export default[
    {
        "name": "笑脸与人物",
        "list": [
            {
                "icon": "😀",
                "name": "露齒而笑的表情 Grinning face",
                "className": "emoji1f600"
            },
            {
                "icon": "😃",
                "name": "張嘴微笑的表情 Smiling face with open mouth",
                "className": "emoji1f603"
            },
            {
                "icon": "😄",
                "name": "張嘴眉開眼笑的表情 Smiling face with open mouth and smiling eyes",
                "className": "emoji1f604"
            },
            {
                "icon": "😁",
                "name": "眉開眼笑的表情 Grinning face with smiling eyes",
                "className": "emoji1f601"
            },
            {
                "icon": "😆",
                "name": "張嘴微笑眼睛緊閉的表情 Smiling face with open mouth and tightly-closed eyes",
                "className": "emoji1f606"
            },
            {
                "icon": "😅",
                "name": "張嘴微笑冒冷汗的表情 Smiling face with open mouth and cold sweat",
                "className": "emoji1f605"
            },
            {
                "icon": "😂",
                "name": "喜極而泣的表情 Face with tears of joy",
                "className": "emoji1f602"
            },
            {
                "icon": "🤣",
                "name": "捧腹大笑 Rolling on the floor laughing",
                "className": "emoji1f923"
            },
            {
                "icon": "☺️",
                "name": "白色笑臉 White smiling face",
                "className": "emoji263a"
            },
            {
                "icon": "😊",
                "name": "眼睛笑眯眯的表情 Smiling face with smiling eyes",
                "className": "emoji1f60a"
            },
            {
                "icon": "😇",
                "name": "有光圈的笑臉 Smiling face with halo",
                "className": "emoji1f607"
            },
            {
                "icon": "🙂",
                "name": "稍微微笑的臉 Slightly smiling face",
                "className": "emoji1f642"
            },
            {
                "icon": "🙃",
                "name": "顛倒的臉 Upside-down face",
                "className": "emoji1f643"
            },
            {
                "icon": "😉",
                "name": "眨眼微笑的表情 Winking face",
                "className": "emoji1f609"
            },
            {
                "icon": "😌",
                "name": "如釋重負的表情 Relieved face",
                "className": "emoji1f60c"
            },
            {
                "icon": "😍",
                "name": "眼睛變成愛心的笑臉 Smiling face with heart-shaped eyes",
                "className": "emoji1f60d"
            },
            {
                "icon": "🥰",
                "name": "有著愛心的微笑表情 Smiling face with 3 hearts",
                "className": "emoji1f970"
            },
            {
                "icon": "😘",
                "name": "飛吻的表情 Face throwing a kiss",
                "className": "emoji1f618"
            },
            {
                "icon": "😗",
                "name": "親吻的表情 Kissing face",
                "className": "emoji1f617"
            },
            {
                "icon": "😙",
                "name": "笑咪咪親吻的表情 Kissing face with smiling eyes",
                "className": "emoji1f619"
            },
            {
                "icon": "😚",
                "name": "眨眼親吻的表情 Kissing face with closed eyes",
                "className": "emoji1f61a"
            },
            {
                "icon": "😋",
                "name": "嚐到美食的表情 Face savouring delicious food",
                "className": "emoji1f60b"
            },
            {
                "icon": "😛",
                "name": "吐舌頭的表情 Face with stuck-out tongue",
                "className": "emoji1f61b"
            },
            {
                "icon": "😝",
                "name": "緊閉眼睛吐舌頭的表情 Face with stuck-out tongue and tightly-closed eyes",
                "className": "emoji1f61d"
            },
            {
                "icon": "😜",
                "name": "眨眼吐舌頭的表情 Face with stuck-out tongue and winking eye",
                "className": "emoji1f61c"
            },
            {
                "icon": "🤪",
                "name": "鬼臉 Zany face",
                "className": "emoji1f92a"
            },
            {
                "icon": "🤨",
                "name": "豎眉的臉 Face with raised eyebrow",
                "className": "emoji1f928"
            },
            {
                "icon": "🧐",
                "name": "戴單片眼鏡的臉 Face with monocle",
                "className": "emoji1f9d0"
            },
            {
                "icon": "🤓",
                "name": "書呆子的臉 Nerd face",
                "className": "emoji1f913"
            },
            {
                "icon": "😎",
                "name": "戴墨鏡微笑的表情 Smiling face with sunglasses",
                "className": "emoji1f60e"
            },
            {
                "icon": "🤩",
                "name": "迷戀明星 Star-struck",
                "className": "emoji1f929"
            },
            {
                "icon": "🥳",
                "name": "開趴的表情 Partying face",
                "className": "emoji1f973"
            },
            {
                "icon": "😏",
                "name": "得意的表情 Smirking face",
                "className": "emoji1f60f"
            },
            {
                "icon": "😒",
                "name": "無精打采的表情 Unamused face",
                "className": "emoji1f612"
            },
            {
                "icon": "😞",
                "name": "失望的表情 Disappointed face",
                "className": "emoji1f61e"
            },
            {
                "icon": "😔",
                "name": "憂慮的表情 Pensive face",
                "className": "emoji1f614"
            },
            {
                "icon": "😟",
                "name": "擔心的表情 Worried face",
                "className": "emoji1f61f"
            },
            {
                "icon": "😕",
                "name": "困惑的表情 Confused face",
                "className": "emoji1f615"
            },
            {
                "icon": "🙁",
                "name": "稍微不悅的臉 Slightly frowning face",
                "className": "emoji1f641"
            },
            {
                "icon": "☹️",
                "name": "不悅的臉 White frowning face",
                "className": "emoji2639"
            },
            {
                "icon": "😣",
                "name": "堅持的表情 Persevering face",
                "className": "emoji1f623"
            },
            {
                "icon": "😖",
                "name": "困惑的表情 Confounded face",
                "className": "emoji1f616"
            },
            {
                "icon": "😫",
                "name": "疲累的表情 Tired face",
                "className": "emoji1f62b"
            },
            {
                "icon": "😩",
                "name": "厭倦的表情 Weary face",
                "className": "emoji1f629"
            },
            {
                "icon": "🥺",
                "name": "請求的表情 Pleading face",
                "className": "emoji1f97a"
            },
            {
                "icon": "😢",
                "name": "哭泣的表情 Crying face",
                "className": "emoji1f622"
            },
            {
                "icon": "😭",
                "name": "嚎啕大哭的表情 Loudly crying face",
                "className": "emoji1f62d"
            },
            {
                "icon": "😤",
                "name": "洋洋得意的表情 Face with look of triumph",
                "className": "emoji1f624"
            },
            {
                "icon": "😠",
                "name": "生氣的表情 Angry face",
                "className": "emoji1f620"
            },
            {
                "icon": "😡",
                "name": "噘嘴的表情 Pouting face",
                "className": "emoji1f621"
            },
            {
                "icon": "🤬",
                "name": "標誌蓋嘴的臉 Face with symbols over mouth",
                "className": "emoji1f92c"
            },
            {
                "icon": "🤯",
                "name": "爆炸的頭 Exploding head",
                "className": "emoji1f92f"
            },
            {
                "icon": "😳",
                "name": "臉紅的表情 Flushed face",
                "className": "emoji1f633"
            },
            {
                "icon": "🥵",
                "name": "炎熱的表情 Hot face",
                "className": "emoji1f975"
            },
            {
                "icon": "🥶",
                "name": "寒冷的表情 Cold face",
                "className": "emoji1f976"
            },
            {
                "icon": "😱",
                "name": "驚恐尖叫的表情 Face screaming in fear",
                "className": "emoji1f631"
            },
            {
                "icon": "😨",
                "name": "害怕的表情 Fearful face",
                "className": "emoji1f628"
            },
            {
                "icon": "😰",
                "name": "張嘴冒冷汗的表情 Face with open mouth and cold sweat",
                "className": "emoji1f630"
            },
            {
                "icon": "😥",
                "name": "失望又鬆了一口氣的表情 Disappointed but relieved face",
                "className": "emoji1f625"
            },
            {
                "icon": "😓",
                "name": "冒冷汗的表情 Face with cold sweat",
                "className": "emoji1f613"
            },
            {
                "icon": "🤗",
                "name": "擁抱的臉 Hugging face",
                "className": "emoji1f917"
            },
            {
                "icon": "🤔",
                "name": "思考的臉 Thinking face",
                "className": "emoji1f914"
            },
            {
                "icon": "🤭",
                "name": "手摀著嘴的臉 Face with hand over mouth",
                "className": "emoji1f92d"
            },
            {
                "icon": "🤫",
                "name": "作勢噤聲的臉 Shushing face",
                "className": "emoji1f92b"
            },
            {
                "icon": "🤥",
                "name": "說謊的臉 Lying face",
                "className": "emoji1f925"
            },
            {
                "icon": "😶",
                "name": "沒有嘴巴的臉 Face without mouth",
                "className": "emoji1f636"
            },
            {
                "icon": "😐",
                "name": "心平氣和的表情 Neutral face",
                "className": "emoji1f610"
            },
            {
                "icon": "😑",
                "name": "面無表情的臉 Expressionless face",
                "className": "emoji1f611"
            },
            {
                "icon": "😬",
                "name": "扭曲的表情 Grimacing face",
                "className": "emoji1f62c"
            },
            {
                "icon": "🙄",
                "name": "轉動眼睛的臉 Face with rolling eyes",
                "className": "emoji1f644"
            },
            {
                "icon": "😯",
                "name": "噤聲的表情 Hushed face",
                "className": "emoji1f62f"
            },
            {
                "icon": "😦",
                "name": "皺眉張嘴的表情 Frowning face with open mouth",
                "className": "emoji1f626"
            },
            {
                "icon": "😧",
                "name": "苦惱的表情 Anguished face",
                "className": "emoji1f627"
            },
            {
                "icon": "😮",
                "name": "張大嘴的表情 Face with open mouth",
                "className": "emoji1f62e"
            },
            {
                "icon": "😲",
                "name": "吃驚的表情 Astonished face",
                "className": "emoji1f632"
            },
            {
                "icon": "🥱",
                "name": "打哈欠的臉 Yawning face",
                "className": "emoji1f971"
            },
            {
                "icon": "😴",
                "name": "想睡的表情 Sleeping face",
                "className": "emoji1f634"
            },
            {
                "icon": "🤤",
                "name": "流口水的臉 Drooling face",
                "className": "emoji1f924"
            },
            {
                "icon": "😪",
                "name": "想睡的表情 Sleepy face",
                "className": "emoji1f62a"
            },
            {
                "icon": "😵",
                "name": "頭暈眼花的表情 Dizzy face",
                "className": "emoji1f635"
            },
            {
                "icon": "🤐",
                "name": "嘴巴拉起拉鍊的臉 Zipper-mouth face",
                "className": "emoji1f910"
            },
            {
                "icon": "🥴",
                "name": "頭昏眼花的表情 Woozy face",
                "className": "emoji1f974"
            },
            {
                "icon": "🤢",
                "name": "作嘔的臉 Nauseated face",
                "className": "emoji1f922"
            },
            {
                "icon": "🤮",
                "name": "嘔吐的臉 Face vomiting",
                "className": "emoji1f92e"
            },
            {
                "icon": "🤧",
                "name": "打噴嚏的臉 Sneezing face",
                "className": "emoji1f927"
            },
            {
                "icon": "😷",
                "name": "戴著醫療口罩的臉 Face with medical mask",
                "className": "emoji1f637"
            },
            {
                "icon": "🤒",
                "name": "含著體溫計的臉 Face with thermometer",
                "className": "emoji1f912"
            },
            {
                "icon": "🤕",
                "name": "頭綁著繃帶的臉 Face with head-bandage",
                "className": "emoji1f915"
            },
            {
                "icon": "🤑",
                "name": "嘴巴含著錢的臉 Money-mouth face",
                "className": "emoji1f911"
            },
            {
                "icon": "🤠",
                "name": "牛仔 Cowboy hat face",
                "className": "emoji1f920"
            },
            {
                "icon": "😈",
                "name": "長角的笑臉 Smiling face with horns",
                "className": "emoji1f608"
            },
            {
                "icon": "👿",
                "name": "小惡魔 Imp",
                "className": "emoji1f47f"
            },
            {
                "icon": "👹",
                "name": "日本妖怪 Japanese ogre",
                "className": "emoji1f479"
            },
            {
                "icon": "👺",
                "name": "日本天狗 Japanese goblin",
                "className": "emoji1f47a"
            },
            {
                "icon": "🤡",
                "name": "小丑的臉 Clown face",
                "className": "emoji1f921"
            },
            {
                "icon": "💩",
                "name": "一坨便便 Pile of poo",
                "className": "emoji1f4a9"
            },
            {
                "icon": "👻",
                "name": "幽靈 Ghost",
                "className": "emoji1f47b"
            },
            {
                "icon": "💀",
                "name": "骷髏 Skull",
                "className": "emoji1f480"
            },
            {
                "icon": "☠️",
                "name": "骷髏頭與二根交叉的骨頭 Skull and crossbones",
                "className": "emoji2620"
            },
            {
                "icon": "👽",
                "name": "外星人 Extraterrestrial alien",
                "className": "emoji1f47d"
            },
            {
                "icon": "👾",
                "name": "外星怪物 Alien monster",
                "className": "emoji1f47e"
            },
            {
                "icon": "🤖",
                "name": "機器人的臉 Robot face",
                "className": "emoji1f916"
            },
            {
                "icon": "🎃",
                "name": "萬聖節南瓜燈籠 Jack-o-lantern",
                "className": "emoji1f383"
            },
            {
                "icon": "😺",
                "name": "貓咪張嘴微笑的表情 Smiling cat face with open mouth",
                "className": "emoji1f63a"
            },
            {
                "icon": "😸",
                "name": "貓咪眉開眼笑的表情 Grinning cat face with smiling eyes",
                "className": "emoji1f638"
            },
            {
                "icon": "😹",
                "name": "貓咪喜極而泣的表情 Cat face with tears of joy",
                "className": "emoji1f639"
            },
            {
                "icon": "😻",
                "name": "貓咪眼睛變成愛心的笑臉 Smiling cat face with heart-shaped eyes",
                "className": "emoji1f63b"
            },
            {
                "icon": "😼",
                "name": "貓咪狡猾微笑的表情 Cat face with wry smile",
                "className": "emoji1f63c"
            },
            {
                "icon": "😽",
                "name": "貓咪眨眼親吻的表情 Kissing cat face with closed eyes",
                "className": "emoji1f63d"
            },
            {
                "icon": "🙀",
                "name": "貓咪厭倦的表情 Weary cat face",
                "className": "emoji1f640"
            },
            {
                "icon": "😿",
                "name": "貓咪哭泣的表情 Crying cat face",
                "className": "emoji1f63f"
            },
            {
                "icon": "😾",
                "name": "貓咪噘嘴的表情 Pouting cat face",
                "className": "emoji1f63e"
            },
            {
                "icon": "🤲",
                "name": "雙手併攏向上 Palms up together",
                "className": "emoji1f932"
            },
            {
                "icon": "👐",
                "name": "張開雙手符號 Open hands sign",
                "className": "emoji1f450"
            },
            {
                "icon": "🙌",
                "name": "舉起雙手慶祝的人 Person raising both hands in celebration",
                "className": "emoji1f64c"
            },
            {
                "icon": "👏",
                "name": "鼓掌符號 Clapping hands sign",
                "className": "emoji1f44f"
            },
            {
                "icon": "🤝",
                "name": "握手 Handshake",
                "className": "emoji1f91d"
            },
            {
                "icon": "👍",
                "name": "拇指朝上符號 Thumbs up sign",
                "className": "emoji1f44d"
            },
            {
                "icon": "👎",
                "name": "拇指朝下符號 Thumbs down sign",
                "className": "emoji1f44e"
            },
            {
                "icon": "👊",
                "name": "握拳符號 Fisted hand sign",
                "className": "emoji1f44a"
            },
            {
                "icon": "✊",
                "name": "舉起的拳頭 Raised fist",
                "className": "emoji270a"
            },
            {
                "icon": "🤛",
                "name": "向左的拳頭 Left-facing fist",
                "className": "emoji1f91b"
            },
            {
                "icon": "🤜",
                "name": "向右的拳頭 Right-facing fist",
                "className": "emoji1f91c"
            },
            {
                "icon": "🤞",
                "name": "雙指交叉的手勢 Crossed fingers",
                "className": "emoji1f91e"
            },
            {
                "icon": "✌️",
                "name": "勝利手勢 Victory hand",
                "className": "emoji270c"
            },
            {
                "icon": "🤟",
                "name": "愛你的手勢 Love-you gesture",
                "className": "emoji1f91f"
            },
            {
                "icon": "🤘",
                "name": "搖滾手勢 Sign of the horns",
                "className": "emoji1f918"
            },
            {
                "icon": "👌",
                "name": "OK 手勢符號 Ok hand sign",
                "className": "emoji1f44c"
            },
            {
                "icon": "🤏",
                "name": "捏合的手 Pinching hand",
                "className": "emoji1f90f"
            },
            {
                "icon": "👈",
                "name": "手背朝前往左指的白色食指 White left pointing backhand index",
                "className": "emoji1f448"
            },
            {
                "icon": "👉",
                "name": "手背朝前往右指的白色食指 White right pointing backhand index",
                "className": "emoji1f449"
            },
            {
                "icon": "👆",
                "name": "手背朝前往上指的白色食指 White up pointing backhand index",
                "className": "emoji1f446"
            },
            {
                "icon": "👇",
                "name": "手背朝前往下指的白色食指 White down pointing backhand index",
                "className": "emoji1f447"
            },
            {
                "icon": "☝️",
                "name": "往上指的白色食指 White up pointing index",
                "className": "emoji261d"
            },
            {
                "icon": "✋",
                "name": "舉起的手 Raised hand",
                "className": "emoji270b"
            },
            {
                "icon": "🤚",
                "name": "舉起手背 Raised back of hand",
                "className": "emoji1f91a"
            },
            {
                "icon": "🖐",
                "name": "手指張開舉手 Raised hand with fingers splayed",
                "className": "emoji1f590"
            },
            {
                "icon": "🖖",
                "name": "中指和無名指分開舉手 Raised hand with part between middle and ring fingers",
                "className": "emoji1f596"
            },
            {
                "icon": "👋",
                "name": "揮手符號 Waving hand sign",
                "className": "emoji1f44b"
            },
            {
                "icon": "🤙",
                "name": "打電話給我手勢 Call me hand",
                "className": "emoji1f919"
            },
            {
                "icon": "💪",
                "name": "股起的二頭肌 Flexed biceps",
                "className": "emoji1f4aa"
            },
            {
                "icon": "🦾",
                "name": "機械手臂 Mechanical arm",
                "className": "emoji1f9be"
            },
            {
                "icon": "🖕",
                "name": "反手中指伸出 Reversed hand with middle finger extended",
                "className": "emoji1f595"
            },
            {
                "icon": "✍️",
                "name": "寫字的手 Writing hand",
                "className": "emoji270d"
            },
            {
                "icon": "🙏",
                "name": "雙手合十的人 Person with folded hands",
                "className": "emoji1f64f"
            },
            {
                "icon": "🦶",
                "name": "腳 Foot",
                "className": "emoji1f9b6"
            },
            {
                "icon": "🦵",
                "name": "腿 Leg",
                "className": "emoji1f9b5"
            },
            {
                "icon": "🦿",
                "name": "機械腿 Mechanical leg",
                "className": "emoji1f9bf"
            },
            {
                "icon": "💄",
                "name": "口紅 Lipstick",
                "className": "emoji1f484"
            },
            {
                "icon": "💋",
                "name": "唇印 Kiss mark",
                "className": "emoji1f48b"
            },
            {
                "icon": "👄",
                "name": "嘴巴 Mouth",
                "className": "emoji1f444"
            },
            {
                "icon": "🦷",
                "name": "牙齒 Tooth",
                "className": "emoji1f9b7"
            },
            {
                "icon": "👅",
                "name": "舌頭 Tongue",
                "className": "emoji1f445"
            },
            {
                "icon": "👂",
                "name": "耳朵 Ear",
                "className": "emoji1f442"
            },
            {
                "icon": "🦻",
                "name": "戴助聽器的耳朵 Ear with hearing aid",
                "className": "emoji1f9bb"
            },
            {
                "icon": "👃",
                "name": "鼻子 Nose",
                "className": "emoji1f443"
            },
            {
                "icon": "👣",
                "name": "腳印 Footprints",
                "className": "emoji1f463"
            },
            {
                "icon": "👁",
                "name": "眼睛 Eye",
                "className": "emoji1f441"
            },
            {
                "icon": "👀",
                "name": "眼睛 Eyes",
                "className": "emoji1f440"
            },
            {
                "icon": "🧠",
                "name": "大腦 Brain",
                "className": "emoji1f9e0"
            },
            {
                "icon": "🗣",
                "name": "說話的黑色剪影頭像 Speaking head in silhouette",
                "className": "emoji1f5e3"
            },
            {
                "icon": "👤",
                "name": "半身像輪廓 Bust in silhouette",
                "className": "emoji1f464"
            },
            {
                "icon": "👥",
                "name": "多個半身像輪廓 Busts in silhouette",
                "className": "emoji1f465"
            },
            {
                "icon": "👶",
                "name": "嬰兒 Baby",
                "className": "emoji1f476"
            },
            {
                "icon": "👧",
                "name": "女孩 Girl",
                "className": "emoji1f467"
            },
            {
                "icon": "🧒",
                "name": "小孩 Child",
                "className": "emoji1f9d2"
            },
            {
                "icon": "👦",
                "name": "男孩 Boy",
                "className": "emoji1f466"
            },
            {
                "icon": "👩",
                "name": "女人 Woman",
                "className": "emoji1f469"
            },
            {
                "icon": "🧑",
                "name": "成人內容 Adult",
                "className": "emoji1f9d1"
            },
            {
                "icon": "👨",
                "name": "男人 Man",
                "className": "emoji1f468"
            },
            {
                "icon": "👩‍🦱",
                "name": "捲髮女性 Woman, curly haired",
                "className": "emoji1f469-200d-1f9b1"
            },
            {
                "icon": "🧑‍🦱",
                "name": "捲髮的人 Person, curly haired",
                "className": "emoji1f9d1-200d-1f9b1"
            },
            {
                "icon": "👨‍🦱",
                "name": "捲髮男性 Man, curly haired",
                "className": "emoji1f468-200d-1f9b1"
            },
            {
                "icon": "👩‍🦰",
                "name": "紅髮女性 Woman, red haired",
                "className": "emoji1f469-200d-1f9b0"
            },
            {
                "icon": "🧑‍🦰",
                "name": "紅髮的人 Person, red haired",
                "className": "emoji1f9d1-200d-1f9b0"
            },
            {
                "icon": "👨‍🦰",
                "name": "紅髮男性 Man, red haired",
                "className": "emoji1f468-200d-1f9b0"
            },
            {
                "icon": "👱‍♀️",
                "name": "金髮女性 Woman, blond haired",
                "className": "emoji1f471-200d-2640"
            },
            {
                "icon": "👱",
                "name": "金髮的人 Person with blond hair",
                "className": "emoji1f471"
            },
            {
                "icon": "👱‍♂️",
                "name": "金髮男人 Man, blond haired",
                "className": "emoji1f471-200d-2642"
            },
            {
                "icon": "👩‍🦳",
                "name": "灰髮男性 Woman, white haired",
                "className": "emoji1f469-200d-1f9b3"
            },
            {
                "icon": "👨‍🦳",
                "name": "白髮男性 Man, white haired",
                "className": "emoji1f468-200d-1f9b3"
            },
            {
                "icon": "👩‍🦲",
                "name": "禿頭女性 Woman, bald",
                "className": "emoji1f469-200d-1f9b2"
            },
            {
                "icon": "👨‍🦲",
                "name": "禿頭男性 Man, bald",
                "className": "emoji1f468-200d-1f9b2"
            },
            {
                "icon": "🧔",
                "name": "留鬍子的人 Bearded person",
                "className": "emoji1f9d4"
            },
            {
                "icon": "👵",
                "name": "女性長者 Older woman",
                "className": "emoji1f475"
            },
            {
                "icon": "🧓",
                "name": "年長的成人 Older adult",
                "className": "emoji1f9d3"
            },
            {
                "icon": "👴",
                "name": "男性長者 Older man",
                "className": "emoji1f474"
            },
            {
                "icon": "👲",
                "name": "戴瓜皮帽的男人 Man with gua pi mao",
                "className": "emoji1f472"
            },
            {
                "icon": "👳‍♀️",
                "name": "綁頭巾的女性 Woman wearing turban",
                "className": "emoji1f473-200d-2640"
            },
            {
                "icon": "👳",
                "name": "戴頭巾的男人 Man with turban",
                "className": "emoji1f473"
            },
            {
                "icon": "👳‍♂️",
                "name": "綁頭巾的男性 Man wearing turban",
                "className": "emoji1f473-200d-2642"
            },
            {
                "icon": "🧕",
                "name": "戴頭巾的女人 Woman with headscarf",
                "className": "emoji1f9d5"
            },
            {
                "icon": "🤰",
                "name": "懷孕的女人 Pregnant woman",
                "className": "emoji1f930"
            },
            {
                "icon": "🤱",
                "name": "哺乳 Breastfeeding",
                "className": "emoji1f931"
            },
            {
                "icon": "🙇‍♀️",
                "name": "深度鞠躬的女人 Woman bowing deeply",
                "className": "emoji1f647-200d-2640"
            },
            {
                "icon": "🙇",
                "name": "深深鞠躬的人 Person bowing deeply",
                "className": "emoji1f647"
            },
            {
                "icon": "🙇‍♂️",
                "name": "深度鞠躬的男人 Man bowing deeply",
                "className": "emoji1f647-200d-2642"
            },
            {
                "icon": "💁‍♀️",
                "name": "輕觸手的女人 Woman tipping hand",
                "className": "emoji1f481-200d-2640"
            },
            {
                "icon": "💁",
                "name": "服務台人員 Information desk person",
                "className": "emoji1f481"
            },
            {
                "icon": "💁‍♂️",
                "name": "輕觸手的男人 Man tipping hand",
                "className": "emoji1f481-200d-2642"
            },
            {
                "icon": "🙅‍♀️",
                "name": "示意有問題的女人 Woman gesturing not ok",
                "className": "emoji1f645-200d-2640"
            },
            {
                "icon": "🙅",
                "name": "比出拒絕手勢的人 Face with no good gesture",
                "className": "emoji1f645"
            },
            {
                "icon": "🙅‍♂️",
                "name": "示意有問題的男人 Man gesturing not ok",
                "className": "emoji1f645-200d-2642"
            },
            {
                "icon": "🙆‍♀️",
                "name": "示意沒問題的女人 Woman gesturing ok",
                "className": "emoji1f646-200d-2640"
            },
            {
                "icon": "🙆",
                "name": "比出 OK 手勢的人 Face with ok gesture",
                "className": "emoji1f646"
            },
            {
                "icon": "🙆‍♂️",
                "name": "示意沒問題的男人 Man gesturing ok",
                "className": "emoji1f646-200d-2642"
            },
            {
                "icon": "🙋‍♀️",
                "name": "開心舉起一隻手的女人 Happy woman raising one hand",
                "className": "emoji1f64b-200d-2640"
            },
            {
                "icon": "🙋",
                "name": "開心地舉起一隻手的人 Happy person raising one hand",
                "className": "emoji1f64b"
            },
            {
                "icon": "🙋‍♂️",
                "name": "開心舉起一隻手的男人 Happy man raising one hand",
                "className": "emoji1f64b-200d-2642"
            },
            {
                "icon": "🧏‍♀️",
                "name": "耳聾的女人 Deaf woman",
                "className": "emoji1f9cf-200d-2640"
            },
            {
                "icon": "🧏",
                "name": "聾人 Deaf person",
                "className": "emoji1f9cf"
            },
            {
                "icon": "🧏‍♂️",
                "name": "耳聾的男人 Deaf man",
                "className": "emoji1f9cf-200d-2642"
            },
            {
                "icon": "🤦‍♀️",
                "name": "掩面的女人 Woman facepalming",
                "className": "emoji1f926-200d-2640"
            },
            {
                "icon": "🤦",
                "name": "捂著臉的人 Person facepalming",
                "className": "emoji1f926"
            },
            {
                "icon": "🤦‍♂️",
                "name": "掩面的男人 Man facepalming",
                "className": "emoji1f926-200d-2642"
            },
            {
                "icon": "🤷‍♀️",
                "name": "聳肩的女人 Woman shrugging",
                "className": "emoji1f937-200d-2640"
            },
            {
                "icon": "🤷",
                "name": "聳肩的人 Person shrugging",
                "className": "emoji1f937"
            },
            {
                "icon": "🤷‍♂️",
                "name": "聳肩的男人 Man shrugging",
                "className": "emoji1f937-200d-2642"
            },
            {
                "icon": "🙎‍♀️",
                "name": "撅嘴的女人 Woman pouting",
                "className": "emoji1f64e-200d-2640"
            },
            {
                "icon": "🙎",
                "name": "噘嘴的人 Person with pouting face",
                "className": "emoji1f64e"
            },
            {
                "icon": "🙎‍♂️",
                "name": "撅嘴的男人 Man pouting",
                "className": "emoji1f64e-200d-2642"
            },
            {
                "icon": "🙍‍♀️",
                "name": "皺眉的女人 Woman frowning",
                "className": "emoji1f64d-200d-2640"
            },
            {
                "icon": "🙍🏽",
                "className": "emoji1f64d-1f3fd"
            },
            {
                "icon": "🙍‍♂️",
                "name": "皺眉的男人 Man frowning",
                "className": "emoji1f64d-200d-2642"
            },
            {
                "icon": "👩‍❤️‍👨",
                "name": "情侶與愛心 (女人、男人) Couple with heart (woman, man)",
                "className": "emoji1f469-200d-2764-200d-1f468"
            },
            {
                "icon": "👩‍❤️‍👩",
                "name": "情侶與愛心 (女人、女人) Couple with heart (woman, woman)",
                "className": "emoji1f469-200d-2764-200d-1f469"
            },
            {
                "icon": "👨‍❤️‍👨",
                "name": "情侶與愛心 (男人、男人) Couple with heart (man, man)",
                "className": "emoji1f468-200d-2764-200d-1f468"
            },
            {
                "icon": "👩‍❤️‍💋‍👨",
                "name": "接吻 (女人、男人) Kiss (woman, man)",
                "className": "emoji1f469-200d-2764-200d-1f48b-200d-1f468"
            },
            {
                "icon": "👩‍❤️‍💋‍👩",
                "name": "接吻 (女人、女人) Kiss (woman, woman)",
                "className": "emoji1f469-200d-2764-200d-1f48b-200d-1f469"
            },
            {
                "icon": "👨‍❤️‍💋‍👨",
                "name": "接吻 (男人、男人) Kiss (man, man)",
                "className": "emoji1f468-200d-2764-200d-1f48b-200d-1f468"
            },
            {
                "icon": "❤️",
                "name": "加粗的黑色愛心 Heavy black heart",
                "className": "emoji2764"
            },
            {
                "icon": "🧡",
                "name": "橙色愛心 Orange heart",
                "className": "emoji1f9e1"
            },
            {
                "icon": "💛",
                "name": "黃色愛心 Yellow heart",
                "className": "emoji1f49b"
            },
            {
                "icon": "💚",
                "name": "綠色愛心 Green heart",
                "className": "emoji1f49a"
            },
            {
                "icon": "💙",
                "name": "藍色愛心 Blue heart",
                "className": "emoji1f499"
            },
            {
                "icon": "💜",
                "name": "紫色愛心 Purple heart",
                "className": "emoji1f49c"
            },
            {
                "icon": "🖤",
                "name": "黑心 Black heart",
                "className": "emoji1f5a4"
            },
            {
                "icon": "🤍",
                "name": "白色愛心 White heart",
                "className": "emoji1f90d"
            },
            {
                "icon": "🤎",
                "name": "棕色愛心 Brown heart",
                "className": "emoji1f90e"
            },
            {
                "icon": "💔",
                "name": "碎裂的心 Broken heart",
                "className": "emoji1f494"
            },
            {
                "icon": "❣️",
                "name": "愛心驚嘆號 Heavy heart exclamation mark ornament",
                "className": "emoji2763"
            },
            {
                "icon": "💕",
                "name": "兩顆愛心 Two hearts",
                "className": "emoji1f495"
            },
            {
                "icon": "💞",
                "name": "旋轉的愛心 Revolving hearts",
                "className": "emoji1f49e"
            },
            {
                "icon": "💓",
                "name": "跳動的心 Beating heart",
                "className": "emoji1f493"
            },
            {
                "icon": "💗",
                "name": "變大的愛心 Growing heart",
                "className": "emoji1f497"
            },
            {
                "icon": "💖",
                "name": "閃閃發光的愛心 Sparkling heart",
                "className": "emoji1f496"
            },
            {
                "icon": "💘",
                "name": "一箭穿心 Heart with arrow",
                "className": "emoji1f498"
            },
            {
                "icon": "💝",
                "name": "綁上緞帶的愛心 Heart with ribbon",
                "className": "emoji1f49d"
            },
            {
                "icon": "💟",
                "name": "心形裝飾 Heart decoration",
                "className": "emoji1f49f"
            }
        ]
    },
    {
        "name": "动物与大自然",
        "list": [
            {
                "icon": "🐶",
                "name": "狗臉 Dog face",
                "className": "emoji1f436"
            },
            {
                "icon": "🐱",
                "name": "貓臉 Cat face",
                "className": "emoji1f431"
            },
            {
                "icon": "🐭",
                "name": "老鼠臉 Mouse face",
                "className": "emoji1f42d"
            },
            {
                "icon": "🐹",
                "name": "倉鼠臉 Hamster face",
                "className": "emoji1f439"
            },
            {
                "icon": "🐰",
                "name": "兔子臉 Rabbit face",
                "className": "emoji1f430"
            },
            {
                "icon": "🦊",
                "name": "狐狸的臉 Fox face",
                "className": "emoji1f98a"
            },
            {
                "icon": "🐻",
                "name": "熊臉 Bear face",
                "className": "emoji1f43b"
            },
            {
                "icon": "🐼",
                "name": "貓熊臉 Panda face",
                "className": "emoji1f43c"
            },
            {
                "icon": "🐨",
                "name": "無尾熊 Koala",
                "className": "emoji1f428"
            },
            {
                "icon": "🐯",
                "name": "老虎臉 Tiger face",
                "className": "emoji1f42f"
            },
            {
                "icon": "🦁",
                "name": "獅子的臉 Lion face",
                "className": "emoji1f981"
            },
            {
                "icon": "🐮",
                "name": "母牛臉 Cow face",
                "className": "emoji1f42e"
            },
            {
                "icon": "🐷",
                "name": "豬臉 Pig face",
                "className": "emoji1f437"
            },
            {
                "icon": "🐽",
                "name": "豬鼻子 Pig nose",
                "className": "emoji1f43d"
            },
            {
                "icon": "🐸",
                "name": "青蛙臉 Frog face",
                "className": "emoji1f438"
            },
            {
                "icon": "🐵",
                "name": "猴子臉 Monkey face",
                "className": "emoji1f435"
            },
            {
                "icon": "🙈",
                "name": "代表非禮勿視的猴子 See-no-evil monkey",
                "className": "emoji1f648"
            },
            {
                "icon": "🙉",
                "name": "代表非禮勿聽的猴子 Hear-no-evil monkey",
                "className": "emoji1f649"
            },
            {
                "icon": "🙊",
                "name": "代表非禮勿言的猴子 Speak-no-evil monkey",
                "className": "emoji1f64a"
            },
            {
                "icon": "🐒",
                "name": "猴子 Monkey",
                "className": "emoji1f412"
            },
            {
                "icon": "🐔",
                "name": "雞 Chicken",
                "className": "emoji1f414"
            },
            {
                "icon": "🐧",
                "name": "企鵝 Penguin",
                "className": "emoji1f427"
            },
            {
                "icon": "🐦",
                "name": "鳥 Bird",
                "className": "emoji1f426"
            },
            {
                "icon": "🐤",
                "name": "小雞 Baby chick",
                "className": "emoji1f424"
            },
            {
                "icon": "🐣",
                "name": "剛孵化的小雞 Hatching chick",
                "className": "emoji1f423"
            },
            {
                "icon": "🐥",
                "name": "面向前方的小雞 Front-facing baby chick",
                "className": "emoji1f425"
            },
            {
                "icon": "🦆",
                "name": "鴨子 Duck",
                "className": "emoji1f986"
            },
            {
                "icon": "🦅",
                "name": "老鷹 Eagle",
                "className": "emoji1f985"
            },
            {
                "icon": "🦉",
                "name": "貓頭鷹 Owl",
                "className": "emoji1f989"
            },
            {
                "icon": "🦇",
                "name": "蝙蝠 Bat",
                "className": "emoji1f987"
            },
            {
                "icon": "🐺",
                "name": "狼臉 Wolf face",
                "className": "emoji1f43a"
            },
            {
                "icon": "🐗",
                "name": "野豬 Boar",
                "className": "emoji1f417"
            },
            {
                "icon": "🐴",
                "name": "馬臉 Horse face",
                "className": "emoji1f434"
            },
            {
                "icon": "🦄",
                "name": "獨角獸的臉 Unicorn face",
                "className": "emoji1f984"
            },
            {
                "icon": "🐝",
                "name": "蜜蜂 Honeybee",
                "className": "emoji1f41d"
            },
            {
                "icon": "🐛",
                "name": "蟲子 Bug",
                "className": "emoji1f41b"
            },
            {
                "icon": "🦋",
                "name": "蝴蝶 Butterfly",
                "className": "emoji1f98b"
            },
            {
                "icon": "🐌",
                "name": "蝸牛 Snail",
                "className": "emoji1f40c"
            },
            {
                "icon": "🐞",
                "name": "瓢蟲 Lady beetle",
                "className": "emoji1f41e"
            },
            {
                "icon": "🐜",
                "name": "螞蟻 Ant",
                "className": "emoji1f41c"
            },
            {
                "icon": "🦟",
                "name": "蚊子 Mosquito",
                "className": "emoji1f99f"
            },
            {
                "icon": "🦗",
                "name": "板球 Cricket",
                "className": "emoji1f997"
            },
            {
                "icon": "🕷",
                "name": "蜘蛛 Spider",
                "className": "emoji1f577"
            },
            {
                "icon": "🕸",
                "name": "蜘蛛網 Spider web",
                "className": "emoji1f578"
            },
            {
                "icon": "🦂",
                "name": "蠍子 Scorpion",
                "className": "emoji1f982"
            },
            {
                "icon": "🐢",
                "name": "烏龜 Turtle",
                "className": "emoji1f422"
            },
            {
                "icon": "🐍",
                "name": "蛇 Snake",
                "className": "emoji1f40d"
            },
            {
                "icon": "🦎",
                "name": "蜥蜴 Lizard",
                "className": "emoji1f98e"
            },
            {
                "icon": "🦖",
                "name": "暴龍 T-Rex",
                "className": "emoji1f996"
            },
            {
                "icon": "🦕",
                "name": "雷龍 Sauropod",
                "className": "emoji1f995"
            },
            {
                "icon": "🐙",
                "name": "章魚 Octopus",
                "className": "emoji1f419"
            },
            {
                "icon": "🦑",
                "name": "烏賊 Squid",
                "className": "emoji1f991"
            },
            {
                "icon": "🦐",
                "name": "蝦 Shrimp",
                "className": "emoji1f990"
            },
            {
                "icon": "🦞",
                "name": "龍蝦 Lobster",
                "className": "emoji1f99e"
            },
            {
                "icon": "🦀",
                "name": "螃蟹 Crab",
                "className": "emoji1f980"
            },
            {
                "icon": "🐡",
                "name": "河豚 Blowfish",
                "className": "emoji1f421"
            },
            {
                "icon": "🐠",
                "name": "熱帶魚 Tropical fish",
                "className": "emoji1f420"
            },
            {
                "icon": "🐟",
                "name": "魚 Fish",
                "className": "emoji1f41f"
            },
            {
                "icon": "🐬",
                "name": "海豚 Dolphin",
                "className": "emoji1f42c"
            },
            {
                "icon": "🐳",
                "name": "噴水的鯨魚 Spouting whale",
                "className": "emoji1f433"
            },
            {
                "icon": "🐋",
                "name": "鯨魚 Whale",
                "className": "emoji1f40b"
            },
            {
                "icon": "🦈",
                "name": "鯊魚 Shark",
                "className": "emoji1f988"
            },
            {
                "icon": "🐊",
                "name": "鱷魚 Crocodile",
                "className": "emoji1f40a"
            },
            {
                "icon": "🐅",
                "name": "老虎 Tiger",
                "className": "emoji1f405"
            },
            {
                "icon": "🐆",
                "name": "豹 Leopard",
                "className": "emoji1f406"
            },
            {
                "icon": "🦓",
                "name": "斑馬 Zebra",
                "className": "emoji1f993"
            },
            {
                "icon": "🦍",
                "name": "大猩猩 Gorilla",
                "className": "emoji1f98d"
            },
            {
                "icon": "🦧",
                "name": "猩猩 Orangutan",
                "className": "emoji1f9a7"
            },
            {
                "icon": "🐘",
                "name": "大象 Elephant",
                "className": "emoji1f418"
            },
            {
                "icon": "🦛",
                "name": "河馬 Hippopotamus",
                "className": "emoji1f99b"
            },
            {
                "icon": "🦏",
                "name": "犀牛 Rhinoceros",
                "className": "emoji1f98f"
            },
            {
                "icon": "🐪",
                "name": "單峰駱駝 Dromedary camel",
                "className": "emoji1f42a"
            },
            {
                "icon": "🐫",
                "name": "雙峰駱駝 Bactrian camel",
                "className": "emoji1f42b"
            },
            {
                "icon": "🦒",
                "name": "長頸鹿 Giraffe",
                "className": "emoji1f992"
            },
            {
                "icon": "🦘",
                "name": "袋鼠 Kangaroo",
                "className": "emoji1f998"
            },
            {
                "icon": "🐃",
                "name": "水牛 Water buffalo",
                "className": "emoji1f403"
            },
            {
                "icon": "🐂",
                "name": "牛 Ox",
                "className": "emoji1f402"
            },
            {
                "icon": "🐄",
                "name": "母牛 Cow",
                "className": "emoji1f404"
            },
            {
                "icon": "🐎",
                "name": "馬 Horse",
                "className": "emoji1f40e"
            },
            {
                "icon": "🐖",
                "name": "豬 Pig",
                "className": "emoji1f416"
            },
            {
                "icon": "🐏",
                "name": "公羊 Ram",
                "className": "emoji1f40f"
            },
            {
                "icon": "🐑",
                "name": "綿羊 Sheep",
                "className": "emoji1f411"
            },
            {
                "icon": "🦙",
                "name": "羊駝 Llama",
                "className": "emoji1f999"
            },
            {
                "icon": "🐐",
                "name": "山羊 Goat",
                "className": "emoji1f410"
            },
            {
                "icon": "🦌",
                "name": "鹿 Deer",
                "className": "emoji1f98c"
            },
            {
                "icon": "🐕",
                "name": "狗 Dog",
                "className": "emoji1f415"
            },
            {
                "icon": "🐩",
                "name": "貴賓狗 Poodle",
                "className": "emoji1f429"
            },
            {
                "icon": "🦮",
                "name": "導盲犬 Guide dog",
                "className": "emoji1f9ae"
            },
            {
                "icon": "🐕‍🦺",
                "name": "服務犬 Service dog",
                "className": "emoji1f415-200d-1f9ba"
            },
            {
                "icon": "🐈",
                "name": "貓 Cat",
                "className": "emoji1f408"
            },
            {
                "icon": "🐓",
                "name": "公雞 Rooster",
                "className": "emoji1f413"
            },
            {
                "icon": "🦃",
                "name": "火雞 (鳥) Turkey",
                "className": "emoji1f983"
            },
            {
                "icon": "🦚",
                "name": "孔雀 Peacock",
                "className": "emoji1f99a"
            },
            {
                "icon": "🦜",
                "name": "鸚鵡 Parrot",
                "className": "emoji1f99c"
            },
            {
                "icon": "🦢",
                "name": "天鵝 Swan",
                "className": "emoji1f9a2"
            },
            {
                "icon": "🦩",
                "name": "紅鶴 Flamingo",
                "className": "emoji1f9a9"
            },
            {
                "icon": "🕊",
                "name": "和平鴿 Dove of peace",
                "className": "emoji1f54a"
            },
            {
                "icon": "🐇",
                "name": "兔子 Rabbit",
                "className": "emoji1f407"
            },
            {
                "icon": "🦝",
                "name": "浣熊 Raccoon",
                "className": "emoji1f99d"
            },
            {
                "icon": "🦨",
                "name": "臭鼬 Skunk",
                "className": "emoji1f9a8"
            },
            {
                "icon": "🦡",
                "name": "獾 Badger",
                "className": "emoji1f9a1"
            },
            {
                "icon": "🦦",
                "name": "水獺 Otter",
                "className": "emoji1f9a6"
            },
            {
                "icon": "🦥",
                "name": "樹懶 Sloth",
                "className": "emoji1f9a5"
            },
            {
                "icon": "🐁",
                "name": "老鼠 Mouse",
                "className": "emoji1f401"
            },
            {
                "icon": "🐀",
                "name": "大型家鼠 Rat",
                "className": "emoji1f400"
            },
            {
                "icon": "🐿",
                "name": "花栗鼠 Chipmunk",
                "className": "emoji1f43f"
            },
            {
                "icon": "🦔",
                "name": "刺蝟 Hedgehog",
                "className": "emoji1f994"
            },
            {
                "icon": "🐾",
                "name": "腳掌印 Paw prints",
                "className": "emoji1f43e"
            },
            {
                "icon": "🐉",
                "name": "龍 Dragon",
                "className": "emoji1f409"
            },
            {
                "icon": "🐲",
                "name": "龍臉 Dragon face",
                "className": "emoji1f432"
            },
            {
                "icon": "🌵",
                "name": "仙人掌 Cactus",
                "className": "emoji1f335"
            },
            {
                "icon": "🎄",
                "name": "聖誕樹 Christmas tree",
                "className": "emoji1f384"
            },
            {
                "icon": "🌲",
                "name": "常綠植物 Evergreen tree",
                "className": "emoji1f332"
            },
            {
                "icon": "🌳",
                "name": "落葉植物 Deciduous tree",
                "className": "emoji1f333"
            },
            {
                "icon": "🌴",
                "name": "棕櫚樹 Palm tree",
                "className": "emoji1f334"
            },
            {
                "icon": "🌱",
                "name": "樹苗 Seedling",
                "className": "emoji1f331"
            },
            {
                "icon": "🌿",
                "name": "香草 Herb",
                "className": "emoji1f33f"
            },
            {
                "icon": "☘",
                "name": "酢漿草 Shamrock",
                "className": "emoji2618"
            },
            {
                "icon": "🍀",
                "name": "四葉酢醬草 Four leaf clover",
                "className": "emoji1f340"
            },
            {
                "icon": "🎍",
                "name": "門松 Pine decoration",
                "className": "emoji1f38d"
            },
            {
                "icon": "🎋",
                "name": "七夕許願樹 Tanabata tree",
                "className": "emoji1f38b"
            },
            {
                "icon": "🍃",
                "name": "風中落葉 Leaf fluttering in wind",
                "className": "emoji1f343"
            },
            {
                "icon": "🍂",
                "name": "落葉 Fallen leaf",
                "className": "emoji1f342"
            },
            {
                "icon": "🍁",
                "name": "楓葉 Maple leaf",
                "className": "emoji1f341"
            },
            {
                "icon": "🍄",
                "name": "蘑菇 Mushroom",
                "className": "emoji1f344"
            },
            {
                "icon": "🐚",
                "name": "螺 Spiral shell",
                "className": "emoji1f41a"
            },
            {
                "icon": "🌾",
                "name": "稻米 Ear of rice",
                "className": "emoji1f33e"
            },
            {
                "icon": "💐",
                "name": "花束 Bouquet",
                "className": "emoji1f490"
            },
            {
                "icon": "🌷",
                "name": "鬱金香 Tulip",
                "className": "emoji1f337"
            },
            {
                "icon": "🌹",
                "name": "玫瑰 Rose",
                "className": "emoji1f339"
            },
            {
                "icon": "🥀",
                "name": "枯萎的花 Wilted flower",
                "className": "emoji1f940"
            },
            {
                "icon": "🌺",
                "name": "扶桑花 Hibiscus",
                "className": "emoji1f33a"
            },
            {
                "icon": "🌸",
                "name": "櫻花 Cherry blossom",
                "className": "emoji1f338"
            },
            {
                "icon": "🌼",
                "name": "花朵 Blossom",
                "className": "emoji1f33c"
            },
            {
                "icon": "🌻",
                "name": "向日葵 Sunflower",
                "className": "emoji1f33b"
            },
            {
                "icon": "🌞",
                "name": "有臉的太陽 Sun with face",
                "className": "emoji1f31e"
            },
            {
                "icon": "🌝",
                "name": "有臉的滿月 Full moon with face",
                "className": "emoji1f31d"
            },
            {
                "icon": "🌛",
                "name": "有臉的上弦月 First quarter moon with face",
                "className": "emoji1f31b"
            },
            {
                "icon": "🌜",
                "name": "有臉的下弦月 Last quarter moon with face",
                "className": "emoji1f31c"
            },
            {
                "icon": "🌚",
                "name": "有臉的新月 New moon with face",
                "className": "emoji1f31a"
            },
            {
                "icon": "🌕",
                "name": "滿月符號 Full moon symbol",
                "className": "emoji1f315"
            },
            {
                "icon": "🌖",
                "name": "虧凸月符號 Waning gibbous moon symbol",
                "className": "emoji1f316"
            },
            {
                "icon": "🌗",
                "name": "下弦月符號 Last quarter moon symbol",
                "className": "emoji1f317"
            },
            {
                "icon": "🌘",
                "name": "殘月符號 Waning crescent moon symbol",
                "className": "emoji1f318"
            },
            {
                "icon": "🌑",
                "name": "新月符號 New moon symbol",
                "className": "emoji1f311"
            },
            {
                "icon": "🌒",
                "name": "娥眉月符號 Waxing crescent moon symbol",
                "className": "emoji1f312"
            },
            {
                "icon": "🌓",
                "name": "上弦月符號 First quarter moon symbol",
                "className": "emoji1f313"
            },
            {
                "icon": "🌔",
                "name": "盈凸月符號 Waxing gibbous moon symbol",
                "className": "emoji1f314"
            },
            {
                "icon": "🌙",
                "name": "月牙 Crescent moon",
                "className": "emoji1f319"
            },
            {
                "icon": "🌎",
                "name": "地球 (美洲) Earth globe americas",
                "className": "emoji1f30e"
            },
            {
                "icon": "🌍",
                "name": "地球 (歐洲到非洲) Earth globe europe-africa",
                "className": "emoji1f30d"
            },
            {
                "icon": "🌏",
                "name": "地球 (亞洲到澳洲) Earth globe asia-australia",
                "className": "emoji1f30f"
            },
            {
                "icon": "🪐",
                "name": "有環的行星 Ringed planet",
                "className": "emoji1fa90"
            },
            {
                "icon": "💫",
                "name": "暈眩符號 Dizzy symbol",
                "className": "emoji1f4ab"
            },
            {
                "icon": "⭐",
                "name": "中型白色星星 White medium star",
                "className": "emoji2b50"
            },
            {
                "icon": "🌟",
                "name": "發光的星星 Glowing star",
                "className": "emoji1f31f"
            },
            {
                "icon": "✨",
                "name": "閃光 Sparkles",
                "className": "emoji2728"
            },
            {
                "icon": "⚡",
                "name": "高壓電標誌 High voltage sign",
                "className": "emoji26a1"
            },
            {
                "icon": "☄",
                "name": "彗星 Comet",
                "className": "emoji2604"
            },
            {
                "icon": "💥",
                "name": "碰撞符號 Collision symbol",
                "className": "emoji1f4a5"
            },
            {
                "icon": "🔥",
                "name": "火 Fire",
                "className": "emoji1f525"
            },
            {
                "icon": "🌪",
                "name": "刮龍捲風的雲 Cloud with tornado",
                "className": "emoji1f32a"
            },
            {
                "icon": "🌈",
                "name": "彩虹 Rainbow",
                "className": "emoji1f308"
            },
            {
                "icon": "☀",
                "name": "黑色的太陽和光線 Black sun with rays",
                "className": "emoji2600"
            },
            {
                "icon": "🌤",
                "name": "太陽與小雲 White sun with small cloud",
                "className": "emoji1f324"
            },
            {
                "icon": "⛅",
                "name": "雲後的太陽 Sun behind cloud",
                "className": "emoji26c5"
            },
            {
                "icon": "🌥",
                "name": "雲朵遮住太陽 White sun behind cloud",
                "className": "emoji1f325"
            },
            {
                "icon": "☁",
                "name": "雲朵 Cloud",
                "className": "emoji2601"
            },
            {
                "icon": "🌦",
                "name": "被下雨的雲遮蔽的太陽 White sun behind cloud with rain",
                "className": "emoji1f326"
            },
            {
                "icon": "🌧",
                "name": "下雨的雲 Cloud with rain",
                "className": "emoji1f327"
            },
            {
                "icon": "⛈",
                "name": "打雷的雲和雨 Thunder cloud and rain",
                "className": "emoji26c8"
            },
            {
                "icon": "🌩",
                "name": "打雷的雲 Cloud with lightning",
                "className": "emoji1f329"
            },
            {
                "icon": "🌨",
                "name": "下雪的雲 Cloud with snow",
                "className": "emoji1f328"
            },
            {
                "icon": "❄",
                "name": "雪花 Snowflake",
                "className": "emoji2744"
            },
            {
                "icon": "☃",
                "name": "雪人 Snowman",
                "className": "emoji2603"
            },
            {
                "icon": "⛄",
                "name": "四周沒有下雪的雪人 Snowman without snow",
                "className": "emoji26c4"
            },
            {
                "icon": "🌬",
                "name": "吹風的臉 Wind blowing face",
                "className": "emoji1f32c"
            },
            {
                "icon": "💨",
                "name": "衝刺符號 Dash symbol",
                "className": "emoji1f4a8"
            },
            {
                "icon": "💧",
                "name": "水滴 Droplet",
                "className": "emoji1f4a7"
            },
            {
                "icon": "💦",
                "name": "噴汗符號 Splashing sweat symbol",
                "className": "emoji1f4a6"
            },
            {
                "icon": "☔",
                "name": "雨傘和雨滴 Umbrella with rain drops",
                "className": "emoji2614"
            },
            {
                "icon": "☂",
                "name": "傘 Umbrella",
                "className": "emoji2602"
            },
            {
                "icon": "🌊",
                "name": "水波 Water wave",
                "className": "emoji1f30a"
            },
            {
                "icon": "🌫",
                "name": "霧 Fog",
                "className": "emoji1f32b"
            }
        ]
    },
    {
        "name":"美食與飲料",
        "list":[
            {
                "icon": "🍏",
                "name": "綠蘋果 Green apple",
                "className": "emoji1f34f"
            },
            {
                "icon": "🍎",
                "name": "紅蘋果 Red apple",
                "className": "emoji1f34e"
            },
            {
                "icon": "🍐",
                "name": "梨子 Pear",
                "className": "emoji1f350"
            },
            {
                "icon": "🍊",
                "name": "柑橘 Tangerine",
                "className": "emoji1f34a"
            },
            {
                "icon": "🍋",
                "name": "檸檬 Lemon",
                "className": "emoji1f34b"
            },
            {
                "icon": "🍌",
                "name": "香蕉 Banana",
                "className": "emoji1f34c"
            },
            {
                "icon": "🍉",
                "name": "西瓜 Watermelon",
                "className": "emoji1f349"
            },
            {
                "icon": "🍇",
                "name": "葡萄 Grapes",
                "className": "emoji1f347"
            },
            {
                "icon": "🍓",
                "name": "草莓 Strawberry",
                "className": "emoji1f353"
            },
            {
                "icon": "🍈",
                "name": "香瓜 Melon",
                "className": "emoji1f348"
            },
            {
                "icon": "🍒",
                "name": "櫻桃 Cherries",
                "className": "emoji1f352"
            },
            {
                "icon": "🍑",
                "name": "桃子 Peach",
                "className": "emoji1f351"
            },
            {
                "icon": "🥭",
                "name": "芒果 Mango",
                "className": "emoji1f96d"
            },
            {
                "icon": "🍍",
                "name": "鳳梨 Pineapple",
                "className": "emoji1f34d"
            },
            {
                "icon": "🥥",
                "name": "椰子 Coconut",
                "className": "emoji1f965"
            },
            {
                "icon": "🥝",
                "name": "奇異果 Kiwi fruit",
                "className": "emoji1f95d"
            },
            {
                "icon": "🍅",
                "name": "番茄 Tomato",
                "className": "emoji1f345"
            },
            {
                "icon": "🍆",
                "name": "茄子 Aubergine",
                "className": "emoji1f346"
            },
            {
                "icon": "🥑",
                "name": "鱷梨 Avocado",
                "className": "emoji1f951"
            },
            {
                "icon": "🥦",
                "name": "花椰菜 Broccoli",
                "className": "emoji1f966"
            },
            {
                "icon": "🥬",
                "name": "綠葉蔬菜 Leafy green",
                "className": "emoji1f96c"
            },
            {
                "icon": "🥒",
                "name": "黃瓜 Cucumber",
                "className": "emoji1f952"
            },
            {
                "icon": "🌶",
                "name": "辣椒 Hot pepper",
                "className": "emoji1f336"
            },
            {
                "icon": "🌽",
                "name": "玉米 Ear of maize",
                "className": "emoji1f33d"
            },
            {
                "icon": "🥕",
                "name": "胡蘿蔔 Carrot",
                "className": "emoji1f955"
            },
            {
                "icon": "🧄",
                "name": "大蒜 Garlic",
                "className": "emoji1f9c4"
            },
            {
                "icon": "🧅",
                "name": "洋蔥 Onion",
                "className": "emoji1f9c5"
            },
            {
                "icon": "🥔",
                "name": "馬鈴薯 Potato",
                "className": "emoji1f954"
            },
            {
                "icon": "🍠",
                "name": "烤地瓜 Roasted sweet potato",
                "className": "emoji1f360"
            },
            {
                "icon": "🥐",
                "name": "牛角麵包 Croissant",
                "className": "emoji1f950"
            },
            {
                "icon": "🥯",
                "name": "貝果 Bagel",
                "className": "emoji1f96f"
            },
            {
                "icon": "🍞",
                "name": "麵包 Bread",
                "className": "emoji1f35e"
            },
            {
                "icon": "🥖",
                "name": "法式長棍麵包 Baguette bread",
                "className": "emoji1f956"
            },
            {
                "icon": "🥨",
                "name": "蝴蝶餅 Pretzel",
                "className": "emoji1f968"
            },
            {
                "icon": "🧀",
                "name": "切成楔形的乳酪 Cheese wedge",
                "className": "emoji1f9c0"
            },
            {
                "icon": "🥚",
                "name": "蛋 Egg",
                "className": "emoji1f95a"
            },
            {
                "icon": "🍳",
                "name": "烹飪 Cooking",
                "className": "emoji1f373"
            },
            {
                "icon": "🧈",
                "name": "奶油 Butter",
                "className": "emoji1f9c8"
            },
            {
                "icon": "🥞",
                "name": "鬆餅 Pancakes",
                "className": "emoji1f95e"
            },
            {
                "icon": "🧇",
                "name": "格子鬆餅 Waffle",
                "className": "emoji1f9c7"
            },
            {
                "icon": "🥓",
                "name": "培根 Bacon",
                "className": "emoji1f953"
            },
            {
                "icon": "🥩",
                "name": "肉塊 Cut of meat",
                "className": "emoji1f969"
            },
            {
                "icon": "🍗",
                "name": "家禽腿肉 Poultry leg",
                "className": "emoji1f357"
            },
            {
                "icon": "🍖",
                "name": "帶骨肉 Meat on bone",
                "className": "emoji1f356"
            },
            {
                "icon": "🦴",
                "name": "骨頭 Bone",
                "className": "emoji1f9b4"
            },
            {
                "icon": "🌭",
                "name": "熱狗 Hot dog",
                "className": "emoji1f32d"
            },
            {
                "icon": "🍔",
                "name": "漢堡 Hamburger",
                "className": "emoji1f354"
            },
            {
                "icon": "🍟",
                "name": "薯條 French fries",
                "className": "emoji1f35f"
            },
            {
                "icon": "🍕",
                "name": "披薩切片 Slice of pizza",
                "className": "emoji1f355"
            },
            {
                "icon": "🥪",
                "name": "三明治 Sandwich",
                "className": "emoji1f96a"
            },
            {
                "icon": "🥙",
                "name": "夾餡料的扁麵包 Stuffed flatbread",
                "className": "emoji1f959"
            },
            {
                "icon": "🧆",
                "name": "油炸鷹嘴豆餅 Falafel",
                "className": "emoji1f9c6"
            },
            {
                "icon": "🌮",
                "name": "墨西哥夾餅 Taco",
                "className": "emoji1f32e"
            },
            {
                "icon": "🌯",
                "name": "墨西哥捲餅 Burrito",
                "className": "emoji1f32f"
            },
            {
                "icon": "🥗",
                "name": "生菜沙拉 Green salad",
                "className": "emoji1f957"
            },
            {
                "icon": "🥘",
                "name": "西班牙大鍋飯 Shallow pan of food",
                "className": "emoji1f958"
            },
            {
                "icon": "🥫",
                "name": "罐頭食品 Canned food",
                "className": "emoji1f96b"
            },
            {
                "icon": "🍝",
                "name": "義大利麵 Spaghetti",
                "className": "emoji1f35d"
            },
            {
                "icon": "🍜",
                "name": "熱食 Steaming bowl",
                "className": "emoji1f35c"
            },
            {
                "icon": "🍲",
                "name": "火鍋料理 Pot of food",
                "className": "emoji1f372"
            },
            {
                "icon": "🍛",
                "name": "咖哩飯 Curry and rice",
                "className": "emoji1f35b"
            },
            {
                "icon": "🍣",
                "name": "壽司 Sushi",
                "className": "emoji1f363"
            },
            {
                "icon": "🍱",
                "name": "便當 Bento box",
                "className": "emoji1f371"
            },
            {
                "icon": "🥟",
                "name": "包餡點心 Dumpling",
                "className": "emoji1f95f"
            },
            {
                "icon": "🦪",
                "name": "牡蠣 Oyster",
                "className": "emoji1f9aa"
            },
            {
                "icon": "🍤",
                "name": "炸蝦 Fried shrimp",
                "className": "emoji1f364"
            },
            {
                "icon": "🍙",
                "name": "飯糰 Rice ball",
                "className": "emoji1f359"
            },
            {
                "icon": "🍚",
                "name": "米飯 Cooked rice",
                "className": "emoji1f35a"
            },
            {
                "icon": "🍘",
                "name": "米脆餅 Rice cracker",
                "className": "emoji1f358"
            },
            {
                "icon": "🍥",
                "name": "鳴門卷 Fish cake with swirl design",
                "className": "emoji1f365"
            },
            {
                "icon": "🥠",
                "name": "籤語餅乾 Fortune cookie",
                "className": "emoji1f960"
            },
            {
                "icon": "🥮",
                "name": "月餅 Moon cake",
                "className": "emoji1f96e"
            },
            {
                "icon": "🍢",
                "name": "關東煮 Oden",
                "className": "emoji1f362"
            },
            {
                "icon": "🍡",
                "name": "日式糯米丸子 Dango",
                "className": "emoji1f361"
            },
            {
                "icon": "🍧",
                "name": "刨冰 Shaved ice",
                "className": "emoji1f367"
            },
            {
                "icon": "🍨",
                "name": "冰淇淋 Ice cream",
                "className": "emoji1f368"
            },
            {
                "icon": "🍦",
                "name": "霜淇淋 Soft ice cream",
                "className": "emoji1f366"
            },
            {
                "icon": "🥧",
                "name": "派 Pie",
                "className": "emoji1f967"
            },
            {
                "icon": "🧁",
                "name": "杯子蛋糕 Cupcake",
                "className": "emoji1f9c1"
            },
            {
                "icon": "🍰",
                "name": "水果蛋糕 Shortcake",
                "className": "emoji1f370"
            },
            {
                "icon": "🎂",
                "name": "生日蛋糕 Birthday cake",
                "className": "emoji1f382"
            },
            {
                "icon": "🍮",
                "name": "卡士達 Custard",
                "className": "emoji1f36e"
            },
            {
                "icon": "🍭",
                "name": "Lollipop Lollipop",
                "className": "emoji1f36d"
            },
            {
                "icon": "🍬",
                "name": "糖果 Candy",
                "className": "emoji1f36c"
            },
            {
                "icon": "🍫",
                "name": "巧克力棒 Chocolate bar",
                "className": "emoji1f36b"
            },
            {
                "icon": "🍿",
                "name": "專心 Popcorn",
                "className": "emoji1f37f"
            },
            {
                "icon": "🍩",
                "name": "甜甜圈 Doughnut",
                "className": "emoji1f369"
            },
            {
                "icon": "🍪",
                "name": "餅乾 Cookie",
                "className": "emoji1f36a"
            },
            {
                "icon": "🌰",
                "name": "栗子 Chestnut",
                "className": "emoji1f330"
            },
            {
                "icon": "🥜",
                "name": "花生 Peanuts",
                "className": "emoji1f95c"
            },
            {
                "icon": "🍯",
                "name": "蜂蜜罐 Honey pot",
                "className": "emoji1f36f"
            },
            {
                "icon": "🥛",
                "name": "一杯牛奶 Glass of milk",
                "className": "emoji1f95b"
            },
            {
                "icon": "🍼",
                "name": "奶瓶 Baby bottle",
                "className": "emoji1f37c"
            },
            {
                "icon": "☕",
                "name": "熱飲 Hot beverage",
                "className": "emoji2615"
            },
            {
                "icon": "🍵",
                "name": "茶碗 Teacup without handle",
                "className": "emoji1f375"
            },
            {
                "icon": "🧃",
                "name": "飲料盒 Beverage box",
                "className": "emoji1f9c3"
            },
            {
                "icon": "🥤",
                "name": "杯子和吸管 Cup with straw",
                "className": "emoji1f964"
            },
            {
                "icon": "🍶",
                "name": "清酒和酒杯 Sake bottle and cup",
                "className": "emoji1f376"
            },
            {
                "icon": "🍺",
                "name": "啤酒杯 Beer mug",
                "className": "emoji1f37a"
            },
            {
                "icon": "🍻",
                "name": "乾杯 Clinking beer mugs",
                "className": "emoji1f37b"
            },
            {
                "icon": "🥂",
                "name": "碰杯 Clinking glasses",
                "className": "emoji1f942"
            },
            {
                "icon": "🍷",
                "name": "葡萄酒杯 Wine glass",
                "className": "emoji1f377"
            },
            {
                "icon": "🥃",
                "name": "玻璃水杯 Tumbler glass",
                "className": "emoji1f943"
            },
            {
                "icon": "🍸",
                "name": "雞尾酒杯 Cocktail glass",
                "className": "emoji1f378"
            },
            {
                "icon": "🍹",
                "name": "熱帶風情雞尾酒 Tropical drink",
                "className": "emoji1f379"
            },
            {
                "icon": "🧉",
                "name": "瑪黛茶 Mate",
                "className": "emoji1f9c9"
            },
            {
                "icon": "🍾",
                "name": "彈出軟木塞的瓶子 Bottle with popping cork",
                "className": "emoji1f37e"
            },
            {
                "icon": "🧊",
                "name": "冰塊 Ice cube",
                "className": "emoji1f9ca"
            },
            {
                "icon": "🥄",
                "name": "湯匙 Spoon",
                "className": "emoji1f944"
            },
            {
                "icon": "🍴",
                "name": "刀叉 Fork and knife",
                "className": "emoji1f374"
            },
            {
                "icon": "🍽",
                "name": "刀叉與盤子 Fork and knife with plate",
                "className": "emoji1f37d"
            },
            {
                "icon": "🥣",
                "name": "碗和湯匙 Bowl with spoon",
                "className": "emoji1f963"
            },
            {
                "icon": "🥡",
                "name": "外帶盒 Takeout box",
                "className": "emoji1f961"
            },
            {
                "icon": "🥢",
                "name": "筷子 Chopsticks",
                "className": "emoji1f962"
            },
            {
                "icon": "🧂",
                "name": "鹽 Salt",
                "className": "emoji1f9c2"
            }
        ]
    },
    {
        "name":"活動",
        "list":[
            {
                "icon": "⚽",
                "name": "足球 Soccer ball",
                "className": "emoji26bd"
            },
            {
                "icon": "🏀",
                "name": "籃球和籃框 Basketball and hoop",
                "className": "emoji1f3c0"
            },
            {
                "icon": "🏈",
                "name": "美式足球 American football",
                "className": "emoji1f3c8"
            },
            {
                "icon": "⚾",
                "name": "棒球 Baseball",
                "className": "emoji26be"
            },
            {
                "icon": "🥎",
                "name": "壘球 Softball",
                "className": "emoji1f94e"
            },
            {
                "icon": "🎾",
                "name": "網球拍和球 Tennis racquet and ball",
                "className": "emoji1f3be"
            },
            {
                "icon": "🏐",
                "name": "排球 Volleyball",
                "className": "emoji1f3d0"
            },
            {
                "icon": "🏉",
                "name": "橄欖球 Rugby football",
                "className": "emoji1f3c9"
            },
            {
                "icon": "🥏",
                "name": "飛盤 Flying disc",
                "className": "emoji1f94f"
            },
            {
                "icon": "🎱",
                "name": "撞球 Billiards",
                "className": "emoji1f3b1"
            },
            {
                "icon": "🪀",
                "name": "溜溜球 Yo-yo",
                "className": "emoji1fa80"
            },
            {
                "icon": "🏓",
                "name": "乒乓球拍和球 Table tennis paddle and ball",
                "className": "emoji1f3d3"
            },
            {
                "icon": "🏸",
                "name": "羽球拍和羽球 Badminton racquet and shuttlecock",
                "className": "emoji1f3f8"
            },
            {
                "icon": "🏒",
                "name": "冰上曲棍球棍和冰球 Ice hockey stick and puck",
                "className": "emoji1f3d2"
            },
            {
                "icon": "🏑",
                "name": "曲棍球棍和球 Field hockey stick and ball",
                "className": "emoji1f3d1"
            },
            {
                "icon": "🥍",
                "name": "曲棍球桿和曲棍球 Lacrosse",
                "className": "emoji1f94d"
            },
            {
                "icon": "🏏",
                "name": "板球拍和球 Cricket bat and ball",
                "className": "emoji1f3cf"
            },
            {
                "icon": "🥅",
                "name": "進球網 Goal net",
                "className": "emoji1f945"
            },
            {
                "icon": "⛳",
                "name": "球洞中的旗子 Flag in hole",
                "className": "emoji26f3"
            },
            {
                "icon": "🪁",
                "name": "風箏 Kite",
                "className": "emoji1fa81"
            },
            {
                "icon": "🏹",
                "name": "弓箭 Bow and arrow",
                "className": "emoji1f3f9"
            },
            {
                "icon": "🎣",
                "name": "釣竿和魚 Fishing pole and fish",
                "className": "emoji1f3a3"
            },
            {
                "icon": "🤿",
                "name": "潛水面罩 Diving mask",
                "className": "emoji1f93f"
            },
            {
                "icon": "🥊",
                "name": "拳擊手套 Boxing glove",
                "className": "emoji1f94a"
            },
            {
                "icon": "🥋",
                "name": "武術制服 Martial arts uniform",
                "className": "emoji1f94b"
            },
            {
                "icon": "🎽",
                "name": "有飾帶的跑步運動服 Running shirt with sash",
                "className": "emoji1f3bd"
            },
            {
                "icon": "🛹",
                "name": "滑板 Skateboard",
                "className": "emoji1f6f9"
            },
            {
                "icon": "🛷",
                "name": "雪橇 Sled",
                "className": "emoji1f6f7"
            },
            {
                "icon": "⛸",
                "name": "溜冰鞋 Ice skate",
                "className": "emoji26f8"
            },
            {
                "icon": "🥌",
                "name": "冰壺球 Curling stone",
                "className": "emoji1f94c"
            },
            {
                "icon": "🎿",
                "name": "滑雪和滑雪靴 Ski and ski boot",
                "className": "emoji1f3bf"
            },
            {
                "icon": "⛷",
                "name": "滑雪者 Skier",
                "className": "emoji26f7"
            },
            {
                "icon": "🏂",
                "name": "滑雪板 Snowboarder",
                "className": "emoji1f3c2"
            },
            {
                "icon": "🪂",
                "name": "降落傘 Parachute",
                "className": "emoji1fa82"
            },
            {
                "icon": "🏋‍♀",
                "name": "女舉重員 Woman lifting weights",
                "className": "emoji1f3cb-200d-2640"
            },
            {
                "icon": "🏋",
                "name": "舉重員 Weight lifter",
                "className": "emoji1f3cb"
            },
            {
                "icon": "🏋‍♂",
                "name": "男舉重員 Man lifting weights",
                "className": "emoji1f3cb-200d-2642"
            },
            {
                "icon": "🤼‍♀",
                "name": "摔角的女人 Women wrestling",
                "className": "emoji1f93c-200d-2640"
            },
            {
                "icon": "🤼",
                "name": "摔角的人 People wrestling",
                "className": "emoji1f93c"
            },
            {
                "icon": "🤼‍♂",
                "name": "摔角的男人 Men wrestling",
                "className": "emoji1f93c-200d-2642"
            },
            {
                "icon": "🤸‍♀",
                "name": "翻跟斗的女性 Woman cartwheeling",
                "className": "emoji1f938-200d-2640"
            },
            {
                "icon": "🤸",
                "name": "側手翻的人 Person cartwheeling",
                "className": "emoji1f938"
            },
            {
                "icon": "🤸‍♂",
                "name": "翻跟斗的男性 Man cartwheeling",
                "className": "emoji1f938-200d-2642"
            },
            {
                "icon": "⛹‍♀",
                "name": "女籃球員 Woman bouncing ball",
                "className": "emoji26f9-200d-2640"
            },
            {
                "icon": "⛹",
                "name": "運球的人 Person with ball",
                "className": "emoji26f9"
            },
            {
                "icon": "⛹‍♂",
                "name": "運球的男人 Man bouncing ball",
                "className": "emoji26f9-200d-2642"
            },
            {
                "icon": "🤺",
                "name": "擊劍運動員 Person fencing",
                "className": "emoji1f93a"
            },
            {
                "icon": "🤾‍♀",
                "name": "打手球的女人 Woman playing handball",
                "className": "emoji1f93e-200d-2640"
            },
            {
                "icon": "🤾",
                "name": "打手球的人 Person playing handball",
                "className": "emoji1f93e"
            },
            {
                "icon": "🤾‍♂",
                "name": "打手球的男人 Man playing handball",
                "className": "emoji1f93e-200d-2642"
            },
            {
                "icon": "🏌‍♀",
                "name": "打高爾夫球的女人 Woman golfing",
                "className": "emoji1f3cc-200d-2640"
            },
            {
                "icon": "🏌",
                "name": "打高爾夫球的人 Golfer",
                "className": "emoji1f3cc"
            },
            {
                "icon": "🏌‍♂",
                "name": "打高爾夫球的男人 Man golfing",
                "className": "emoji1f3cc-200d-2642"
            },
            {
                "icon": "🏇",
                "name": "賽馬 Horse racing",
                "className": "emoji1f3c7"
            },
            {
                "icon": "🧘‍♀",
                "name": "雙腿盤坐的女人 Woman in lotus position",
                "className": "emoji1f9d8-200d-2640"
            },
            {
                "icon": "🧘",
                "name": "雙腿盤坐的人 Person in lotus position",
                "className": "emoji1f9d8"
            },
            {
                "icon": "🧘‍♂",
                "name": "雙腿盤坐的男人 Man in lotus position",
                "className": "emoji1f9d8-200d-2642"
            },
            {
                "icon": "🏄‍♀",
                "name": "衝浪的女人 Woman surfing",
                "className": "emoji1f3c4-200d-2640"
            },
            {
                "icon": "🏄",
                "name": "衝浪客 Surfer",
                "className": "emoji1f3c4"
            },
            {
                "icon": "🏄‍♂",
                "name": "衝浪的男人 Man surfing",
                "className": "emoji1f3c4-200d-2642"
            },
            {
                "icon": "🏊‍♀",
                "name": "游泳的女人 Woman swimming",
                "className": "emoji1f3ca-200d-2640"
            },
            {
                "icon": "🏊",
                "name": "游泳者 Swimmer",
                "className": "emoji1f3ca"
            },
            {
                "icon": "🏊‍♂",
                "name": "游泳的男人 Man swimming",
                "className": "emoji1f3ca-200d-2642"
            },
            {
                "icon": "🤽‍♀",
                "name": "打水球的女人 Woman playing water polo",
                "className": "emoji1f93d-200d-2640"
            },
            {
                "icon": "🤽",
                "name": "打水球的人 Person playing water polo",
                "className": "emoji1f93d"
            },
            {
                "icon": "🤽‍♂",
                "name": "打水球的男人 Man playing water polo",
                "className": "emoji1f93d-200d-2642"
            },
            {
                "icon": "🚣‍♀",
                "name": "划船的女人 Woman rowing boat",
                "className": "emoji1f6a3-200d-2640"
            },
            {
                "icon": "🚣",
                "name": "划槳船 Rowboat",
                "className": "emoji1f6a3"
            },
            {
                "icon": "🚣‍♂",
                "name": "划船的男人 Man rowing boat",
                "className": "emoji1f6a3-200d-2642"
            },
            {
                "icon": "🧗‍♀",
                "name": "攀爬的女人 Woman climbing",
                "className": "emoji1f9d7-200d-2640"
            },
            {
                "icon": "🧗",
                "name": "攀爬的人 Person climbing",
                "className": "emoji1f9d7"
            },
            {
                "icon": "🧗‍♂",
                "name": "攀爬的男人 Man climbing",
                "className": "emoji1f9d7-200d-2642"
            },
            {
                "icon": "🚵‍♀",
                "name": "騎單車越野的女人 Woman mountain biking",
                "className": "emoji1f6b5-200d-2640"
            },
            {
                "icon": "🚵",
                "name": "越野自行車騎士 Mountain bicyclist",
                "className": "emoji1f6b5"
            },
            {
                "icon": "🚵‍♂",
                "name": "騎單車越野的男人 Man mountain biking",
                "className": "emoji1f6b5-200d-2642"
            },
            {
                "icon": "🚴‍♀",
                "name": "騎自行車的女人 Woman biking",
                "className": "emoji1f6b4-200d-2640"
            },
            {
                "icon": "🚴",
                "name": "腳踏車騎士 Bicyclist",
                "className": "emoji1f6b4"
            },
            {
                "icon": "🚴‍♂",
                "name": "騎自行車的男人 Man biking",
                "className": "emoji1f6b4-200d-2642"
            },
            {
                "icon": "🏆",
                "name": "獎盃 Trophy",
                "className": "emoji1f3c6"
            },
            {
                "icon": "🥇",
                "name": "第一名獎牌 First place medal",
                "className": "emoji1f947"
            },
            {
                "icon": "🥈",
                "name": "第二名獎牌 Second place medal",
                "className": "emoji1f948"
            },
            {
                "icon": "🥉",
                "name": "第三名獎牌 Third place medal",
                "className": "emoji1f949"
            },
            {
                "icon": "🏅",
                "name": "體育獎章 Sports medal",
                "className": "emoji1f3c5"
            },
            {
                "icon": "🎖",
                "name": "軍功勳章 Military medal",
                "className": "emoji1f396"
            },
            {
                "icon": "🏵",
                "name": "玫瑰花形 Rosette",
                "className": "emoji1f3f5"
            },
            {
                "icon": "🎗",
                "name": "提醒緞帶 Reminder ribbon",
                "className": "emoji1f397"
            },
            {
                "icon": "🎫",
                "name": "門票 Ticket",
                "className": "emoji1f3ab"
            },
            {
                "icon": "🎟",
                "name": "入場券 Admission tickets",
                "className": "emoji1f39f"
            },
            {
                "icon": "🎪",
                "name": "馬戲團帳篷 Circus tent",
                "className": "emoji1f3aa"
            },
            {
                "icon": "🤹‍♀",
                "name": "雜耍的女人 Woman juggling",
                "className": "emoji1f939-200d-2640"
            },
            {
                "icon": "🤹",
                "name": "耍球的人 Person juggling",
                "className": "emoji1f939"
            },
            {
                "icon": "🤹‍♂",
                "name": "雜耍的男人 Man juggling",
                "className": "emoji1f939-200d-2642"
            },
            {
                "icon": "🎭",
                "name": "表演藝術 Performing arts",
                "className": "emoji1f3ad"
            },
            {
                "icon": "🩰",
                "name": "芭蕾舞鞋 Ballet shoes",
                "className": "emoji1fa70"
            },
            {
                "icon": "🎨",
                "name": "調色盤 Artist palette",
                "className": "emoji1f3a8"
            },
            {
                "icon": "🎬",
                "name": "場記板 Clapper board",
                "className": "emoji1f3ac"
            },
            {
                "icon": "🎤",
                "name": "麥克風 Microphone",
                "className": "emoji1f3a4"
            },
            {
                "icon": "🎧",
                "name": "耳機 Headphone",
                "className": "emoji1f3a7"
            },
            {
                "icon": "🎼",
                "name": "樂譜 Musical score",
                "className": "emoji1f3bc"
            },
            {
                "icon": "🎹",
                "name": "鍵盤樂器 Musical keyboard",
                "className": "emoji1f3b9"
            },
            {
                "icon": "🥁",
                "name": "鼓 Drum",
                "className": "emoji1f941"
            },
            {
                "icon": "🎷",
                "name": "薩克斯風 Saxophone",
                "className": "emoji1f3b7"
            },
            {
                "icon": "🎺",
                "name": "小號 Trumpet",
                "className": "emoji1f3ba"
            },
            {
                "icon": "🎸",
                "name": "吉他 Guitar",
                "className": "emoji1f3b8"
            },
            {
                "icon": "🪕",
                "name": "斑鳩琴 Banjo",
                "className": "emoji1fa95"
            },
            {
                "icon": "🎻",
                "name": "小提琴 Violin",
                "className": "emoji1f3bb"
            },
            {
                "icon": "🎲",
                "name": "遊戲骰子 Game die",
                "className": "emoji1f3b2"
            },
            {
                "icon": "♟",
                "name": "棋子 Chess pawn",
                "className": "emoji265f"
            },
            {
                "icon": "🎯",
                "name": "正中紅心 Direct hit",
                "className": "emoji1f3af"
            },
            {
                "icon": "🎳",
                "name": "保齡球 Bowling",
                "className": "emoji1f3b3"
            },
            {
                "icon": "🎮",
                "name": "電玩遊戲 Video game",
                "className": "emoji1f3ae"
            },
            {
                "icon": "🎰",
                "name": "吃角子老虎機 Slot machine",
                "className": "emoji1f3b0"
            },
            {
                "icon": "🧩",
                "name": "拼圖片 Jigsaw",
                "className": "emoji1f9e9"
            },
            {
                "icon": "👮‍♀",
                "name": "女警 Woman police officer",
                "className": "emoji1f46e-200d-2640"
            },
            {
                "icon": "👮",
                "name": "警察 Police officer",
                "className": "emoji1f46e"
            },
            {
                "icon": "👮‍♂",
                "name": "男警察 Man police officer",
                "className": "emoji1f46e-200d-2642"
            },
            {
                "icon": "👷‍♀",
                "name": "女工人 Woman construction worker",
                "className": "emoji1f477-200d-2640"
            },
            {
                "icon": "👷",
                "name": "建築工人 Construction worker",
                "className": "emoji1f477"
            },
            {
                "icon": "👷‍♂",
                "name": "男工人 Man construction worker",
                "className": "emoji1f477-200d-2642"
            },
            {
                "icon": "💂‍♀",
                "name": "女衛兵 Woman guard",
                "className": "emoji1f482-200d-2640"
            },
            {
                "icon": "💂",
                "name": "衛兵 Guardsman",
                "className": "emoji1f482"
            },
            {
                "icon": "💂‍♂",
                "name": "男衛兵 Man guard",
                "className": "emoji1f482-200d-2642"
            },
            {
                "icon": "🕵‍♀",
                "name": "女偵探 Woman detective",
                "className": "emoji1f575-200d-2640"
            },
            {
                "icon": "🕵",
                "name": "偵探 Sleuth or spy",
                "className": "emoji1f575"
            },
            {
                "icon": "🕵‍♂",
                "name": "男偵探 Man detective",
                "className": "emoji1f575-200d-2642"
            },
            {
                "icon": "👩‍⚕",
                "name": "女醫護人員 Woman health worker",
                "className": "emoji1f469-200d-2695"
            },
            {
                "icon": "🧑‍⚕",
                "name": "醫護人員 Health worker",
                "className": "emoji1f9d1-200d-2695"
            },
            {
                "icon": "👨‍⚕",
                "name": "男醫護人員 Man health worker",
                "className": "emoji1f468-200d-2695"
            },
            {
                "icon": "👩‍🌾",
                "name": "女農夫 Woman farmer",
                "className": "emoji1f469-200d-1f33e"
            },
            {
                "icon": "🧑‍🌾",
                "name": "農夫 Farmer",
                "className": "emoji1f9d1-200d-1f33e"
            },
            {
                "icon": "👨‍🌾",
                "name": "男農夫 Man farmer",
                "className": "emoji1f468-200d-1f33e"
            },
            {
                "icon": "👩‍🍳",
                "name": "女廚師 Woman cook",
                "className": "emoji1f469-200d-1f373"
            },
            {
                "icon": "🧑‍🍳",
                "name": "廚師 Cook",
                "className": "emoji1f9d1-200d-1f373"
            },
            {
                "icon": "👨‍🍳",
                "name": "男廚師 Man cook",
                "className": "emoji1f468-200d-1f373"
            },
            {
                "icon": "👩‍🎓",
                "name": "女學生 Woman student",
                "className": "emoji1f469-200d-1f393"
            },
            {
                "icon": "🧑‍🎓",
                "name": "學生 Student",
                "className": "emoji1f9d1-200d-1f393"
            },
            {
                "icon": "👨‍🎓",
                "name": "男學生 Man student",
                "className": "emoji1f468-200d-1f393"
            },
            {
                "icon": "👩‍🎤",
                "name": "女歌手 Woman singer",
                "className": "emoji1f469-200d-1f3a4"
            },
            {
                "icon": "🧑‍🎤",
                "name": "歌手 Singer",
                "className": "emoji1f9d1-200d-1f3a4"
            },
            {
                "icon": "👨‍🎤",
                "name": "男歌手 Man singer",
                "className": "emoji1f468-200d-1f3a4"
            },
            {
                "icon": "👩‍🏫",
                "name": "女老師 Woman teacher",
                "className": "emoji1f469-200d-1f3eb"
            },
            {
                "icon": "🧑‍🏫",
                "name": "老師 Teacher",
                "className": "emoji1f9d1-200d-1f3eb"
            },
            {
                "icon": "👨‍🏫",
                "name": "男老師 Man teacher",
                "className": "emoji1f468-200d-1f3eb"
            },
            {
                "icon": "👩‍🏭",
                "name": "女工廠工人 Woman factory worker",
                "className": "emoji1f469-200d-1f3ed"
            },
            {
                "icon": "🧑‍🏭",
                "name": "工廠作業員 Factory worker",
                "className": "emoji1f9d1-200d-1f3ed"
            },
            {
                "icon": "👨‍🏭",
                "name": "男工廠作業員 Man factory worker",
                "className": "emoji1f468-200d-1f3ed"
            },
            {
                "icon": "👩‍💻",
                "name": "女技術人員 Woman technologist",
                "className": "emoji1f469-200d-1f4bb"
            },
            {
                "icon": "🧑‍💻",
                "name": "技術人員 Technologist",
                "className": "emoji1f9d1-200d-1f4bb"
            },
            {
                "icon": "👨‍💻",
                "name": "男技術員 Man technologist",
                "className": "emoji1f468-200d-1f4bb"
            },
            {
                "icon": "👩‍💼",
                "name": "女職員 Woman office worker",
                "className": "emoji1f469-200d-1f4bc"
            },
            {
                "icon": "🧑‍💼",
                "name": "辦公人員 Office worker",
                "className": "emoji1f9d1-200d-1f4bc"
            },
            {
                "icon": "👨‍💼",
                "name": "男職員 Man office worker",
                "className": "emoji1f468-200d-1f4bc"
            },
            {
                "icon": "👩‍🔧",
                "name": "女技師 Woman mechanic",
                "className": "emoji1f469-200d-1f527"
            },
            {
                "icon": "🧑‍🔧",
                "name": "技工 Mechanic",
                "className": "emoji1f9d1-200d-1f527"
            },
            {
                "icon": "👨‍🔧",
                "name": "男技師 Man mechanic",
                "className": "emoji1f468-200d-1f527"
            },
            {
                "icon": "👩‍🔬",
                "name": "女科學家 Woman scientist",
                "className": "emoji1f469-200d-1f52c"
            },
            {
                "icon": "🧑‍🔬",
                "name": "科學家 Scientist",
                "className": "emoji1f9d1-200d-1f52c"
            },
            {
                "icon": "👨‍🔬",
                "name": "男科學家 Man scientist",
                "className": "emoji1f468-200d-1f52c"
            },
            {
                "icon": "👩‍🎨",
                "name": "女畫家 Woman artist",
                "className": "emoji1f469-200d-1f3a8"
            },
            {
                "icon": "🧑‍🎨",
                "name": "藝術家 Artist",
                "className": "emoji1f9d1-200d-1f3a8"
            },
            {
                "icon": "👨‍🎨",
                "name": "男畫家 Man artist",
                "className": "emoji1f468-200d-1f3a8"
            },
            {
                "icon": "👩‍🚒",
                "name": "女消防員 Woman firefighter",
                "className": "emoji1f469-200d-1f692"
            },
            {
                "icon": "🧑‍🚒",
                "name": "消防員 Firefighter",
                "className": "emoji1f9d1-200d-1f692"
            },
            {
                "icon": "👨‍🚒",
                "name": "男消防員 Man firefighter",
                "className": "emoji1f468-200d-1f692"
            },
            {
                "icon": "👩‍✈",
                "name": "女機長 Woman pilot",
                "className": "emoji1f469-200d-2708"
            },
            {
                "icon": "🧑‍✈",
                "name": "機長 Pilot",
                "className": "emoji1f9d1-200d-2708"
            },
            {
                "icon": "👨‍✈",
                "name": "男飛行員 Man pilot",
                "className": "emoji1f468-200d-2708"
            },
            {
                "icon": "👩‍🚀",
                "name": "女太空人 Woman astronaut",
                "className": "emoji1f469-200d-1f680"
            },
            {
                "icon": "🧑‍🚀",
                "name": "太空人 Astronaut",
                "className": "emoji1f9d1-200d-1f680"
            },
            {
                "icon": "👨‍🚀",
                "name": "男太空人 Man astronaut",
                "className": "emoji1f468-200d-1f680"
            },
            {
                "icon": "👩‍⚖",
                "name": "女法官 Woman judge",
                "className": "emoji1f469-200d-2696"
            },
            {
                "icon": "🧑‍⚖",
                "name": "法官 Judge",
                "className": "emoji1f9d1-200d-2696"
            },
            {
                "icon": "👨‍⚖",
                "name": "男法官 Man judge",
                "className": "emoji1f468-200d-2696"
            },
            {
                "icon": "👰",
                "name": "戴頭紗的新娘 Bride with veil",
                "className": "emoji1f470"
            },
            {
                "icon": "🤵",
                "name": "穿禮服的男性 Person in tuxedo",
                "className": "emoji1f935"
            },
            {
                "icon": "👸",
                "name": "公主 Princess",
                "className": "emoji1f478"
            },
            {
                "icon": "🤴",
                "name": "王子 Prince",
                "className": "emoji1f934"
            },
            {
                "icon": "🦸‍♀",
                "name": "女超級英雄 Woman superhero",
                "className": "emoji1f9b8-200d-2640"
            },
            {
                "icon": "🦸",
                "name": "超級英雄 Superhero",
                "className": "emoji1f9b8"
            },
            {
                "icon": "🦸‍♂",
                "name": "男超級英雄 Man superhero",
                "className": "emoji1f9b8-200d-2642"
            },
            {
                "icon": "🦹‍♀",
                "name": "女超級惡棍 Woman supervillain",
                "className": "emoji1f9b9-200d-2640"
            },
            {
                "icon": "🦹",
                "name": "超級惡棍 Supervillain",
                "className": "emoji1f9b9"
            },
            {
                "icon": "🦹‍♂",
                "name": "男超級惡棍 Man supervillain",
                "className": "emoji1f9b9-200d-2642"
            },
            {
                "icon": "🤶",
                "name": "聖誕夫人 Mrs. Claus",
                "className": "emoji1f936"
            },
            {
                "icon": "🎅",
                "name": "聖誕老人 Father christmas",
                "className": "emoji1f385"
            },
            {
                "icon": "🧙‍♀",
                "name": "女巫師 Woman mage",
                "className": "emoji1f9d9-200d-2640"
            },
            {
                "icon": "🧙",
                "name": "巫師 Mage",
                "className": "emoji1f9d9"
            },
            {
                "icon": "🧙‍♂",
                "name": "男巫師 Man mage",
                "className": "emoji1f9d9-200d-2642"
            },
            {
                "icon": "🧝‍♀",
                "name": "女小精靈 Woman elf",
                "className": "emoji1f9dd-200d-2640"
            },
            {
                "icon": "🧝",
                "name": "小精靈 Elf",
                "className": "emoji1f9dd"
            },
            {
                "icon": "🧝‍♂",
                "name": "男小精靈 Man elf",
                "className": "emoji1f9dd-200d-2642"
            },
            {
                "icon": "🧛‍♀",
                "name": "女吸血鬼 Woman vampire",
                "className": "emoji1f9db-200d-2640"
            },
            {
                "icon": "🧛",
                "name": "吸血鬼 Vampire",
                "className": "emoji1f9db"
            },
            {
                "icon": "🧛‍♂",
                "name": "男吸血鬼 Man vampire",
                "className": "emoji1f9db-200d-2642"
            },
            {
                "icon": "🧟‍♀",
                "name": "女僵屍 Woman zombie",
                "className": "emoji1f9df-200d-2640"
            },
            {
                "icon": "🧟",
                "name": "僵屍 Zombie",
                "className": "emoji1f9df"
            },
            {
                "icon": "🧟‍♂",
                "name": "男僵屍 Man zombie",
                "className": "emoji1f9df-200d-2642"
            },
            {
                "icon": "🧞‍♀",
                "name": "女精靈 Woman genie",
                "className": "emoji1f9de-200d-2640"
            },
            {
                "icon": "🧞",
                "name": "精靈 Genie",
                "className": "emoji1f9de"
            },
            {
                "icon": "🧞‍♂",
                "name": "男精靈 Man genie",
                "className": "emoji1f9de-200d-2642"
            },
            {
                "icon": "🧜‍♀",
                "name": "女美人魚 Mermaid",
                "className": "emoji1f9dc-200d-2640"
            },
            {
                "icon": "🧜",
                "name": "人魚 Merperson",
                "className": "emoji1f9dc"
            },
            {
                "icon": "🧜‍♂",
                "name": "男美人魚 Merman",
                "className": "emoji1f9dc-200d-2642"
            },
            {
                "icon": "🧚‍♀",
                "name": "仙女 Woman fairy",
                "className": "emoji1f9da-200d-2640"
            },
            {
                "icon": "🧚",
                "name": "仙子 Fairy",
                "className": "emoji1f9da"
            },
            {
                "icon": "🧚‍♂",
                "name": "男仙子 Man fairy",
                "className": "emoji1f9da-200d-2642"
            },
            {
                "icon": "👼",
                "name": "小天使 Baby angel",
                "className": "emoji1f47c"
            },
            {
                "icon": "💇‍♀",
                "name": "接受剪髮的女子 Woman getting haircut",
                "className": "emoji1f487-200d-2640"
            },
            {
                "icon": "💇",
                "name": "剪髮 Haircut",
                "className": "emoji1f487"
            },
            {
                "icon": "💇‍♂",
                "name": "接受剪髮的男子 Man getting haircut",
                "className": "emoji1f487-200d-2642"
            },
            {
                "icon": "💆‍♀",
                "name": "接受臉部按摩的女子 Woman getting face massage",
                "className": "emoji1f486-200d-2640"
            },
            {
                "icon": "💆",
                "name": "臉部按摩 Face massage",
                "className": "emoji1f486"
            },
            {
                "icon": "💆‍♂",
                "name": "接受臉部按摩的男子 Man getting face massage",
                "className": "emoji1f486-200d-2642"
            },
            {
                "icon": "🧖‍♀",
                "name": "蒸氣室裡的女人 Woman in steamy room",
                "className": "emoji1f9d6-200d-2640"
            },
            {
                "icon": "🧖",
                "name": "蒸氣室裡的人 Person in steamy room",
                "className": "emoji1f9d6"
            },
            {
                "icon": "🧖‍♂",
                "name": "蒸氣室裡的男人 Man in steamy room",
                "className": "emoji1f9d6-200d-2642"
            },
            {
                "icon": "💅",
                "name": "指甲油 Nail polish",
                "className": "emoji1f485"
            },
            {
                "icon": "🤳",
                "name": "自拍 Selfie",
                "className": "emoji1f933"
            },
            {
                "icon": "💃",
                "name": "舞者 Dancer",
                "className": "emoji1f483"
            },
            {
                "icon": "🕺",
                "name": "跳舞的男人 Man dancing",
                "className": "emoji1f57a"
            },
            {
                "icon": "👯‍♀",
                "name": "戴兔子耳朵的女人 Women with bunny ears",
                "className": "emoji1f46f-200d-2640"
            },
            {
                "icon": "👯",
                "name": "兔耳女郎 Woman with bunny ears",
                "className": "emoji1f46f"
            },
            {
                "icon": "👯‍♂",
                "name": "戴兔子耳朵的男人 Men with bunny ears",
                "className": "emoji1f46f-200d-2642"
            },
            {
                "icon": "🕴",
                "name": "穿著西裝，飄在空中的男性 Man in business suit levitating",
                "className": "emoji1f574"
            },
            {
                "icon": "👩‍🦽",
                "name": "坐手動輪椅的女人 Woman in manual wheelchair",
                "className": "emoji1f469-200d-1f9bd"
            },
            {
                "icon": "🧑‍🦽",
                "name": "坐在輪椅上的人 Person in manual wheelchair",
                "className": "emoji1f9d1-200d-1f9bd"
            },
            {
                "icon": "👨‍🦽",
                "name": "坐手動輪椅的男人 Man in manual wheelchair",
                "className": "emoji1f468-200d-1f9bd"
            },
            {
                "icon": "👩‍🦼",
                "name": "坐電動輪椅的女人 Woman in motorized wheelchair",
                "className": "emoji1f469-200d-1f9bc"
            },
            {
                "icon": "🧑‍🦼",
                "name": "坐在電動輪椅上的人 Person in motorized wheelchair",
                "className": "emoji1f9d1-200d-1f9bc"
            },
            {
                "icon": "👨‍🦼",
                "name": "坐電動輪椅的男人 Man in motorized wheelchair",
                "className": "emoji1f468-200d-1f9bc"
            },
            {
                "icon": "🚶‍♀",
                "name": "正在走路的女人 Woman walking",
                "className": "emoji1f6b6-200d-2640"
            },
            {
                "icon": "🚶",
                "name": "行人 Pedestrian",
                "className": "emoji1f6b6"
            },
            {
                "icon": "🚶‍♂",
                "name": "正在走路的男人 Man walking",
                "className": "emoji1f6b6-200d-2642"
            },
            {
                "icon": "👩‍🦯",
                "name": "拿盲人柺杖的女人 Woman with probing cane",
                "className": "emoji1f469-200d-1f9af"
            },
            {
                "icon": "🧑‍🦯",
                "name": "拿盲人手杖的人 Person with probing cane",
                "className": "emoji1f9d1-200d-1f9af"
            },
            {
                "icon": "👨‍🦯",
                "name": "拿盲人柺杖的男人 Man with probing cane",
                "className": "emoji1f468-200d-1f9af"
            },
            {
                "icon": "🧎‍♀",
                "name": "跪著的女人 Woman kneeling",
                "className": "emoji1f9ce-200d-2640"
            },
            {
                "icon": "🧎",
                "name": "跪著的人 Person kneeling",
                "className": "emoji1f9ce"
            },
            {
                "icon": "🧎‍♂",
                "name": "跪著的男人 Man kneeling",
                "className": "emoji1f9ce-200d-2642"
            },
            {
                "icon": "🏃‍♀",
                "name": "正在奔跑的女人 Woman running",
                "className": "emoji1f3c3-200d-2640"
            },
            {
                "icon": "🏃",
                "name": "跑者 Runner",
                "className": "emoji1f3c3"
            },
            {
                "icon": "🏃‍♂",
                "name": "正在奔跑的男人 Man running",
                "className": "emoji1f3c3-200d-2642"
            },
            {
                "icon": "🧍‍♀",
                "name": "站立的女人 Woman standing",
                "className": "emoji1f9cd-200d-2640"
            },
            {
                "icon": "🧍",
                "name": "站立的人 Person standing",
                "className": "emoji1f9cd"
            },
            {
                "icon": "🧍‍♂",
                "name": "站立的男人 Man standing",
                "className": "emoji1f9cd-200d-2642"
            },
            {
                "icon": "👫",
                "name": "一男一女手牽手 Man and woman holding hands",
                "className": "emoji1f46b"
            },
            {
                "icon": "👭",
                "name": "兩個女人手牽手 Two women holding hands",
                "className": "emoji1f46d"
            },
            {
                "icon": "👬",
                "name": "兩個男人手牽手 Two men holding hands",
                "className": "emoji1f46c"
            },
            {
                "icon": "👨‍👩‍👦",
                "className": "emoji1f468-200d-1f469-200d-1f466"
            },
            {
                "icon": "👨‍👩‍👧",
                "name": "家庭 (男人、女人、女孩) Family (man, woman, girl)",
                "className": "emoji1f468-200d-1f469-200d-1f467"
            },
            {
                "icon": "👨‍👩‍👧‍👦",
                "name": "家庭 (男人、女人、女孩、男孩) Family (man, woman, girl, boy)",
                "className": "emoji1f468-200d-1f469-200d-1f467-200d-1f466"
            },
            {
                "icon": "👨‍👩‍👦‍👦",
                "name": "家庭 (男人、女人、男孩、男孩) Family (man, woman, boy, boy)",
                "className": "emoji1f468-200d-1f469-200d-1f466-200d-1f466"
            },
            {
                "icon": "👨‍👩‍👧‍👧",
                "name": "家庭 (男人、女人、女孩、女孩) Family (man, woman, girl, girl)",
                "className": "emoji1f468-200d-1f469-200d-1f467-200d-1f467"
            },
            {
                "icon": "👩‍👩‍👦",
                "name": "家庭 (女人、女人、男孩) Family (woman, woman, boy)",
                "className": "emoji1f469-200d-1f469-200d-1f466"
            },
            {
                "icon": "👩‍👩‍👧",
                "name": "家庭 (女人、女人、女孩) Family (woman, woman, girl)",
                "className": "emoji1f469-200d-1f469-200d-1f467"
            },
            {
                "icon": "👩‍👩‍👧‍👦",
                "name": "家庭 (女人、女人、女孩、男孩) Family (woman, woman, girl, boy)",
                "className": "emoji1f469-200d-1f469-200d-1f467-200d-1f466"
            },
            {
                "icon": "👩‍👩‍👦‍👦",
                "name": "家庭 (女人、女人、男孩、男孩) Family (woman, woman, boy, boy)",
                "className": "emoji1f469-200d-1f469-200d-1f466-200d-1f466"
            },
            {
                "icon": "👩‍👩‍👧‍👧",
                "name": "家庭 (女人、女人、女孩、女孩) Family (woman, woman, girl, girl)",
                "className": "emoji1f469-200d-1f469-200d-1f467-200d-1f467"
            },
            {
                "icon": "👨‍👨‍👦",
                "name": "家庭 (男人、男人、男孩) Family (man, man, boy)",
                "className": "emoji1f468-200d-1f468-200d-1f466"
            },
            {
                "icon": "👨‍👨‍👧",
                "name": "家庭 (女人、女人、女孩) Family (man, man, girl)",
                "className": "emoji1f468-200d-1f468-200d-1f467"
            },
            {
                "icon": "👨‍👨‍👧‍👦",
                "name": "家庭 (男人、男人、女孩、男孩) Family (man, man, girl, boy)",
                "className": "emoji1f468-200d-1f468-200d-1f467-200d-1f466"
            },
            {
                "icon": "👨‍👨‍👦‍👦",
                "name": "家庭 (男人、男人、男孩、男孩) Family (man, man, boy, boy)",
                "className": "emoji1f468-200d-1f468-200d-1f466-200d-1f466"
            },
            {
                "icon": "👨‍👨‍👧‍👧",
                "name": "家庭 (男人、男人、女孩、女孩) Family (man, man, girl, girl)",
                "className": "emoji1f468-200d-1f468-200d-1f467-200d-1f467"
            },
            {
                "icon": "👩‍👦",
                "name": "家庭 (女人、男孩) Family (woman, boy)",
                "className": "emoji1f469-200d-1f466"
            },
            {
                "icon": "👩‍👧",
                "name": "家庭 (女人、女孩) Family (woman, girl)",
                "className": "emoji1f469-200d-1f467"
            },
            {
                "icon": "👩‍👧‍👦",
                "name": "家庭 (女人、女孩、男孩) Family (woman, girl, boy)",
                "className": "emoji1f469-200d-1f467-200d-1f466"
            },
            {
                "icon": "👩‍👦‍👦",
                "name": "家庭 (女人、男孩、男孩) Family (woman, boy, boy)",
                "className": "emoji1f469-200d-1f466-200d-1f466"
            },
            {
                "icon": "👩‍👧‍👧",
                "name": "家庭 (女人、女孩、女孩) Family (woman, girl, girl)",
                "className": "emoji1f469-200d-1f467-200d-1f467"
            },
            {
                "icon": "👨‍👦",
                "name": "家庭 (男人、男孩) Family (man, boy)",
                "className": "emoji1f468-200d-1f466"
            },
            {
                "icon": "👨‍👧",
                "name": "家庭 (男人、女孩) Family (man, girl)",
                "className": "emoji1f468-200d-1f467"
            },
            {
                "icon": "👨‍👧‍👦",
                "name": "家庭 (男人、女孩、男孩) Family (man, girl, boy)",
                "className": "emoji1f468-200d-1f467-200d-1f466"
            },
            {
                "icon": "👨‍👦‍👦",
                "name": "家庭 (男人、男孩、男孩) Family (man, boy, boy)",
                "className": "emoji1f468-200d-1f466-200d-1f466"
            },
            {
                "icon": "👨‍👧‍👧",
                "name": "家庭 (男人、女孩、女孩) Family (man, girl, girl)",
                "className": "emoji1f468-200d-1f467-200d-1f467"
            }
        ]
    },
    {
        "name":"旅遊與地標",
        "list":[
            {
                "icon": "🚗",
                "name": "汽車 Automobile",
                "className": "emoji1f697"
            },
            {
                "icon": "🚕",
                "name": "計程車 Taxi",
                "className": "emoji1f695"
            },
            {
                "icon": "🚙",
                "name": "休旅露營車 Recreational vehicle",
                "className": "emoji1f699"
            },
            {
                "icon": "🚌",
                "name": "公車 Bus",
                "className": "emoji1f68c"
            },
            {
                "icon": "🚎",
                "name": "無軌電車 Trolleybus",
                "className": "emoji1f68e"
            },
            {
                "icon": "🏎",
                "name": "賽車 Racing car",
                "className": "emoji1f3ce"
            },
            {
                "icon": "🚓",
                "name": "警車 Police car",
                "className": "emoji1f693"
            },
            {
                "icon": "🚑",
                "name": "救護車 Ambulance",
                "className": "emoji1f691"
            },
            {
                "icon": "🚒",
                "name": "消防車 Fire engine",
                "className": "emoji1f692"
            },
            {
                "icon": "🚐",
                "name": "小型巴士 Minibus",
                "className": "emoji1f690"
            },
            {
                "icon": "🚚",
                "name": "運貨車 Delivery truck",
                "className": "emoji1f69a"
            },
            {
                "icon": "🚛",
                "name": "鉸接式卡車 Articulated lorry",
                "className": "emoji1f69b"
            },
            {
                "icon": "🚜",
                "name": "拖拉機 Tractor",
                "className": "emoji1f69c"
            },
            {
                "icon": "🦯",
                "name": "盲人柺杖 Probing cane",
                "className": "emoji1f9af"
            },
            {
                "icon": "🦽",
                "name": "手動輪椅 Manual wheelchair",
                "className": "emoji1f9bd"
            },
            {
                "icon": "🦼",
                "name": "電動輪椅 Motorized wheelchair",
                "className": "emoji1f9bc"
            },
            {
                "icon": "🛴",
                "name": "滑板車 Kick scooter",
                "className": "emoji1f6f4"
            },
            {
                "icon": "🚲",
                "name": "腳踏車 Bicycle",
                "className": "emoji1f6b2"
            },
            {
                "icon": "🛵",
                "name": "摩托車 Motor scooter",
                "className": "emoji1f6f5"
            },
            {
                "icon": "🏍",
                "name": "競賽摩托車 Racing motorcycle",
                "className": "emoji1f3cd"
            },
            {
                "icon": "🛺",
                "name": "嘟嘟車 Auto rickshaw",
                "className": "emoji1f6fa"
            },
            {
                "icon": "🚨",
                "name": "旋轉的警車警示燈 Police cars revolving light",
                "className": "emoji1f6a8"
            },
            {
                "icon": "🚔",
                "name": "迎面駛來的警車 Oncoming police car",
                "className": "emoji1f694"
            },
            {
                "icon": "🚍",
                "name": "迎面駛來的公車 Oncoming bus",
                "className": "emoji1f68d"
            },
            {
                "icon": "🚘",
                "name": "迎面駛來的汽車 Oncoming automobile",
                "className": "emoji1f698"
            },
            {
                "icon": "🚖",
                "name": "迎面駛來的計程車 Oncoming taxi",
                "className": "emoji1f696"
            },
            {
                "icon": "🚡",
                "name": "空中纜車 Aerial tramway",
                "className": "emoji1f6a1"
            },
            {
                "icon": "🚠",
                "name": "山區纜車 Mountain cableway",
                "className": "emoji1f6a0"
            },
            {
                "icon": "🚟",
                "name": "懸掛式鐵路 Suspension railway",
                "className": "emoji1f69f"
            },
            {
                "icon": "🚃",
                "name": "火車車廂 Railway car",
                "className": "emoji1f683"
            },
            {
                "icon": "🚋",
                "name": "電車車廂 Tram car",
                "className": "emoji1f68b"
            },
            {
                "icon": "🚞",
                "name": "山區火車 Mountain railway",
                "className": "emoji1f69e"
            },
            {
                "icon": "🚝",
                "name": "單軌鐵路 Monorail",
                "className": "emoji1f69d"
            },
            {
                "icon": "🚄",
                "name": "高速鐵路列車 High-speed train",
                "className": "emoji1f684"
            },
            {
                "icon": "🚅",
                "name": "子彈頭高速鐵路列車 High-speed train with bullet nose",
                "className": "emoji1f685"
            },
            {
                "icon": "🚈",
                "name": "輕軌鐵路 Light rail",
                "className": "emoji1f688"
            },
            {
                "icon": "🚂",
                "name": "蒸汽火車頭 Steam locomotive",
                "className": "emoji1f682"
            },
            {
                "icon": "🚆",
                "name": "火車 Train",
                "className": "emoji1f686"
            },
            {
                "icon": "🚇",
                "name": "地下鐵路 Metro",
                "className": "emoji1f687"
            },
            {
                "icon": "🚊",
                "name": "電車 Tram",
                "className": "emoji1f68a"
            },
            {
                "icon": "🚉",
                "name": "車站 Station",
                "className": "emoji1f689"
            },
            {
                "icon": "✈",
                "name": "飛機 Airplane",
                "className": "emoji2708"
            },
            {
                "icon": "🛫",
                "name": "飛機起飛 Airplane departure",
                "className": "emoji1f6eb"
            },
            {
                "icon": "🛬",
                "name": "飛機降落 Airplane arriving",
                "className": "emoji1f6ec"
            },
            {
                "icon": "🛩",
                "name": "小飛機 Small airplane",
                "className": "emoji1f6e9"
            },
            {
                "icon": "💺",
                "name": "座位 Seat",
                "className": "emoji1f4ba"
            },
            {
                "icon": "🛰",
                "name": "衛星 Satellite",
                "className": "emoji1f6f0"
            },
            {
                "icon": "🚀",
                "name": "火箭 Rocket",
                "className": "emoji1f680"
            },
            {
                "icon": "🛸",
                "name": "飛碟 Flying saucer",
                "className": "emoji1f6f8"
            },
            {
                "icon": "🚁",
                "name": "直昇機 Helicopter",
                "className": "emoji1f681"
            },
            {
                "icon": "🛶",
                "name": "獨木舟 Canoe",
                "className": "emoji1f6f6"
            },
            {
                "icon": "⛵",
                "name": "帆船 Sailboat",
                "className": "emoji26f5"
            },
            {
                "icon": "🚤",
                "name": "快艇 Speedboat",
                "className": "emoji1f6a4"
            },
            {
                "icon": "🛥",
                "name": "汽艇 Motor boat",
                "className": "emoji1f6e5"
            },
            {
                "icon": "🛳",
                "name": "客輪 Passenger ship",
                "className": "emoji1f6f3"
            },
            {
                "icon": "⛴",
                "name": "渡輪 Ferry",
                "className": "emoji26f4"
            },
            {
                "icon": "🚢",
                "name": "船隻 Ship",
                "className": "emoji1f6a2"
            },
            {
                "icon": "⚓",
                "name": "船錨 Anchor",
                "className": "emoji2693"
            },
            {
                "icon": "⛽",
                "name": "燃油泵 Fuel pump",
                "className": "emoji26fd"
            },
            {
                "icon": "🚧",
                "name": "施工標誌 Construction sign",
                "className": "emoji1f6a7"
            },
            {
                "icon": "🚦",
                "name": "垂直式紅綠燈 Vertical traffic light",
                "className": "emoji1f6a6"
            },
            {
                "icon": "🚥",
                "name": "水平式紅綠燈 Horizontal traffic light",
                "className": "emoji1f6a5"
            },
            {
                "icon": "🚏",
                "name": "公車站牌 Bus stop",
                "className": "emoji1f68f"
            },
            {
                "icon": "🗺",
                "name": "世界地圖 World map",
                "className": "emoji1f5fa"
            },
            {
                "icon": "🗿",
                "name": "澀谷仿摩艾石像 Moyai",
                "className": "emoji1f5ff"
            },
            {
                "icon": "🗽",
                "name": "自由女神像 Statue of liberty",
                "className": "emoji1f5fd"
            },
            {
                "icon": "🗼",
                "name": "東京鐵塔 Tokyo tower",
                "className": "emoji1f5fc"
            },
            {
                "icon": "🏰",
                "name": "歐式城堡 European castle",
                "className": "emoji1f3f0"
            },
            {
                "icon": "🏯",
                "name": "日式宮殿 Japanese castle",
                "className": "emoji1f3ef"
            },
            {
                "icon": "🏟",
                "name": "體育場 Stadium",
                "className": "emoji1f3df"
            },
            {
                "icon": "🎡",
                "name": "摩天輪 Ferris wheel",
                "className": "emoji1f3a1"
            },
            {
                "icon": "🎢",
                "name": "雲霄飛車 Roller coaster",
                "className": "emoji1f3a2"
            },
            {
                "icon": "🎠",
                "name": "旋轉木馬 Carousel horse",
                "className": "emoji1f3a0"
            },
            {
                "icon": "⛲",
                "name": "噴泉 Fountain",
                "className": "emoji26f2"
            },
            {
                "icon": "⛱",
                "name": "地上的傘 Umbrella on ground",
                "className": "emoji26f1"
            },
            {
                "icon": "🏖",
                "name": "海灘與傘 Beach with umbrella",
                "className": "emoji1f3d6"
            },
            {
                "icon": "🏝",
                "name": "荒島 Desert island",
                "className": "emoji1f3dd"
            },
            {
                "icon": "🏜",
                "name": "沙漠 Desert",
                "className": "emoji1f3dc"
            },
            {
                "icon": "🌋",
                "name": "火山 Volcano",
                "className": "emoji1f30b"
            },
            {
                "icon": "⛰",
                "name": "山 Mountain",
                "className": "emoji26f0"
            },
            {
                "icon": "🏔",
                "name": "白雪覆蓋的山 Snow capped mountain",
                "className": "emoji1f3d4"
            },
            {
                "icon": "🗻",
                "name": "富士山 Mount fuji",
                "className": "emoji1f5fb"
            },
            {
                "icon": "🏕",
                "name": "露營 Camping",
                "className": "emoji1f3d5"
            },
            {
                "icon": "⛺",
                "name": "帳篷 Tent",
                "className": "emoji26fa"
            },
            {
                "icon": "🏠",
                "name": "住家建築 House building",
                "className": "emoji1f3e0"
            },
            {
                "icon": "🏡",
                "name": "有庭院的房子 House with garden",
                "className": "emoji1f3e1"
            },
            {
                "icon": "🏘",
                "name": "房子 House buildings",
                "className": "emoji1f3d8"
            },
            {
                "icon": "🏚",
                "name": "荒廢的房子 Derelict house building",
                "className": "emoji1f3da"
            },
            {
                "icon": "🏗",
                "name": "建築施工 Building construction",
                "className": "emoji1f3d7"
            },
            {
                "icon": "🏭",
                "name": "工廠 Factory",
                "className": "emoji1f3ed"
            },
            {
                "icon": "🏢",
                "name": "辦公建築 Office building",
                "className": "emoji1f3e2"
            },
            {
                "icon": "🏬",
                "name": "百貨公司 Department store",
                "className": "emoji1f3ec"
            },
            {
                "icon": "🏣",
                "name": "日本郵局 Japanese post office",
                "className": "emoji1f3e3"
            },
            {
                "icon": "🏤",
                "name": "歐洲郵局 European post office",
                "className": "emoji1f3e4"
            },
            {
                "icon": "🏥",
                "name": "醫院 Hospital",
                "className": "emoji1f3e5"
            },
            {
                "icon": "🏦",
                "name": "銀行 Bank",
                "className": "emoji1f3e6"
            },
            {
                "icon": "🏨",
                "name": "飯店 Hotel",
                "className": "emoji1f3e8"
            },
            {
                "icon": "🏪",
                "name": "便利商店 Convenience store",
                "className": "emoji1f3ea"
            },
            {
                "icon": "🏫",
                "name": "學校 School",
                "className": "emoji1f3eb"
            },
            {
                "icon": "🏩",
                "name": "賓館 Love hotel",
                "className": "emoji1f3e9"
            },
            {
                "icon": "💒",
                "name": "婚禮 Wedding",
                "className": "emoji1f492"
            },
            {
                "icon": "🏛",
                "name": "古典建築 Classical building",
                "className": "emoji1f3db"
            },
            {
                "icon": "⛪",
                "name": "教堂 Church",
                "className": "emoji26ea"
            },
            {
                "icon": "🕌",
                "name": "清真寺 Mosque",
                "className": "emoji1f54c"
            },
            {
                "icon": "🕍",
                "name": "猶太教堂 Synagogue",
                "className": "emoji1f54d"
            },
            {
                "icon": "🛕",
                "name": "印度教寺廟 Hindu temple",
                "className": "emoji1f6d5"
            },
            {
                "icon": "🕋",
                "name": "卡巴聖堂 Kaaba",
                "className": "emoji1f54b"
            },
            {
                "icon": "⛩",
                "name": "神社 Shinto shrine",
                "className": "emoji26e9"
            },
            {
                "icon": "🛤",
                "name": "鐵軌 Railway track",
                "className": "emoji1f6e4"
            },
            {
                "icon": "🛣",
                "name": "高速公路 Motorway",
                "className": "emoji1f6e3"
            },
            {
                "icon": "🗾",
                "name": "日本地圖輪廓 Silhouette of japan",
                "className": "emoji1f5fe"
            },
            {
                "icon": "🎑",
                "name": "賞月 Moon viewing ceremony",
                "className": "emoji1f391"
            },
            {
                "icon": "🏞",
                "name": "國家公園 National park",
                "className": "emoji1f3de"
            },
            {
                "icon": "🌅",
                "name": "日出 Sunrise",
                "className": "emoji1f305"
            },
            {
                "icon": "🌄",
                "name": "山頂日出 Sunrise over mountains",
                "className": "emoji1f304"
            },
            {
                "icon": "🌠",
                "name": "流星 Shooting star",
                "className": "emoji1f320"
            },
            {
                "icon": "🎇",
                "name": "仙女棒 Firework sparkler",
                "className": "emoji1f387"
            },
            {
                "icon": "🎆",
                "name": "煙火 Fireworks",
                "className": "emoji1f386"
            },
            {
                "icon": "🌇",
                "name": "高樓日落 Sunset over buildings",
                "className": "emoji1f307"
            },
            {
                "icon": "🌆",
                "name": "城市暮色 Cityscape at dusk",
                "className": "emoji1f306"
            },
            {
                "icon": "🏙",
                "name": "城市景象 Cityscape",
                "className": "emoji1f3d9"
            },
            {
                "icon": "🌃",
                "name": "星夜 Night with stars",
                "className": "emoji1f303"
            },
            {
                "icon": "🌌",
                "name": "銀河 Milky way",
                "className": "emoji1f30c"
            },
            {
                "icon": "🌉",
                "name": "夜晚的橋 Bridge at night",
                "className": "emoji1f309"
            },
            {
                "icon": "🌁",
                "name": "起霧 Foggy",
                "className": "emoji1f301"
            }
        ]
    },
    {
        "name":"物品",
        "list":[
            {
                "icon": "⌚",
                "name": "手錶 Watch",
                "className": "emoji231a"
            },
            {
                "icon": "📱",
                "name": "手機 Mobile phone",
                "className": "emoji1f4f1"
            },
            {
                "icon": "📲",
                "name": "左方有向右箭頭的手機 Mobile phone with rightwards arrow at left",
                "className": "emoji1f4f2"
            },
            {
                "icon": "💻",
                "name": "個人電腦 Personal computer",
                "className": "emoji1f4bb"
            },
            {
                "icon": "⌨",
                "name": "鍵盤 Keyboard",
                "className": "emoji2328"
            },
            {
                "icon": "🖥",
                "name": "桌上型電腦 Desktop computer",
                "className": "emoji1f5a5"
            },
            {
                "icon": "🖨",
                "name": "印表機 Printer",
                "className": "emoji1f5a8"
            },
            {
                "icon": "🖱",
                "name": "三鍵滑鼠 Three button mouse",
                "className": "emoji1f5b1"
            },
            {
                "icon": "🖲",
                "name": "軌跡球 Trackball",
                "className": "emoji1f5b2"
            },
            {
                "icon": "🕹",
                "name": "搖桿 Joystick",
                "className": "emoji1f579"
            },
            {
                "icon": "🗜",
                "name": "壓縮 Compression",
                "className": "emoji1f5dc"
            },
            {
                "icon": "💽",
                "name": "迷你光碟 Minidisc",
                "className": "emoji1f4bd"
            },
            {
                "icon": "💾",
                "name": "磁碟片 Floppy disk",
                "className": "emoji1f4be"
            },
            {
                "icon": "💿",
                "name": "光碟 Optical disc",
                "className": "emoji1f4bf"
            },
            {
                "icon": "📀",
                "name": "DVD Dvd",
                "className": "emoji1f4c0"
            },
            {
                "icon": "📼",
                "name": "錄影帶 Videocassette",
                "className": "emoji1f4fc"
            },
            {
                "icon": "📷",
                "name": "相機 Camera",
                "className": "emoji1f4f7"
            },
            {
                "icon": "📸",
                "name": "有閃光燈的相機 Camera with flash",
                "className": "emoji1f4f8"
            },
            {
                "icon": "📹",
                "name": "攝影機 Video camera",
                "className": "emoji1f4f9"
            },
            {
                "icon": "🎥",
                "name": "電影攝影機 Movie camera",
                "className": "emoji1f3a5"
            },
            {
                "icon": "📽",
                "name": "影片投影機 Film projector",
                "className": "emoji1f4fd"
            },
            {
                "icon": "🎞",
                "name": "膠片幀 Film frames",
                "className": "emoji1f39e"
            },
            {
                "icon": "📞",
                "name": "電話話筒 Telephone receiver",
                "className": "emoji1f4de"
            },
            {
                "icon": "☎",
                "name": "黑色電話 Black telephone",
                "className": "emoji260e"
            },
            {
                "icon": "📟",
                "name": "呼叫器 Pager",
                "className": "emoji1f4df"
            },
            {
                "icon": "📠",
                "name": "傳真機 Fax machine",
                "className": "emoji1f4e0"
            },
            {
                "icon": "📺",
                "name": "電視 Television",
                "className": "emoji1f4fa"
            },
            {
                "icon": "📻",
                "name": "收音機 Radio",
                "className": "emoji1f4fb"
            },
            {
                "icon": "🎙",
                "name": "錄音室麥克風 Studio microphone",
                "className": "emoji1f399"
            },
            {
                "icon": "🎚",
                "name": "程度滑桿 Level slider",
                "className": "emoji1f39a"
            },
            {
                "icon": "🎛",
                "name": "控制旋鈕 Control knobs",
                "className": "emoji1f39b"
            },
            {
                "icon": "🧭",
                "name": "指南針 Compass",
                "className": "emoji1f9ed"
            },
            {
                "icon": "⏱",
                "name": "碼錶 Stopwatch",
                "className": "emoji23f1"
            },
            {
                "icon": "⏲",
                "name": "計時器 Timer clock",
                "className": "emoji23f2"
            },
            {
                "icon": "⏰",
                "name": "鬧鐘 Alarm clock",
                "className": "emoji23f0"
            },
            {
                "icon": "🕰",
                "name": "座鐘 Mantelpiece clock",
                "className": "emoji1f570"
            },
            {
                "icon": "⌛",
                "name": "沙漏 Hourglass",
                "className": "emoji231b"
            },
            {
                "icon": "⏳",
                "name": "沙粒流動中的沙漏 Hourglass with flowing sand",
                "className": "emoji23f3"
            },
            {
                "icon": "📡",
                "name": "衛星天線 Satellite antenna",
                "className": "emoji1f4e1"
            },
            {
                "icon": "🔋",
                "name": "電池 Battery",
                "className": "emoji1f50b"
            },
            {
                "icon": "🔌",
                "name": "插頭 Electric plug",
                "className": "emoji1f50c"
            },
            {
                "icon": "💡",
                "name": "電燈泡 Electric light bulb",
                "className": "emoji1f4a1"
            },
            {
                "icon": "🔦",
                "name": "手電筒 Electric torch",
                "className": "emoji1f526"
            },
            {
                "icon": "🕯",
                "name": "蠟燭 Candle",
                "className": "emoji1f56f"
            },
            {
                "icon": "🪔",
                "name": "迪亞油燈 Diya lamp",
                "className": "emoji1fa94"
            },
            {
                "icon": "🧯",
                "name": "滅火器 Fire extinguisher",
                "className": "emoji1f9ef"
            },
            {
                "icon": "🛢",
                "name": "油桶 Oil drum",
                "className": "emoji1f6e2"
            },
            {
                "icon": "💸",
                "name": "長翅膀的錢 Money with wings",
                "className": "emoji1f4b8"
            },
            {
                "icon": "💵",
                "name": "有美元符號的鈔票 Banknote with dollar sign",
                "className": "emoji1f4b5"
            },
            {
                "icon": "💴",
                "name": "有日幣符號的鈔票 Banknote with yen sign",
                "className": "emoji1f4b4"
            },
            {
                "icon": "💶",
                "name": "有歐元符號的鈔票 Banknote with euro sign",
                "className": "emoji1f4b6"
            },
            {
                "icon": "💷",
                "name": "有英鎊符號的鈔票 Banknote with pound sign",
                "className": "emoji1f4b7"
            },
            {
                "icon": "💰",
                "name": "錢袋 Money bag",
                "className": "emoji1f4b0"
            },
            {
                "icon": "💳",
                "name": "信用卡 Credit card",
                "className": "emoji1f4b3"
            },
            {
                "icon": "💎",
                "name": "寶石 Gem stone",
                "className": "emoji1f48e"
            },
            {
                "icon": "⚖",
                "name": "天秤 Scales",
                "className": "emoji2696"
            },
            {
                "icon": "🧰",
                "name": "工具箱 Toolbox",
                "className": "emoji1f9f0"
            },
            {
                "icon": "🔧",
                "name": "扳手 Wrench",
                "className": "emoji1f527"
            },
            {
                "icon": "🔨",
                "name": "鐵鎚 Hammer",
                "className": "emoji1f528"
            },
            {
                "icon": "⚒",
                "name": "鐵槌與十字鎬 Hammer and pick",
                "className": "emoji2692"
            },
            {
                "icon": "🛠",
                "name": "鐵槌與板手 Hammer and wrench",
                "className": "emoji1f6e0"
            },
            {
                "icon": "⛏",
                "name": "十字鎬 Pick",
                "className": "emoji26cf"
            },
            {
                "icon": "🔩",
                "name": "螺帽與螺栓 Nut and bolt",
                "className": "emoji1f529"
            },
            {
                "icon": "⚙",
                "name": "齒輪 Gear",
                "className": "emoji2699"
            },
            {
                "icon": "🧱",
                "name": "磚 Bricks",
                "className": "emoji1f9f1"
            },
            {
                "icon": "⛓",
                "name": "鏈條 Chains",
                "className": "emoji26d3"
            },
            {
                "icon": "🧲",
                "name": "磁鐵 Magnet",
                "className": "emoji1f9f2"
            },
            {
                "icon": "🔫",
                "name": "手槍 Pistol",
                "className": "emoji1f52b"
            },
            {
                "icon": "💣",
                "name": "炸彈 Bomb",
                "className": "emoji1f4a3"
            },
            {
                "icon": "🧨",
                "name": "鞭炮 Firecracker",
                "className": "emoji1f9e8"
            },
            {
                "icon": "🪓",
                "name": "斧頭 Axe",
                "className": "emoji1fa93"
            },
            {
                "icon": "🔪",
                "name": "日式廚刀 Hocho",
                "className": "emoji1f52a"
            },
            {
                "icon": "🗡",
                "name": "匕首 Dagger knife",
                "className": "emoji1f5e1"
            },
            {
                "icon": "⚔",
                "name": "交叉的劍 Crossed swords",
                "className": "emoji2694"
            },
            {
                "icon": "🛡",
                "name": "盾 Shield",
                "className": "emoji1f6e1"
            },
            {
                "icon": "🚬",
                "name": "吸菸標誌 Smoking symbol",
                "className": "emoji1f6ac"
            },
            {
                "icon": "⚰",
                "name": "棺材 Coffin",
                "className": "emoji26b0"
            },
            {
                "icon": "⚱",
                "name": "骨灰罈 Funeral urn",
                "className": "emoji26b1"
            },
            {
                "icon": "🏺",
                "name": "雙耳細頸瓶 Amphora",
                "className": "emoji1f3fa"
            },
            {
                "icon": "🔮",
                "name": "水晶球 Crystal ball",
                "className": "emoji1f52e"
            },
            {
                "icon": "📿",
                "name": "念珠 Prayer beads",
                "className": "emoji1f4ff"
            },
            {
                "icon": "🧿",
                "name": "護身符 Nazar amulet",
                "className": "emoji1f9ff"
            },
            {
                "icon": "💈",
                "name": "理髮店彩色旋轉燈筒招牌 Barber pole",
                "className": "emoji1f488"
            },
            {
                "icon": "⚗",
                "name": "蒸餾器 Alembic",
                "className": "emoji2697"
            },
            {
                "icon": "🔭",
                "name": "望遠鏡 Telescope",
                "className": "emoji1f52d"
            },
            {
                "icon": "🔬",
                "name": "顯微鏡 Microscope",
                "className": "emoji1f52c"
            },
            {
                "icon": "🕳",
                "name": "洞 Hole",
                "className": "emoji1f573"
            },
            {
                "icon": "🩹",
                "name": "粘性繃帶 Adhesive bandage",
                "className": "emoji1fa79"
            },
            {
                "icon": "🩺",
                "name": "聽診器 Stethoscope",
                "className": "emoji1fa7a"
            },
            {
                "icon": "💊",
                "name": "藥丸 Pill",
                "className": "emoji1f48a"
            },
            {
                "icon": "💉",
                "name": "注射器 Syringe",
                "className": "emoji1f489"
            },
            {
                "icon": "🩸",
                "name": "血滴 Drop of blood",
                "className": "emoji1fa78"
            },
            {
                "icon": "🧬",
                "name": "DNA DNA",
                "className": "emoji1f9ec"
            },
            {
                "icon": "🦠",
                "name": "微生物 Microbe",
                "className": "emoji1f9a0"
            },
            {
                "icon": "🧫",
                "name": "培養皿 Petri dish",
                "className": "emoji1f9eb"
            },
            {
                "icon": "🧪",
                "name": "試管 Test tube",
                "className": "emoji1f9ea"
            },
            {
                "icon": "🌡",
                "name": "溫度計 Thermometer",
                "className": "emoji1f321"
            },
            {
                "icon": "🧹",
                "name": "掃把 Broom",
                "className": "emoji1f9f9"
            },
            {
                "icon": "🧺",
                "name": "籃子 Basket",
                "className": "emoji1f9fa"
            },
            {
                "icon": "🧻",
                "name": "紙捲 Roll of paper",
                "className": "emoji1f9fb"
            },
            {
                "icon": "🚽",
                "name": "馬桶 Toilet",
                "className": "emoji1f6bd"
            },
            {
                "icon": "🚰",
                "name": "飲用水標誌 Potable water symbol",
                "className": "emoji1f6b0"
            },
            {
                "icon": "🚿",
                "name": "淋浴間 Shower",
                "className": "emoji1f6bf"
            },
            {
                "icon": "🛁",
                "name": "浴缸 Bathtub",
                "className": "emoji1f6c1"
            },
            {
                "icon": "🛀",
                "name": "浴室 Bath",
                "className": "emoji1f6c0"
            },
            {
                "icon": "🧼",
                "name": "肥皂 Soap",
                "className": "emoji1f9fc"
            },
            {
                "icon": "🪒",
                "name": "刮鬍刀 Razor",
                "className": "emoji1fa92"
            },
            {
                "icon": "🧽",
                "name": "海綿 Sponge",
                "className": "emoji1f9fd"
            },
            {
                "icon": "🧴",
                "name": "乳液瓶 Lotion bottle",
                "className": "emoji1f9f4"
            },
            {
                "icon": "🛎",
                "name": "服務鈴 Bellhop bell",
                "className": "emoji1f6ce"
            },
            {
                "icon": "🔑",
                "name": "鑰匙 Key",
                "className": "emoji1f511"
            },
            {
                "icon": "🗝",
                "name": "舊鑰匙 Old key",
                "className": "emoji1f5dd"
            },
            {
                "icon": "🚪",
                "name": "門 Door",
                "className": "emoji1f6aa"
            },
            {
                "icon": "🪑",
                "name": "椅子 Chair",
                "className": "emoji1fa91"
            },
            {
                "icon": "🛋",
                "name": "沙發和燈 Couch and lamp",
                "className": "emoji1f6cb"
            },
            {
                "icon": "🛏",
                "name": "床 Bed",
                "className": "emoji1f6cf"
            },
            {
                "icon": "🛌",
                "name": "臥室 Sleeping accommodation",
                "className": "emoji1f6cc"
            },
            {
                "icon": "🧸",
                "name": "泰迪熊 Teddy bear",
                "className": "emoji1f9f8"
            },
            {
                "icon": "🖼",
                "name": "裱框的圖 Frame with picture",
                "className": "emoji1f5bc"
            },
            {
                "icon": "🛍",
                "name": "購物袋 Shopping bags",
                "className": "emoji1f6cd"
            },
            {
                "icon": "🛒",
                "name": "購物車 Shopping cart",
                "className": "emoji1f6d2"
            },
            {
                "icon": "🎁",
                "name": "包裝好的禮物 Wrapped present",
                "className": "emoji1f381"
            },
            {
                "icon": "🎈",
                "name": "氣球 Balloon",
                "className": "emoji1f388"
            },
            {
                "icon": "🎏",
                "name": "鯉魚旗 Carp streamer",
                "className": "emoji1f38f"
            },
            {
                "icon": "🎀",
                "name": "緞帶 Ribbon",
                "className": "emoji1f380"
            },
            {
                "icon": "🎊",
                "name": "五彩碎紙球 Confetti ball",
                "className": "emoji1f38a"
            },
            {
                "icon": "🎉",
                "name": "拉炮 Party popper",
                "className": "emoji1f389"
            },
            {
                "icon": "🎎",
                "name": "日本女兒節人偶 Japanese dolls",
                "className": "emoji1f38e"
            },
            {
                "icon": "🏮",
                "name": "居酒屋燈籠 Izakaya lantern",
                "className": "emoji1f3ee"
            },
            {
                "icon": "🎐",
                "name": "風鈴 Wind chime",
                "className": "emoji1f390"
            },
            {
                "icon": "🧧",
                "name": "紅包 Red envelope",
                "className": "emoji1f9e7"
            },
            {
                "icon": "✉",
                "name": "信封 Envelope",
                "className": "emoji2709"
            },
            {
                "icon": "📩",
                "name": "上方有向下箭頭的信封 Envelope with downwards arrow above",
                "className": "emoji1f4e9"
            },
            {
                "icon": "📨",
                "name": "寄來的信封 Incoming envelope",
                "className": "emoji1f4e8"
            },
            {
                "icon": "📧",
                "name": "電子郵件符號 E-mail symbol",
                "className": "emoji1f4e7"
            },
            {
                "icon": "💌",
                "name": "情書 Love letter",
                "className": "emoji1f48c"
            },
            {
                "icon": "📥",
                "name": "收件匣 Inbox tray",
                "className": "emoji1f4e5"
            },
            {
                "icon": "📤",
                "name": "寄件匣 Outbox tray",
                "className": "emoji1f4e4"
            },
            {
                "icon": "📦",
                "name": "包裹 Package",
                "className": "emoji1f4e6"
            },
            {
                "icon": "🏷",
                "name": "標籤 Label",
                "className": "emoji1f3f7"
            },
            {
                "icon": "📪",
                "name": "關閉且已將旗子拉下的信箱 Closed mailbox with lowered flag",
                "className": "emoji1f4ea"
            },
            {
                "icon": "📫",
                "name": "關閉且已將旗子升起的信箱 Closed mailbox with raised flag",
                "className": "emoji1f4eb"
            },
            {
                "icon": "📬",
                "name": "開啟且已將旗子升起的信箱 Open mailbox with raised flag",
                "className": "emoji1f4ec"
            },
            {
                "icon": "📭",
                "name": "開啟且已將旗子降下的信箱 Open mailbox with lowered flag",
                "className": "emoji1f4ed"
            },
            {
                "icon": "📮",
                "name": "郵筒 Postbox",
                "className": "emoji1f4ee"
            },
            {
                "icon": "📯",
                "name": "急件喇叭 Postal horn",
                "className": "emoji1f4ef"
            },
            {
                "icon": "📜",
                "name": "卷軸 Scroll",
                "className": "emoji1f4dc"
            },
            {
                "icon": "📃",
                "name": "一角捲起的紙頁 Page with curl",
                "className": "emoji1f4c3"
            },
            {
                "icon": "📄",
                "name": "正面朝上的紙頁 Page facing up",
                "className": "emoji1f4c4"
            },
            {
                "icon": "📑",
                "name": "書籤標籤 Bookmark tabs",
                "className": "emoji1f4d1"
            },
            {
                "icon": "🧾",
                "name": "收據 Receipt",
                "className": "emoji1f9fe"
            },
            {
                "icon": "📊",
                "name": "長條圖 Bar chart",
                "className": "emoji1f4ca"
            },
            {
                "icon": "📈",
                "name": "走勢往上的圖表 Chart with upwards trend",
                "className": "emoji1f4c8"
            },
            {
                "icon": "📉",
                "name": "走勢往下的圖表 Chart with downwards trend",
                "className": "emoji1f4c9"
            },
            {
                "icon": "🗒",
                "name": "螺旋筆記本 Spiral note pad",
                "className": "emoji1f5d2"
            },
            {
                "icon": "🗓",
                "name": "螺旋日曆本 Spiral calendar pad",
                "className": "emoji1f5d3"
            },
            {
                "icon": "📆",
                "name": "撕頁式日曆 Tear-off calendar",
                "className": "emoji1f4c6"
            },
            {
                "icon": "📅",
                "name": "日曆 Calendar",
                "className": "emoji1f4c5"
            },
            {
                "icon": "🗑",
                "name": "廢紙簍 Wastebasket",
                "className": "emoji1f5d1"
            },
            {
                "icon": "📇",
                "name": "卡片索引 Card index",
                "className": "emoji1f4c7"
            },
            {
                "icon": "🗃",
                "name": "卡片檔案盒 Card file box",
                "className": "emoji1f5c3"
            },
            {
                "icon": "🗳",
                "name": "投票箱與選票 Ballot box with ballot",
                "className": "emoji1f5f3"
            },
            {
                "icon": "🗄",
                "name": "檔案櫃 File cabinet",
                "className": "emoji1f5c4"
            },
            {
                "icon": "📋",
                "name": "剪貼簿 Clipboard",
                "className": "emoji1f4cb"
            },
            {
                "icon": "📁",
                "name": "文件夾 File folder",
                "className": "emoji1f4c1"
            },
            {
                "icon": "📂",
                "name": "開啟的文件夾 Open file folder",
                "className": "emoji1f4c2"
            },
            {
                "icon": "🗂",
                "name": "索引卡隔板 Card index dividers",
                "className": "emoji1f5c2"
            },
            {
                "icon": "🗞",
                "name": "捲起的報紙 Rolled-up newspaper",
                "className": "emoji1f5de"
            },
            {
                "icon": "📰",
                "name": "報紙 Newspaper",
                "className": "emoji1f4f0"
            },
            {
                "icon": "📓",
                "name": "筆記本 Notebook",
                "className": "emoji1f4d3"
            },
            {
                "icon": "📔",
                "name": "有裝飾性封面的筆記本 Notebook with decorative cover",
                "className": "emoji1f4d4"
            },
            {
                "icon": "📒",
                "name": "分類帳 Ledger",
                "className": "emoji1f4d2"
            },
            {
                "icon": "📕",
                "name": "闔上的書 Closed book",
                "className": "emoji1f4d5"
            },
            {
                "icon": "📗",
                "name": "綠色的書 Green book",
                "className": "emoji1f4d7"
            },
            {
                "icon": "📘",
                "name": "藍色的書 Blue book",
                "className": "emoji1f4d8"
            },
            {
                "icon": "📙",
                "name": "橘色的書 Orange book",
                "className": "emoji1f4d9"
            },
            {
                "icon": "📚",
                "name": "書籍 Books",
                "className": "emoji1f4da"
            },
            {
                "icon": "📖",
                "name": "翻開的書 Open book",
                "className": "emoji1f4d6"
            },
            {
                "icon": "🔖",
                "name": "書籤 Bookmark",
                "className": "emoji1f516"
            },
            {
                "icon": "🧷",
                "name": "安全別針 Safety pin",
                "className": "emoji1f9f7"
            },
            {
                "icon": "🔗",
                "name": "連結符號 Link symbol",
                "className": "emoji1f517"
            },
            {
                "icon": "📎",
                "name": "迴紋針 Paperclip",
                "className": "emoji1f4ce"
            },
            {
                "icon": "🖇",
                "name": "連接的迴紋針 Linked paperclips",
                "className": "emoji1f587"
            },
            {
                "icon": "📐",
                "name": "三角板 Triangular ruler",
                "className": "emoji1f4d0"
            },
            {
                "icon": "📏",
                "name": "直尺 Straight ruler",
                "className": "emoji1f4cf"
            },
            {
                "icon": "🧮",
                "name": "算盤 Abacus",
                "className": "emoji1f9ee"
            },
            {
                "icon": "📌",
                "name": "圖釘 Pushpin",
                "className": "emoji1f4cc"
            },
            {
                "icon": "📍",
                "name": "圓頭圖釘 Round pushpin",
                "className": "emoji1f4cd"
            },
            {
                "icon": "✂",
                "name": "黑色剪刀 Black scissors",
                "className": "emoji2702"
            },
            {
                "icon": "🖊",
                "name": "指向左下的原子筆 Lower left ballpoint pen",
                "className": "emoji1f58a"
            },
            {
                "icon": "🖋",
                "name": "指向左下的鋼筆 Lower left fountain pen",
                "className": "emoji1f58b"
            },
            {
                "icon": "✒",
                "name": "黑色鋼筆筆尖 Black nib",
                "className": "emoji2712"
            },
            {
                "icon": "🖌",
                "name": "指向左下的畫筆 Lower left paintbrush",
                "className": "emoji1f58c"
            },
            {
                "icon": "🖍",
                "name": "指向左下的蠟筆 Lower left crayon",
                "className": "emoji1f58d"
            },
            {
                "icon": "📝",
                "name": "筆記 Memo",
                "className": "emoji1f4dd"
            },
            {
                "icon": "✏",
                "name": "鉛筆 Pencil",
                "className": "emoji270f"
            },
            {
                "icon": "🔍",
                "name": "朝向左邊的放大鏡 Left-pointing magnifying glass",
                "className": "emoji1f50d"
            },
            {
                "icon": "🔎",
                "name": "朝向右邊的放大鏡 Right-pointing magnifying glass",
                "className": "emoji1f50e"
            },
            {
                "icon": "🔏",
                "name": "鎖頭和鋼筆 Lock with ink pen",
                "className": "emoji1f50f"
            },
            {
                "icon": "🔐",
                "name": "關上的鎖頭和鑰匙 Closed lock with key",
                "className": "emoji1f510"
            },
            {
                "icon": "🔒",
                "name": "鎖頭 Lock",
                "className": "emoji1f512"
            },
            {
                "icon": "🔓",
                "name": "打開的鎖頭 Open lock",
                "className": "emoji1f513"
            },
            {
                "icon": "🧶",
                "name": "紗繩 Yarn",
                "className": "emoji1f9f6"
            },
            {
                "icon": "🧵",
                "name": "對話串 Thread",
                "className": "emoji1f9f5"
            },
            {
                "icon": "🧥",
                "name": "外套 Coat",
                "className": "emoji1f9e5"
            },
            {
                "icon": "🥼",
                "name": "白袍 Lab coat",
                "className": "emoji1f97c"
            },
            {
                "icon": "🦺",
                "name": "安全背心 Safety vest",
                "className": "emoji1f9ba"
            },
            {
                "icon": "👚",
                "name": "女裝 Womans clothes",
                "className": "emoji1f45a"
            },
            {
                "icon": "👕",
                "name": "T 恤 T-shirt",
                "className": "emoji1f455"
            },
            {
                "icon": "👖",
                "name": "牛仔褲 Jeans",
                "className": "emoji1f456"
            },
            {
                "icon": "🩲",
                "name": "內褲 Briefs",
                "className": "emoji1fa72"
            },
            {
                "icon": "🩳",
                "name": "短褲 Shorts",
                "className": "emoji1fa73"
            },
            {
                "icon": "👔",
                "name": "領帶 Necktie",
                "className": "emoji1f454"
            },
            {
                "icon": "👗",
                "name": "洋裝 Dress",
                "className": "emoji1f457"
            },
            {
                "icon": "👙",
                "name": "比基尼 Bikini",
                "className": "emoji1f459"
            },
            {
                "icon": "👘",
                "name": "和服 Kimono",
                "className": "emoji1f458"
            },
            {
                "icon": "🥻",
                "name": "紗麗 Sari",
                "className": "emoji1f97b"
            },
            {
                "icon": "🩱",
                "name": "一件式 One-piece",
                "className": "emoji1fa71"
            },
            {
                "icon": "🥿",
                "name": "平底鞋 Woman’s flat shoe",
                "className": "emoji1f97f"
            },
            {
                "icon": "👠",
                "name": "高跟鞋 High-heeled shoe",
                "className": "emoji1f460"
            },
            {
                "icon": "👡",
                "name": "女用涼鞋 Womans sandal",
                "className": "emoji1f461"
            },
            {
                "icon": "👢",
                "name": "女靴 Womans boots",
                "className": "emoji1f462"
            },
            {
                "icon": "👞",
                "name": "男鞋 Mans shoe",
                "className": "emoji1f45e"
            },
            {
                "icon": "👟",
                "name": "運動鞋 Athletic shoe",
                "className": "emoji1f45f"
            },
            {
                "icon": "🥾",
                "name": "登山鞋 Hiking boot",
                "className": "emoji1f97e"
            },
            {
                "icon": "🧦",
                "name": "襪子 Socks",
                "className": "emoji1f9e6"
            },
            {
                "icon": "🧤",
                "name": "手套 Gloves",
                "className": "emoji1f9e4"
            },
            {
                "icon": "🧣",
                "name": "圍巾 Scarf",
                "className": "emoji1f9e3"
            },
            {
                "icon": "🎩",
                "name": "高帽子 Top hat",
                "className": "emoji1f3a9"
            },
            {
                "icon": "🧢",
                "name": "鴨舌帽 Billed cap",
                "className": "emoji1f9e2"
            },
            {
                "icon": "👒",
                "name": "女帽 Womans hat",
                "className": "emoji1f452"
            },
            {
                "icon": "🎓",
                "name": "學士帽 Graduation cap",
                "className": "emoji1f393"
            },
            {
                "icon": "⛑",
                "name": "有白色十字的安全帽 Helmet with white cross",
                "className": "emoji26d1"
            },
            {
                "icon": "👑",
                "name": "皇冠 Crown",
                "className": "emoji1f451"
            },
            {
                "icon": "💍",
                "name": "戒指 Ring",
                "className": "emoji1f48d"
            },
            {
                "icon": "👝",
                "name": "小袋子 Pouch",
                "className": "emoji1f45d"
            },
            {
                "icon": "👛",
                "name": "錢包 Purse",
                "className": "emoji1f45b"
            },
            {
                "icon": "👜",
                "name": "手提包 Handbag",
                "className": "emoji1f45c"
            },
            {
                "icon": "💼",
                "name": "公事包 Briefcase",
                "className": "emoji1f4bc"
            },
            {
                "icon": "🎒",
                "name": "書包 School satchel",
                "className": "emoji1f392"
            },
            {
                "icon": "🧳",
                "name": "行李 Luggage",
                "className": "emoji1f9f3"
            },
            {
                "icon": "👓",
                "name": "眼鏡 Eyeglasses",
                "className": "emoji1f453"
            },
            {
                "icon": "🕶",
                "name": "深色太陽眼鏡 Dark sunglasses",
                "className": "emoji1f576"
            },
            {
                "icon": "🥽",
                "name": "護目鏡 Goggles",
                "className": "emoji1f97d"
            },
            {
                "icon": "🌂",
                "name": "收起的雨傘 Closed umbrella",
                "className": "emoji1f302"
            }
        ]
    },
    {
        "name":"符號",
        "list":[
            {
                "icon": "❤",
                "name": "加粗的黑色愛心 Heavy black heart",
                "className": "emoji2764"
            },
            {
                "icon": "🧡",
                "name": "橙色愛心 Orange heart",
                "className": "emoji1f9e1"
            },
            {
                "icon": "💛",
                "name": "黃色愛心 Yellow heart",
                "className": "emoji1f49b"
            },
            {
                "icon": "💚",
                "name": "綠色愛心 Green heart",
                "className": "emoji1f49a"
            },
            {
                "icon": "💙",
                "name": "藍色愛心 Blue heart",
                "className": "emoji1f499"
            },
            {
                "icon": "💜",
                "name": "紫色愛心 Purple heart",
                "className": "emoji1f49c"
            },
            {
                "icon": "🖤",
                "name": "黑心 Black heart",
                "className": "emoji1f5a4"
            },
            {
                "icon": "🤍",
                "name": "白色愛心 White heart",
                "className": "emoji1f90d"
            },
            {
                "icon": "🤎",
                "name": "棕色愛心 Brown heart",
                "className": "emoji1f90e"
            },
            {
                "icon": "💔",
                "name": "碎裂的心 Broken heart",
                "className": "emoji1f494"
            },
            {
                "icon": "❣",
                "name": "愛心驚嘆號 Heavy heart exclamation mark ornament",
                "className": "emoji2763"
            },
            {
                "icon": "💕",
                "name": "兩顆愛心 Two hearts",
                "className": "emoji1f495"
            },
            {
                "icon": "💞",
                "name": "旋轉的愛心 Revolving hearts",
                "className": "emoji1f49e"
            },
            {
                "icon": "💓",
                "name": "跳動的心 Beating heart",
                "className": "emoji1f493"
            },
            {
                "icon": "💗",
                "name": "變大的愛心 Growing heart",
                "className": "emoji1f497"
            },
            {
                "icon": "💖",
                "name": "閃閃發光的愛心 Sparkling heart",
                "className": "emoji1f496"
            },
            {
                "icon": "💘",
                "name": "一箭穿心 Heart with arrow",
                "className": "emoji1f498"
            },
            {
                "icon": "💝",
                "name": "綁上緞帶的愛心 Heart with ribbon",
                "className": "emoji1f49d"
            },
            {
                "icon": "💟",
                "name": "心形裝飾 Heart decoration",
                "className": "emoji1f49f"
            },
            {
                "icon": "☮",
                "name": "和平標誌 Peace symbol",
                "className": "emoji262e"
            },
            {
                "icon": "✝",
                "name": "拉丁十字 Latin cross",
                "className": "emoji271d"
            },
            {
                "icon": "☪",
                "name": "星月 Star and crescent",
                "className": "emoji262a"
            },
            {
                "icon": "🕉",
                "name": "梵文唵標誌 Om symbol",
                "className": "emoji1f549"
            },
            {
                "icon": "☸",
                "name": "法輪 Wheel of dharma",
                "className": "emoji2638"
            },
            {
                "icon": "✡",
                "name": "大衛星 Star of David",
                "className": "emoji2721"
            },
            {
                "icon": "🔯",
                "name": "中間有一個點的六角星 Six pointed star with middle dot",
                "className": "emoji1f52f"
            },
            {
                "icon": "🕎",
                "name": "九盞燈燭台 Menorah with nine branches",
                "className": "emoji1f54e"
            },
            {
                "icon": "☯",
                "name": "陰陽 Yin yang",
                "className": "emoji262f"
            },
            {
                "icon": "☦",
                "name": "正教會十字 Orthodox cross",
                "className": "emoji2626"
            },
            {
                "icon": "🛐",
                "name": "禮拜地點 Place of worship",
                "className": "emoji1f6d0"
            },
            {
                "icon": "⛎",
                "name": "蛇夫座 Ophiuchus",
                "className": "emoji26ce"
            },
            {
                "icon": "♈",
                "name": "牡羊座 Aries",
                "className": "emoji2648"
            },
            {
                "icon": "♉",
                "name": "金牛座 Taurus",
                "className": "emoji2649"
            },
            {
                "icon": "♊",
                "name": "雙子座 Gemini",
                "className": "emoji264a"
            },
            {
                "icon": "♋",
                "name": "巨蟹座 Cancer",
                "className": "emoji264b"
            },
            {
                "icon": "♌",
                "name": "獅子座 Leo",
                "className": "emoji264c"
            },
            {
                "icon": "♍",
                "name": "處女座 Virgo",
                "className": "emoji264d"
            },
            {
                "icon": "♎",
                "name": "天秤座 Libra",
                "className": "emoji264e"
            },
            {
                "icon": "♏",
                "name": "天蠍座 Scorpius",
                "className": "emoji264f"
            },
            {
                "icon": "♐",
                "name": "射手座 Sagittarius",
                "className": "emoji2650"
            },
            {
                "icon": "♑",
                "name": "摩羯座 Capricorn",
                "className": "emoji2651"
            },
            {
                "icon": "♒",
                "name": "水瓶座 Aquarius",
                "className": "emoji2652"
            },
            {
                "icon": "♓",
                "name": "雙魚座 Pisces",
                "className": "emoji2653"
            },
            {
                "icon": "🆔",
                "name": "方框 ID Squared ID",
                "className": "emoji1f194"
            },
            {
                "icon": "⚛",
                "name": "原子標誌 Atom symbol",
                "className": "emoji269b"
            },
            {
                "icon": "🉑",
                "name": "圓圈形的表意字元「接受」 Circled ideograph accept",
                "className": "emoji1f251"
            },
            {
                "icon": "☢",
                "name": "放射性標誌 Radioactive sign",
                "className": "emoji2622"
            },
            {
                "icon": "☣",
                "name": "生物危害標誌 Biohazard sign",
                "className": "emoji2623"
            },
            {
                "icon": "📴",
                "name": "手機關機 Mobile phone off",
                "className": "emoji1f4f4"
            },
            {
                "icon": "📳",
                "name": "振動模式 Vibration mode",
                "className": "emoji1f4f3"
            },
            {
                "icon": "🈶",
                "name": "方框表意字元「收費」 Squared ideograph paid",
                "className": "emoji1f236"
            },
            {
                "icon": "🈚",
                "name": "方框表意字元「免費」 Squared ideograph charge-free",
                "className": "emoji1f21a"
            },
            {
                "icon": "🈸",
                "name": "方框表意字元「申請」 Squared ideograph application",
                "className": "emoji1f238"
            },
            {
                "icon": "🈺",
                "name": "方框表意字元「營業中」 Squared ideograph in business",
                "className": "emoji1f23a"
            },
            {
                "icon": "🈷",
                "name": "方框表意字元「每月」 Squared ideograph monthly",
                "className": "emoji1f237"
            },
            {
                "icon": "✴",
                "name": "黑色八角星形 Eight pointed black star",
                "className": "emoji2734"
            },
            {
                "icon": "🆚",
                "name": "方框 VS Squared vs",
                "className": "emoji1f19a"
            },
            {
                "icon": "💮",
                "name": "白花 White flower",
                "className": "emoji1f4ae"
            },
            {
                "icon": "🉐",
                "name": "圓圈形的表意字元「特惠」 Circled ideograph advantage",
                "className": "emoji1f250"
            },
            {
                "icon": "㊙",
                "name": "圓圈形的表意字元「秘密」 Circled ideograph secret",
                "className": "emoji3299"
            },
            {
                "icon": "㊗",
                "name": "圓圈形的表意字元「祝賀」 Circled ideograph congratulation",
                "className": "emoji3297"
            },
            {
                "icon": "🈴",
                "name": "方框表意字元「同意」 Squared ideograph acceptance",
                "className": "emoji1f234"
            },
            {
                "icon": "🈵",
                "name": "方框表意字元「已滿」 Squared ideograph full occupancy",
                "className": "emoji1f235"
            },
            {
                "icon": "🈹",
                "name": "方框表意字元「折扣」 Squared ideograph discount",
                "className": "emoji1f239"
            },
            {
                "icon": "🈲",
                "name": "方框表意字元「禁止」 Squared ideograph prohibitation",
                "className": "emoji1f232"
            },
            {
                "icon": "🅰",
                "name": "血型 A 型 Blood type A",
                "className": "emoji1f170"
            },
            {
                "icon": "🅱",
                "name": "血型 B 型 Blood type B",
                "className": "emoji1f171"
            },
            {
                "icon": "🆎",
                "name": "血型 AB 型 Blood type AB",
                "className": "emoji1f18e"
            },
            {
                "icon": "🆑",
                "name": "方框 CL Squared CL",
                "className": "emoji1f191"
            },
            {
                "icon": "🅾",
                "name": "血型 O 型 Blood type O",
                "className": "emoji1f17e"
            },
            {
                "icon": "🆘",
                "name": "方框 SOS Squared SOS",
                "className": "emoji1f198"
            },
            {
                "icon": "❌",
                "name": "交叉記號 Cross mark",
                "className": "emoji274c"
            },
            {
                "icon": "⭕",
                "name": "加粗的大型圓形 Heavy large circle",
                "className": "emoji2b55"
            },
            {
                "icon": "🛑",
                "name": "八邊形符號 Stop sign",
                "className": "emoji1f6d1"
            },
            {
                "icon": "⛔",
                "name": "禁止進入 No entry",
                "className": "emoji26d4"
            },
            {
                "icon": "📛",
                "name": "識別證 Name badge",
                "className": "emoji1f4db"
            },
            {
                "icon": "🚫",
                "name": "禁止進入標誌 No entry sign",
                "className": "emoji1f6ab"
            },
            {
                "icon": "💯",
                "name": "一百分符號 Hundred points symbol",
                "className": "emoji1f4af"
            },
            {
                "icon": "💢",
                "name": "生氣符號 Anger symbol",
                "className": "emoji1f4a2"
            },
            {
                "icon": "♨",
                "name": "溫泉 Hot springs",
                "className": "emoji2668"
            },
            {
                "icon": "🚷",
                "name": "禁止行人通行 No pedestrians",
                "className": "emoji1f6b7"
            },
            {
                "icon": "🚯",
                "name": "請勿亂丟垃圾標誌 Do not litter symbol",
                "className": "emoji1f6af"
            },
            {
                "icon": "🚳",
                "name": "禁帶腳踏車 No bicycles",
                "className": "emoji1f6b3"
            },
            {
                "icon": "🚱",
                "name": "非飲用水標誌 Non-potable water symbol",
                "className": "emoji1f6b1"
            },
            {
                "icon": "🔞",
                "name": "18 禁符號 No one under eighteen symbol",
                "className": "emoji1f51e"
            },
            {
                "icon": "📵",
                "name": "禁止使用手機 No mobile phones",
                "className": "emoji1f4f5"
            },
            {
                "icon": "🚭",
                "name": "禁菸標誌 No smoking symbol",
                "className": "emoji1f6ad"
            },
            {
                "icon": "❗",
                "name": "加粗的驚嘆號符號 Heavy exclamation mark symbol",
                "className": "emoji2757"
            },
            {
                "icon": "❕",
                "name": "白色驚嘆號裝飾 White exclamation mark ornament",
                "className": "emoji2755"
            },
            {
                "icon": "❓",
                "name": "黑色問號裝飾 Black question mark ornament",
                "className": "emoji2753"
            },
            {
                "icon": "❔",
                "name": "白色問號裝飾 White question mark ornament",
                "className": "emoji2754"
            },
            {
                "icon": "‼",
                "name": "雙驚嘆號 Double exclamation mark",
                "className": "emoji203c"
            },
            {
                "icon": "⁉",
                "name": "驚嘆號和問號 Exclamation question mark",
                "className": "emoji2049"
            },
            {
                "icon": "🔅",
                "name": "低亮度符號 Low brightness symbol",
                "className": "emoji1f505"
            },
            {
                "icon": "🔆",
                "name": "高亮度符號 High brightness symbol",
                "className": "emoji1f506"
            },
            {
                "icon": "〽",
                "name": "歌謠標記 Part alternation mark",
                "className": "emoji303d"
            },
            {
                "icon": "⚠",
                "name": "警告標誌 Warning sign",
                "className": "emoji26a0"
            },
            {
                "icon": "🚸",
                "name": "注意兒童穿越馬路 Children crossing",
                "className": "emoji1f6b8"
            },
            {
                "icon": "🔱",
                "name": "三插戟圖騰 Trident emblem",
                "className": "emoji1f531"
            },
            {
                "icon": "⚜",
                "name": "百合花飾 Fleur-de-lis",
                "className": "emoji269c"
            },
            {
                "icon": "🔰",
                "name": "日本的新手符號 Japanese symbol for beginner",
                "className": "emoji1f530"
            },
            {
                "icon": "♻",
                "name": "黑色的國際通用資源回收符號 Black universal recycling symbol",
                "className": "emoji267b"
            },
            {
                "icon": "✅",
                "name": "加粗的白色打勾記號 White heavy check mark",
                "className": "emoji2705"
            },
            {
                "icon": "🈯",
                "name": "方框表意字元「對號座」 Squared ideograph reserved-seat",
                "className": "emoji1f22f"
            },
            {
                "icon": "💹",
                "name": "有日圓符號且走勢往上的圖表 Chart with upwards trend and yen sign",
                "className": "emoji1f4b9"
            },
            {
                "icon": "❇",
                "name": "火花 Sparkle",
                "className": "emoji2747"
            },
            {
                "icon": "✳",
                "name": "八角星芒 Eight spoked asterisk",
                "className": "emoji2733"
            },
            {
                "icon": "❎",
                "name": "反白方框打叉記號 Negative squared cross mark",
                "className": "emoji274e"
            },
            {
                "icon": "🌐",
                "name": "有經線的地球 Globe with meridians",
                "className": "emoji1f310"
            },
            {
                "icon": "💠",
                "name": "中間有一個點的鑽石形狀 Diamond shape with a dot inside",
                "className": "emoji1f4a0"
            },
            {
                "icon": "Ⓜ",
                "name": "圓圈中的大寫字母 M Circled latin capital letter m",
                "className": "emoji24c2"
            },
            {
                "icon": "🌀",
                "name": "氣旋 Cyclone",
                "className": "emoji1f300"
            },
            {
                "icon": "💤",
                "name": "想睡符號 Sleeping symbol",
                "className": "emoji1f4a4"
            },
            {
                "icon": "🏧",
                "name": "自動櫃員機 Automated teller machine",
                "className": "emoji1f3e7"
            },
            {
                "icon": "🚾",
                "name": "廁所 Water closet",
                "className": "emoji1f6be"
            },
            {
                "icon": "♿",
                "name": "輪椅符號 Wheelchair symbol",
                "className": "emoji267f"
            },
            {
                "icon": "🅿",
                "name": "停車場 Parking lot",
                "className": "emoji1f17f"
            },
            {
                "icon": "🈳",
                "name": "方框表意字元「空位」 Squared ideograph vacancy",
                "className": "emoji1f233"
            },
            {
                "icon": "🈂",
                "name": "方框片假名「服務」 Squared katakana service",
                "className": "emoji1f202"
            },
            {
                "icon": "🛂",
                "name": "護照查驗處 Passport control",
                "className": "emoji1f6c2"
            },
            {
                "icon": "🛃",
                "name": "海關 Customs",
                "className": "emoji1f6c3"
            },
            {
                "icon": "🛄",
                "name": "行李領取處 Baggage claim",
                "className": "emoji1f6c4"
            },
            {
                "icon": "🛅",
                "name": "行李寄存處 Left luggage",
                "className": "emoji1f6c5"
            },
            {
                "icon": "🚹",
                "name": "男性符號 Mens symbol",
                "className": "emoji1f6b9"
            },
            {
                "icon": "🚺",
                "name": "女性符號 Womens symbol",
                "className": "emoji1f6ba"
            },
            {
                "icon": "🚼",
                "name": "嬰兒符號 Baby symbol",
                "className": "emoji1f6bc"
            },
            {
                "icon": "🚻",
                "name": "洗手間 Restroom",
                "className": "emoji1f6bb"
            },
            {
                "icon": "🚮",
                "name": "請正確丟棄垃圾標誌 Put litter in its place symbol",
                "className": "emoji1f6ae"
            },
            {
                "icon": "🎦",
                "name": "電影 Cinema",
                "className": "emoji1f3a6"
            },
            {
                "icon": "📶",
                "name": "含訊號格的天線 Antenna with bars",
                "className": "emoji1f4f6"
            },
            {
                "icon": "🈁",
                "name": "方框片假名「這裡」 Squared katakana here",
                "className": "emoji1f201"
            },
            {
                "icon": "🔣",
                "name": "符號輸入符號 Input symbol for symbols",
                "className": "emoji1f523"
            },
            {
                "icon": "ℹ",
                "name": "資訊來源 Information source",
                "className": "emoji2139"
            },
            {
                "icon": "🔤",
                "name": "拉丁字母輸入符號 Input symbol for latin letters",
                "className": "emoji1f524"
            },
            {
                "icon": "🔡",
                "name": "小寫拉丁字母輸入符號 Input symbol for latin small letters",
                "className": "emoji1f521"
            },
            {
                "icon": "🔠",
                "name": "大寫拉丁字母輸入符號 Input symbol for latin capital letters",
                "className": "emoji1f520"
            },
            {
                "icon": "🆖",
                "name": "方框 NG Squared N G",
                "className": "emoji1f196"
            },
            {
                "icon": "🆗",
                "name": "方框 OK Squared OK",
                "className": "emoji1f197"
            },
            {
                "icon": "🆙",
                "name": "方框 UP 和驚嘆號 Squared up with exclamation mark",
                "className": "emoji1f199"
            },
            {
                "icon": "🆒",
                "name": "方框 COOL Squared cool",
                "className": "emoji1f192"
            },
            {
                "icon": "🆕",
                "name": "方框 NEW Squared new",
                "className": "emoji1f195"
            },
            {
                "icon": "🆓",
                "name": "方框 FREE Squared free",
                "className": "emoji1f193"
            },
            {
                "icon": "0⃣",
                "name": "鍵帽數字 0 Keycap digit zero",
                "className": "emoji30-20e3"
            },
            {
                "icon": "1⃣",
                "name": "鍵帽數字 1 Keycap digit one",
                "className": "emoji31-20e3"
            },
            {
                "icon": "2⃣",
                "name": "鍵帽數字 2 Keycap digit two",
                "className": "emoji32-20e3"
            },
            {
                "icon": "3⃣",
                "name": "鍵帽數字 3 Keycap digit three",
                "className": "emoji33-20e3"
            },
            {
                "icon": "4⃣",
                "name": "鍵帽數字 4 Keycap digit four",
                "className": "emoji34-20e3"
            },
            {
                "icon": "5⃣",
                "name": "鍵帽數字 5 Keycap digit five",
                "className": "emoji35-20e3"
            },
            {
                "icon": "6⃣",
                "name": "鍵帽數字 6 Keycap digit six",
                "className": "emoji36-20e3"
            },
            {
                "icon": "7⃣",
                "name": "鍵帽數字 7 Keycap digit seven",
                "className": "emoji37-20e3"
            },
            {
                "icon": "8⃣",
                "name": "鍵帽數字 8 Keycap digit eight",
                "className": "emoji38-20e3"
            },
            {
                "icon": "9⃣",
                "name": "鍵帽數字 9 Keycap digit nine",
                "className": "emoji39-20e3"
            },
            {
                "icon": "🔟",
                "name": "鍵帽 10 Keycap ten",
                "className": "emoji1f51f"
            },
            {
                "icon": "🔢",
                "name": "數字輸入符號 Input symbol for numbers",
                "className": "emoji1f522"
            },
            {
                "icon": "#⃣",
                "name": "鍵帽數字標誌 Keycap number sign",
                "className": "emoji23-20e3"
            },
            {
                "icon": "*⃣",
                "name": "鍵帽星號 Keycap asterisk",
                "className": "emoji2a-20e3"
            },
            {
                "icon": "⏏",
                "name": "退出標誌 Eject symbol",
                "className": "emoji23cf"
            },
            {
                "icon": "▶",
                "name": "指向右邊的黑色三角形 Black right-pointing triangle",
                "className": "emoji25b6"
            },
            {
                "icon": "⏸",
                "name": "雙重垂直線 Double vertical bar",
                "className": "emoji23f8"
            },
            {
                "icon": "⏯",
                "name": "向右指三角形與雙重垂直線 Black right-pointing triangle with double vertical bar",
                "className": "emoji23ef"
            },
            {
                "icon": "⏹",
                "name": "停止方形 Black square for stop",
                "className": "emoji23f9"
            },
            {
                "icon": "⏺",
                "name": "錄製圓形 Black circle for record",
                "className": "emoji23fa"
            },
            {
                "icon": "⏭",
                "name": "向右指雙重三角形與垂直線 Black right-pointing double triangle with vertical bar",
                "className": "emoji23ed"
            },
            {
                "icon": "⏮",
                "name": "向左指雙重三角形與垂直線 Black left-pointing double triangle with vertical bar",
                "className": "emoji23ee"
            },
            {
                "icon": "⏩",
                "name": "指向右邊的兩個黑色三角形 Black right-pointing double triangle",
                "className": "emoji23e9"
            },
            {
                "icon": "⏪",
                "name": "指向左邊的兩個黑色三角形 Black left-pointing double triangle",
                "className": "emoji23ea"
            },
            {
                "icon": "⏫",
                "name": "指向上方的兩個黑色三角形 Black up-pointing double triangle",
                "className": "emoji23eb"
            },
            {
                "icon": "⏬",
                "name": "指向下方的兩個黑色三角形 Black down-pointing double triangle",
                "className": "emoji23ec"
            },
            {
                "icon": "◀",
                "name": "指向左邊的黑色三角形 Black left-pointing triangle",
                "className": "emoji25c0"
            },
            {
                "icon": "🔼",
                "name": "往上的小型紅色三角形 Up-pointing small red triangle",
                "className": "emoji1f53c"
            },
            {
                "icon": "🔽",
                "name": "往下的小型紅色三角形 Down-pointing small red triangle",
                "className": "emoji1f53d"
            },
            {
                "icon": "➡",
                "name": "黑色向右箭頭 Black rightwards arrow",
                "className": "emoji27a1"
            },
            {
                "icon": "⬅",
                "name": "黑色向左箭頭 Leftwards black arrow",
                "className": "emoji2b05"
            },
            {
                "icon": "⬆",
                "name": "黑色向上箭頭 Upwards black arrow",
                "className": "emoji2b06"
            },
            {
                "icon": "⬇",
                "name": "黑色向下箭頭 Downwards black arrow",
                "className": "emoji2b07"
            },
            {
                "icon": "↗",
                "name": "東北方箭頭 North east arrow",
                "className": "emoji2197"
            },
            {
                "icon": "↘",
                "name": "東南方箭頭 South east arrow",
                "className": "emoji2198"
            },
            {
                "icon": "↙",
                "name": "西南方箭頭 South west arrow",
                "className": "emoji2199"
            },
            {
                "icon": "↖",
                "name": "西北方箭頭 North west arrow",
                "className": "emoji2196"
            },
            {
                "icon": "↕",
                "name": "上下箭頭 Up down arrow",
                "className": "emoji2195"
            },
            {
                "icon": "↔",
                "name": "左右箭頭 Left right arrow",
                "className": "emoji2194"
            },
            {
                "icon": "↪",
                "name": "鉤狀向右箭頭 Rightwards arrow with hook",
                "className": "emoji21aa"
            },
            {
                "icon": "↩",
                "name": "向左勾箭頭 Leftwards arrow with hook",
                "className": "emoji21a9"
            },
            {
                "icon": "⤴",
                "name": "先向右再往上彎曲的箭頭 Arrow pointing rightwards then curving upwards",
                "className": "emoji2934"
            },
            {
                "icon": "⤵",
                "name": "先向右再往下彎曲的箭頭 Arrow pointing rightwards then curving downwards",
                "className": "emoji2935"
            },
            {
                "icon": "🔀",
                "name": "扭轉向右的兩個箭頭 Twisted rightwards arrows",
                "className": "emoji1f500"
            },
            {
                "icon": "🔁",
                "name": "順時針向右和向左繞成開放式圓圈的箭頭 Clockwise rightwards and leftwards open circle arrows",
                "className": "emoji1f501"
            },
            {
                "icon": "🔂",
                "name": "順時針向右和向左繞成開放式圓圈的箭頭，上面有圈起來的 1 Clockwise rightwards and leftwards open circle arrows with circled one overlay",
                "className": "emoji1f502"
            },
            {
                "icon": "🔄",
                "name": "逆時針向下和向上繞成開放式圓圈的箭頭 Anticlockwise downwards and upwards open circle arrows",
                "className": "emoji1f504"
            },
            {
                "icon": "🔃",
                "name": "順時針向下和向上繞成開放式圓圈的箭頭 Clockwise downwards and upwards open circle arrows",
                "className": "emoji1f503"
            },
            {
                "icon": "🎵",
                "name": "音符 Musical note",
                "className": "emoji1f3b5"
            },
            {
                "icon": "🎶",
                "name": "許多音符 Multiple musical notes",
                "className": "emoji1f3b6"
            },
            {
                "icon": "➕",
                "name": "加粗的加號 Heavy plus sign",
                "className": "emoji2795"
            },
            {
                "icon": "➖",
                "name": "加粗的減號 Heavy minus sign",
                "className": "emoji2796"
            },
            {
                "icon": "➗",
                "name": "加粗的除號 Heavy division sign",
                "className": "emoji2797"
            },
            {
                "icon": "✖",
                "name": "加粗的乘法記號 Heavy multiplication x",
                "className": "emoji2716"
            },
            {
                "icon": "♾",
                "name": "無限 Infinity",
                "className": "emoji267e"
            },
            {
                "icon": "💲",
                "name": "大型錢幣符號 Heavy dollar sign",
                "className": "emoji1f4b2"
            },
            {
                "icon": "💱",
                "name": "貨幣兌換 Currency exchange",
                "className": "emoji1f4b1"
            },
            {
                "icon": "™",
                "name": "商標符號 Trade mark sign",
                "className": "emoji2122"
            },
            {
                "icon": "©",
                "name": "版權符號 Copyright sign",
                "className": "emojia9"
            },
            {
                "icon": "®",
                "name": "註冊符號 Registered sign",
                "className": "emojiae"
            },
            {
                "icon": "👁‍🗨",
                "name": "對話泡泡中的眼睛 Eye in speech bubble",
                "className": "emoji1f441-200d-1f5e8"
            },
            {
                "icon": "🔚",
                "name": "上方有向左箭頭的 END End with leftwards arrow above",
                "className": "emoji1f51a"
            },
            {
                "icon": "🔙",
                "name": "上方有向左箭頭的 BACK Back with leftwards arrow above",
                "className": "emoji1f519"
            },
            {
                "icon": "🔛",
                "name": "上方有向左箭頭的 ON 和驚嘆號 On with exclamation mark with left right arrow above",
                "className": "emoji1f51b"
            },
            {
                "icon": "🔝",
                "name": "上面有向上箭頭的 TOP Top with upwards arrow above",
                "className": "emoji1f51d"
            },
            {
                "icon": "🔜",
                "name": "上面有向右箭頭的 SOON Soon with rightwards arrow above",
                "className": "emoji1f51c"
            },
            {
                "icon": "〰",
                "name": "連續波浪號 Wavy dash",
                "className": "emoji3030"
            },
            {
                "icon": "➰",
                "name": "捲曲線 Curly loop",
                "className": "emoji27b0"
            },
            {
                "icon": "➿",
                "name": "雙捲曲線 Double curly loop",
                "className": "emoji27bf"
            },
            {
                "icon": "✔",
                "name": "加粗的打勾記號 Heavy check mark",
                "className": "emoji2714"
            },
            {
                "icon": "☑",
                "name": "打勾的黑色方塊 Ballot box with check",
                "className": "emoji2611"
            },
            {
                "icon": "🔘",
                "name": "圓形按鈕 Radio button",
                "className": "emoji1f518"
            },
            {
                "icon": "🔴",
                "name": "大型紅色圓圈 Large red circle",
                "className": "emoji1f534"
            },
            {
                "icon": "🟠",
                "name": "橙色圓形 Orange circle",
                "className": "emoji1f7e0"
            },
            {
                "icon": "🟡",
                "name": "黃色圓形 Yellow circle",
                "className": "emoji1f7e1"
            },
            {
                "icon": "🟢",
                "name": "綠色圓形 Green circle",
                "className": "emoji1f7e2"
            },
            {
                "icon": "🔵",
                "name": "大型藍色圓圈 Large blue circle",
                "className": "emoji1f535"
            },
            {
                "icon": "🟣",
                "name": "紫色圓形 Purple circle",
                "className": "emoji1f7e3"
            },
            {
                "icon": "⚫",
                "name": "中型黑色圓形 Medium black circle",
                "className": "emoji26ab"
            },
            {
                "icon": "⚪",
                "name": "中型白色圓形 Medium white circle",
                "className": "emoji26aa"
            },
            {
                "icon": "🟤",
                "name": "棕色圓形 Brown circle",
                "className": "emoji1f7e4"
            },
            {
                "icon": "🔺",
                "name": "往上的紅色三角形 Up-pointing red triangle",
                "className": "emoji1f53a"
            },
            {
                "icon": "🔻",
                "name": "往下的紅色三角形 Down-pointing red triangle",
                "className": "emoji1f53b"
            },
            {
                "icon": "🔸",
                "name": "小型橘色菱形 Small orange diamond",
                "className": "emoji1f538"
            },
            {
                "icon": "🔹",
                "name": "小型藍色菱形 Small blue diamond",
                "className": "emoji1f539"
            },
            {
                "icon": "🔶",
                "name": "大型橘色菱形 Large orange diamond",
                "className": "emoji1f536"
            },
            {
                "icon": "🔷",
                "name": "大型藍色菱形 Large blue diamond",
                "className": "emoji1f537"
            },
            {
                "icon": "🔳",
                "name": "白色方形按鈕 White square button",
                "className": "emoji1f533"
            },
            {
                "icon": "🔲",
                "name": "黑色方形按鈕 Black square button",
                "className": "emoji1f532"
            },
            {
                "icon": "▪",
                "name": "小型黑色正方形 Black small square",
                "className": "emoji25aa"
            },
            {
                "icon": "▫",
                "name": "小型白色正方形 White small square",
                "className": "emoji25ab"
            },
            {
                "icon": "◾",
                "name": "中小型黑色正方形 Black medium small square",
                "className": "emoji25fe"
            },
            {
                "icon": "◽",
                "name": "中小型白色正方形 White medium small square",
                "className": "emoji25fd"
            },
            {
                "icon": "◼",
                "name": "中型黑色正方形 Black medium square",
                "className": "emoji25fc"
            },
            {
                "icon": "◻",
                "name": "中型白色正方形 White medium square",
                "className": "emoji25fb"
            },
            {
                "icon": "🟥",
                "name": "紅色方形 Red square",
                "className": "emoji1f7e5"
            },
            {
                "icon": "🟧",
                "name": "橙色方形 Orange square",
                "className": "emoji1f7e7"
            },
            {
                "icon": "🟨",
                "name": "黃色方形 Yellow square",
                "className": "emoji1f7e8"
            },
            {
                "icon": "🟩",
                "name": "綠色方形 Green square",
                "className": "emoji1f7e9"
            },
            {
                "icon": "🟦",
                "name": "藍色方形 Blue square",
                "className": "emoji1f7e6"
            },
            {
                "icon": "🟪",
                "name": "紫色方形 Purple square",
                "className": "emoji1f7ea"
            },
            {
                "icon": "⬛",
                "name": "大型黑色正方形 Black large square",
                "className": "emoji2b1b"
            },
            {
                "icon": "⬜",
                "name": "大型白色正方形 White large square",
                "className": "emoji2b1c"
            },
            {
                "icon": "🟫",
                "name": "棕色方形 Brown square",
                "className": "emoji1f7eb"
            },
            {
                "icon": "🔈",
                "name": "喇叭 Speaker",
                "className": "emoji1f508"
            },
            {
                "icon": "🔇",
                "name": "加上刪除斜線的喇叭 Speaker with cancellation stroke",
                "className": "emoji1f507"
            },
            {
                "icon": "🔉",
                "name": "有一個聲波符號的喇叭 Speaker with one sound wave",
                "className": "emoji1f509"
            },
            {
                "icon": "🔊",
                "name": "有三個聲波符號的喇叭 Speaker with three sound waves",
                "className": "emoji1f50a"
            },
            {
                "icon": "🔔",
                "name": "響鈴 Bell",
                "className": "emoji1f514"
            },
            {
                "icon": "🔕",
                "name": "加上刪除斜線的響鈴 Bell with cancellation stroke",
                "className": "emoji1f515"
            },
            {
                "icon": "📣",
                "name": "傳聲筒加油棒 Cheering megaphone",
                "className": "emoji1f4e3"
            },
            {
                "icon": "📢",
                "name": "大聲公 Public address loudspeaker",
                "className": "emoji1f4e2"
            },
            {
                "icon": "💬",
                "name": "對話泡泡 Speech balloon",
                "className": "emoji1f4ac"
            },
            {
                "icon": "💭",
                "name": "思考泡泡框 Thought balloon",
                "className": "emoji1f4ad"
            },
            {
                "icon": "🗯",
                "name": "右生氣泡泡 Right anger bubble",
                "className": "emoji1f5ef"
            },
            {
                "icon": "♠",
                "name": "黑色的黑桃紙牌花色 Black spade suit",
                "className": "emoji2660"
            },
            {
                "icon": "♣",
                "name": "黑色的梅花紙牌花色 Black club suit",
                "className": "emoji2663"
            },
            {
                "icon": "♥",
                "name": "黑色的紅心紙牌花色 Black heart suit",
                "className": "emoji2665"
            },
            {
                "icon": "♦",
                "name": "黑色的方塊紙牌花色 Black diamond suit",
                "className": "emoji2666"
            },
            {
                "icon": "🃏",
                "name": "黑色鬼牌 Playing card black joker",
                "className": "emoji1f0cf"
            },
            {
                "icon": "🎴",
                "name": "日本花牌 Flower playing cards",
                "className": "emoji1f3b4"
            },
            {
                "icon": "🀄",
                "name": "麻將牌紅中 Mahjong tile red dragon",
                "className": "emoji1f004"
            },
            {
                "icon": "🕐",
                "name": "顯示為一點的時鐘鐘面 Clock face one oclock",
                "className": "emoji1f550"
            },
            {
                "icon": "🕑",
                "name": "顯示為兩點的時鐘鐘面 Clock face two oclock",
                "className": "emoji1f551"
            },
            {
                "icon": "🕒",
                "name": "顯示為三點的時鐘鐘面 Clock face three oclock",
                "className": "emoji1f552"
            },
            {
                "icon": "🕓",
                "name": "顯示為四點的時鐘鐘面 Clock face four oclock",
                "className": "emoji1f553"
            },
            {
                "icon": "🕔",
                "name": "顯示為五點的時鐘鐘面 Clock face five oclock",
                "className": "emoji1f554"
            },
            {
                "icon": "🕕",
                "name": "顯示為六點的時鐘鐘面 Clock face six oclock",
                "className": "emoji1f555"
            },
            {
                "icon": "🕖",
                "name": "顯示為七點的時鐘鐘面 Clock face seven oclock",
                "className": "emoji1f556"
            },
            {
                "icon": "🕗",
                "name": "顯示為八點的時鐘鐘面 Clock face eight oclock",
                "className": "emoji1f557"
            },
            {
                "icon": "🕘",
                "name": "顯示為九點的時鐘鐘面 Clock face nine oclock",
                "className": "emoji1f558"
            },
            {
                "icon": "🕙",
                "name": "顯示為十點的時鐘鐘面 Clock face ten oclock",
                "className": "emoji1f559"
            },
            {
                "icon": "🕚",
                "name": "顯示為十一點的時鐘鐘面 Clock face eleven oclock",
                "className": "emoji1f55a"
            },
            {
                "icon": "🕛",
                "name": "顯示為十二點的時鐘鐘面 Clock face twelve oclock",
                "className": "emoji1f55b"
            },
            {
                "icon": "🕜",
                "name": "顯示為一點半的時鐘鐘面 Clock face one-thirty",
                "className": "emoji1f55c"
            },
            {
                "icon": "🕝",
                "name": "顯示為兩點半的時鐘鐘面 Clock face two-thirty",
                "className": "emoji1f55d"
            },
            {
                "icon": "🕞",
                "name": "顯示為三點半的時鐘鐘面 Clock face three-thirty",
                "className": "emoji1f55e"
            },
            {
                "icon": "🕟",
                "name": "顯示為四點半的時鐘鐘面 Clock face four-thirty",
                "className": "emoji1f55f"
            },
            {
                "icon": "🕠",
                "name": "顯示為五點半的時鐘鐘面 Clock face five-thirty",
                "className": "emoji1f560"
            },
            {
                "icon": "🕡",
                "name": "顯示為六點半的時鐘鐘面 Clock face six-thirty",
                "className": "emoji1f561"
            },
            {
                "icon": "🕢",
                "name": "顯示為七點半的時鐘鐘面 Clock face seven-thirty",
                "className": "emoji1f562"
            },
            {
                "icon": "🕣",
                "name": "顯示為八點半的時鐘鐘面 Clock face eight-thirty",
                "className": "emoji1f563"
            },
            {
                "icon": "🕤",
                "name": "顯示為九點半的時鐘鐘面 Clock face nine-thirty",
                "className": "emoji1f564"
            },
            {
                "icon": "🕥",
                "name": "顯示為十點半的時鐘鐘面 Clock face ten-thirty",
                "className": "emoji1f565"
            },
            {
                "icon": "🕦",
                "name": "顯示為十一點半的時鐘鐘面 Clock face eleven-thirty",
                "className": "emoji1f566"
            },
            {
                "icon": "🕧",
                "name": "顯示為十二點半的時鐘鐘面 Clock face twelve-thirty",
                "className": "emoji1f567"
            }
        ]
    },
    {
        "name":"旗幟",
        "list":[
            {
                "icon": "🏳",
                "name": "揮白旗 Waving white flag",
                "className": "emoji1f3f3"
            },
            {
                "icon": "🏴",
                "name": "揮黑旗 Waving black flag",
                "className": "emoji1f3f4"
            },
            {
                "icon": "🏴‍☠",
                "name": "海盜旗 Pirate flag",
                "className": "emoji1f3f4-200d-2620"
            },
            {
                "icon": "🏁",
                "name": "賽車方格旗 Chequered flag",
                "className": "emoji1f3c1"
            },
            {
                "icon": "🚩",
                "name": "三角旗桿 Triangular flag on post",
                "className": "emoji1f6a9"
            },
            {
                "icon": "🏳‍🌈",
                "name": "彩虹旗 Rainbow flag",
                "className": "emoji1f3f3-200d-1f308"
            },
            {
                "icon": "🏳‍⚧",
                "name": "跨性別旗幟 Transgender flag",
                "className": "emoji1f3f3-200d-26a7"
            },
            {
                "icon": "🇺🇳",
                "name": "聯合國旗幟 Flag of United Nations",
                "className": "emoji1f1fa-1f1f3"
            },
            {
                "icon": "🇦🇫",
                "name": "阿富汗旗幟 Flag of Afghanistan",
                "className": "emoji1f1e6-1f1eb"
            },
            {
                "icon": "🇦🇽",
                "name": "奧蘭群島旗幟 Flag of Åland Islands",
                "className": "emoji1f1e6-1f1fd"
            },
            {
                "icon": "🇦🇱",
                "name": "阿爾巴尼亞旗幟 Flag of Albania",
                "className": "emoji1f1e6-1f1f1"
            },
            {
                "icon": "🇩🇿",
                "name": "阿爾及利亞旗幟 Flag of Algeria",
                "className": "emoji1f1e9-1f1ff"
            },
            {
                "icon": "🇦🇸",
                "name": "美屬薩摩亞旗幟 Flag of American Samoa",
                "className": "emoji1f1e6-1f1f8"
            },
            {
                "icon": "🇦🇩",
                "name": "安道爾旗幟 Flag of Andorra",
                "className": "emoji1f1e6-1f1e9"
            },
            {
                "icon": "🇦🇴",
                "name": "安哥拉旗幟 Flag of Angola",
                "className": "emoji1f1e6-1f1f4"
            },
            {
                "icon": "🇦🇮",
                "name": "安圭拉旗幟 Flag of Anguilla",
                "className": "emoji1f1e6-1f1ee"
            },
            {
                "icon": "🇦🇶",
                "name": "南極洲旗幟 Flag of Antarctica",
                "className": "emoji1f1e6-1f1f6"
            },
            {
                "icon": "🇦🇬",
                "name": "安地卡及巴布達旗幟 Flag of Antigua &amp; Barbuda",
                "className": "emoji1f1e6-1f1ec"
            },
            {
                "icon": "🇦🇷",
                "name": "阿根廷旗幟 Flag of Argentina",
                "className": "emoji1f1e6-1f1f7"
            },
            {
                "icon": "🇦🇲",
                "name": "亞美尼亞旗幟 Flag of Armenia",
                "className": "emoji1f1e6-1f1f2"
            },
            {
                "icon": "🇦🇼",
                "name": "阿魯巴旗幟 Flag of Aruba",
                "className": "emoji1f1e6-1f1fc"
            },
            {
                "icon": "🇦🇺",
                "name": "澳洲旗幟 Flag of Australia",
                "className": "emoji1f1e6-1f1fa"
            },
            {
                "icon": "🇦🇹",
                "name": "奧地利旗幟 Flag of Austria",
                "className": "emoji1f1e6-1f1f9"
            },
            {
                "icon": "🇦🇿",
                "name": "亞塞拜然旗幟 Flag of Azerbaijan",
                "className": "emoji1f1e6-1f1ff"
            },
            {
                "icon": "🇧🇸",
                "name": "巴哈馬旗幟 Flag of Bahamas",
                "className": "emoji1f1e7-1f1f8"
            },
            {
                "icon": "🇧🇭",
                "name": "巴林旗幟 Flag of Bahrain",
                "className": "emoji1f1e7-1f1ed"
            },
            {
                "icon": "🇧🇩",
                "name": "孟加拉旗幟 Flag of Bangladesh",
                "className": "emoji1f1e7-1f1e9"
            },
            {
                "icon": "🇧🇧",
                "name": "巴貝多旗幟 Flag of Barbados",
                "className": "emoji1f1e7-1f1e7"
            },
            {
                "icon": "🇧🇾",
                "name": "白俄羅斯旗幟 Flag of Belarus",
                "className": "emoji1f1e7-1f1fe"
            },
            {
                "icon": "🇧🇪",
                "name": "比利時旗幟 Flag of Belgium",
                "className": "emoji1f1e7-1f1ea"
            },
            {
                "icon": "🇧🇿",
                "name": "貝里斯旗幟 Flag of Belize",
                "className": "emoji1f1e7-1f1ff"
            },
            {
                "icon": "🇧🇯",
                "name": "貝南旗幟 Flag of Benin",
                "className": "emoji1f1e7-1f1ef"
            },
            {
                "icon": "🇧🇲",
                "name": "百慕達旗幟 Flag of Bermuda",
                "className": "emoji1f1e7-1f1f2"
            },
            {
                "icon": "🇧🇹",
                "name": "不丹旗幟 Flag of Bhutan",
                "className": "emoji1f1e7-1f1f9"
            },
            {
                "icon": "🇧🇴",
                "name": "玻利維亞旗幟 Flag of Bolivia",
                "className": "emoji1f1e7-1f1f4"
            },
            {
                "icon": "🇧🇦",
                "name": "波士尼亞與赫塞哥維納旗幟 Flag of Bosnia &amp; Herzegovina",
                "className": "emoji1f1e7-1f1e6"
            },
            {
                "icon": "🇧🇼",
                "name": "波札那旗幟 Flag of Botswana",
                "className": "emoji1f1e7-1f1fc"
            },
            {
                "icon": "🇧🇷",
                "name": "巴西旗幟 Flag of Brazil",
                "className": "emoji1f1e7-1f1f7"
            },
            {
                "icon": "🇮🇴",
                "name": "英屬印度洋領地旗幟 Flag of British Indian Ocean Territory",
                "className": "emoji1f1ee-1f1f4"
            },
            {
                "icon": "🇻🇬",
                "name": "英屬維京群島旗幟 Flag of British Virgin Islands",
                "className": "emoji1f1fb-1f1ec"
            },
            {
                "icon": "🇧🇳",
                "name": "汶萊旗幟 Flag of Brunei",
                "className": "emoji1f1e7-1f1f3"
            },
            {
                "icon": "🇧🇬",
                "name": "保加利亞旗幟 Flag of Bulgaria",
                "className": "emoji1f1e7-1f1ec"
            },
            {
                "icon": "🇧🇫",
                "name": "布吉納法索旗幟 Flag of Burkina Faso",
                "className": "emoji1f1e7-1f1eb"
            },
            {
                "icon": "🇧🇮",
                "name": "蒲隆地旗幟 Flag of Burundi",
                "className": "emoji1f1e7-1f1ee"
            },
            {
                "icon": "🇰🇭",
                "name": "柬埔寨旗幟 Flag of Cambodia",
                "className": "emoji1f1f0-1f1ed"
            },
            {
                "icon": "🇨🇲",
                "name": "喀麥隆旗幟 Flag of Cameroon",
                "className": "emoji1f1e8-1f1f2"
            },
            {
                "icon": "🇨🇦",
                "name": "加拿大旗幟 Flag of Canada",
                "className": "emoji1f1e8-1f1e6"
            },
            {
                "icon": "🇮🇨",
                "name": "加那利群島旗幟 Flag of Canary Islands",
                "className": "emoji1f1ee-1f1e8"
            },
            {
                "icon": "🇨🇻",
                "name": "維德角旗幟 Flag of Cape Verde",
                "className": "emoji1f1e8-1f1fb"
            },
            {
                "icon": "🇧🇶",
                "name": "荷蘭加勒比區旗幟 Flag of Caribbean Netherlands",
                "className": "emoji1f1e7-1f1f6"
            },
            {
                "icon": "🇰🇾",
                "name": "開曼群島旗幟 Flag of Cayman Islands",
                "className": "emoji1f1f0-1f1fe"
            },
            {
                "icon": "🇨🇫",
                "name": "中非共和國旗幟 Flag of Central African Republic",
                "className": "emoji1f1e8-1f1eb"
            },
            {
                "icon": "🇹🇩",
                "name": "查德旗幟 Flag of Chad",
                "className": "emoji1f1f9-1f1e9"
            },
            {
                "icon": "🇨🇱",
                "name": "智利旗幟 Flag of Chile",
                "className": "emoji1f1e8-1f1f1"
            },
            {
                "icon": "🇨🇳",
                "name": "中國旗幟 Flag of China",
                "className": "emoji1f1e8-1f1f3"
            },
            {
                "icon": "🇨🇽",
                "name": "聖誕島旗幟 Flag of Christmas Island",
                "className": "emoji1f1e8-1f1fd"
            },
            {
                "icon": "🇨🇨",
                "name": "科科斯群島旗幟 Flag of Cocos Islands",
                "className": "emoji1f1e8-1f1e8"
            },
            {
                "icon": "🇨🇴",
                "name": "哥倫比亞旗幟 Flag of Colombia",
                "className": "emoji1f1e8-1f1f4"
            },
            {
                "icon": "🇰🇲",
                "name": "葛摩旗幟 Flag of Comoros",
                "className": "emoji1f1f0-1f1f2"
            },
            {
                "icon": "🇨🇬",
                "name": "剛果布拉柴維爾旗幟 Flag of Congo - Brazzaville",
                "className": "emoji1f1e8-1f1ec"
            },
            {
                "icon": "🇨🇩",
                "name": "剛果金夏沙旗幟 Flag of Congo - Kinshasa",
                "className": "emoji1f1e8-1f1e9"
            },
            {
                "icon": "🇨🇰",
                "name": "庫克群島旗幟 Flag of Cook Islands",
                "className": "emoji1f1e8-1f1f0"
            },
            {
                "icon": "🇨🇷",
                "name": "哥斯大黎加旗幟 Flag of Costa Rica",
                "className": "emoji1f1e8-1f1f7"
            },
            {
                "icon": "🇨🇮",
                "name": "象牙海岸旗幟 Flag of Côte d’Ivoire",
                "className": "emoji1f1e8-1f1ee"
            },
            {
                "icon": "🇭🇷",
                "name": "克羅埃西亞旗幟 Flag of Croatia",
                "className": "emoji1f1ed-1f1f7"
            },
            {
                "icon": "🇨🇺",
                "name": "古巴旗幟 Flag of Cuba",
                "className": "emoji1f1e8-1f1fa"
            },
            {
                "icon": "🇨🇼",
                "name": "古拉索旗幟 Flag of Curaçao",
                "className": "emoji1f1e8-1f1fc"
            },
            {
                "icon": "🇨🇾",
                "name": "賽普勒斯旗幟 Flag of Cyprus",
                "className": "emoji1f1e8-1f1fe"
            },
            {
                "icon": "🇨🇿",
                "name": "捷克共和國旗幟 Flag of Czech Republic",
                "className": "emoji1f1e8-1f1ff"
            },
            {
                "icon": "🇩🇰",
                "name": "丹麥旗幟 Flag of Denmark",
                "className": "emoji1f1e9-1f1f0"
            },
            {
                "icon": "🇩🇯",
                "name": "吉布地旗幟 Flag of Djibouti",
                "className": "emoji1f1e9-1f1ef"
            },
            {
                "icon": "🇩🇲",
                "name": "多米尼克旗幟 Flag of Dominica",
                "className": "emoji1f1e9-1f1f2"
            },
            {
                "icon": "🇩🇴",
                "name": "多明尼加共和國旗幟 Flag of Dominican Republic",
                "className": "emoji1f1e9-1f1f4"
            },
            {
                "icon": "🇪🇨",
                "name": "厄瓜多旗幟 Flag of Ecuador",
                "className": "emoji1f1ea-1f1e8"
            },
            {
                "icon": "🇪🇬",
                "name": "埃及旗幟 Flag of Egypt",
                "className": "emoji1f1ea-1f1ec"
            },
            {
                "icon": "🇸🇻",
                "name": "薩爾瓦多旗幟 Flag of El Salvador",
                "className": "emoji1f1f8-1f1fb"
            },
            {
                "icon": "🇬🇶",
                "name": "赤道幾內亞旗幟 Flag of Equatorial Guinea",
                "className": "emoji1f1ec-1f1f6"
            },
            {
                "icon": "🇪🇷",
                "name": "厄利垂亞旗幟 Flag of Eritrea",
                "className": "emoji1f1ea-1f1f7"
            },
            {
                "icon": "🇪🇪",
                "name": "愛沙尼亞旗幟 Flag of Estonia",
                "className": "emoji1f1ea-1f1ea"
            },
            {
                "icon": "🇪🇹",
                "name": "衣索比亞旗幟 Flag of Ethiopia",
                "className": "emoji1f1ea-1f1f9"
            },
            {
                "icon": "🇪🇺",
                "name": "歐盟旗幟 Flag of European Union",
                "className": "emoji1f1ea-1f1fa"
            },
            {
                "icon": "🇫🇰",
                "name": "福克蘭群島旗幟 Flag of Falkland Islands",
                "className": "emoji1f1eb-1f1f0"
            },
            {
                "icon": "🇫🇴",
                "name": "法羅群島旗幟 Flag of Faroe Islands",
                "className": "emoji1f1eb-1f1f4"
            },
            {
                "icon": "🇫🇯",
                "name": "斐濟旗幟 Flag of Fiji",
                "className": "emoji1f1eb-1f1ef"
            },
            {
                "icon": "🇫🇮",
                "name": "芬蘭旗幟 Flag of Finland",
                "className": "emoji1f1eb-1f1ee"
            },
            {
                "icon": "🇫🇷",
                "name": "法國旗幟 Flag of France",
                "className": "emoji1f1eb-1f1f7"
            },
            {
                "icon": "🇬🇫",
                "name": "法屬蓋亞那旗幟 Flag of French Guiana",
                "className": "emoji1f1ec-1f1eb"
            },
            {
                "icon": "🇵🇫",
                "name": "法屬玻里尼西亞旗幟 Flag of French Polynesia",
                "className": "emoji1f1f5-1f1eb"
            },
            {
                "icon": "🇹🇫",
                "name": "法屬南部領地旗幟 Flag of French Southern Territories",
                "className": "emoji1f1f9-1f1eb"
            },
            {
                "icon": "🇬🇦",
                "name": "加彭旗幟 Flag of Gabon",
                "className": "emoji1f1ec-1f1e6"
            },
            {
                "icon": "🇬🇲",
                "name": "甘比亞旗幟 Flag of Gambia",
                "className": "emoji1f1ec-1f1f2"
            },
            {
                "icon": "🇬🇪",
                "name": "喬治亞旗幟 Flag of Georgia",
                "className": "emoji1f1ec-1f1ea"
            },
            {
                "icon": "🇩🇪",
                "name": "德國旗幟 Flag of Germany",
                "className": "emoji1f1e9-1f1ea"
            },
            {
                "icon": "🇬🇭",
                "name": "迦納旗幟 Flag of Ghana",
                "className": "emoji1f1ec-1f1ed"
            },
            {
                "icon": "🇬🇮",
                "name": "直布羅陀旗幟 Flag of Gibraltar",
                "className": "emoji1f1ec-1f1ee"
            },
            {
                "icon": "🇬🇷",
                "name": "希臘旗幟 Flag of Greece",
                "className": "emoji1f1ec-1f1f7"
            },
            {
                "icon": "🇬🇱",
                "name": "格陵蘭旗幟 Flag of Greenland",
                "className": "emoji1f1ec-1f1f1"
            },
            {
                "icon": "🇬🇩",
                "name": "格瑞那達旗幟 Flag of Grenada",
                "className": "emoji1f1ec-1f1e9"
            },
            {
                "icon": "🇬🇵",
                "name": "瓜德羅普旗幟 Flag of Guadeloupe",
                "className": "emoji1f1ec-1f1f5"
            },
            {
                "icon": "🇬🇺",
                "name": "關島旗幟 Flag of Guam",
                "className": "emoji1f1ec-1f1fa"
            },
            {
                "icon": "🇬🇹",
                "name": "瓜地馬拉旗幟 Flag of Guatemala",
                "className": "emoji1f1ec-1f1f9"
            },
            {
                "icon": "🇬🇬",
                "name": "根西旗幟 Flag of Guernsey",
                "className": "emoji1f1ec-1f1ec"
            },
            {
                "icon": "🇬🇳",
                "name": "幾內亞旗幟 Flag of Guinea",
                "className": "emoji1f1ec-1f1f3"
            },
            {
                "icon": "🇬🇼",
                "name": "幾內亞比索旗幟 Flag of Guinea-Bissau",
                "className": "emoji1f1ec-1f1fc"
            },
            {
                "icon": "🇬🇾",
                "name": "蓋亞那旗幟 Flag of Guyana",
                "className": "emoji1f1ec-1f1fe"
            },
            {
                "icon": "🇭🇹",
                "name": "海地旗幟 Flag of Haiti",
                "className": "emoji1f1ed-1f1f9"
            },
            {
                "icon": "🇭🇳",
                "name": "宏都拉斯旗幟 Flag of Honduras",
                "className": "emoji1f1ed-1f1f3"
            },
            {
                "icon": "🇭🇰",
                "name": "香港旗幟 Flag of Hong Kong",
                "className": "emoji1f1ed-1f1f0"
            },
            {
                "icon": "🇭🇺",
                "name": "匈牙利旗幟 Flag of Hungary",
                "className": "emoji1f1ed-1f1fa"
            },
            {
                "icon": "🇮🇸",
                "name": "冰島旗幟 Flag of Iceland",
                "className": "emoji1f1ee-1f1f8"
            },
            {
                "icon": "🇮🇳",
                "name": "印度旗幟 Flag of India",
                "className": "emoji1f1ee-1f1f3"
            },
            {
                "icon": "🇮🇩",
                "name": "印度尼西亞旗幟 Flag of Indonesia",
                "className": "emoji1f1ee-1f1e9"
            },
            {
                "icon": "🇮🇷",
                "name": "伊朗旗幟 Flag of Iran",
                "className": "emoji1f1ee-1f1f7"
            },
            {
                "icon": "🇮🇶",
                "name": "伊拉克旗幟 Flag of Iraq",
                "className": "emoji1f1ee-1f1f6"
            },
            {
                "icon": "🇮🇪",
                "name": "愛爾蘭旗幟 Flag of Ireland",
                "className": "emoji1f1ee-1f1ea"
            },
            {
                "icon": "🇮🇲",
                "name": "曼島旗幟 Flag of Isle of Man",
                "className": "emoji1f1ee-1f1f2"
            },
            {
                "icon": "🇮🇱",
                "name": "以色列旗幟 Flag of Israel",
                "className": "emoji1f1ee-1f1f1"
            },
            {
                "icon": "🇮🇹",
                "name": "義大利旗幟 Flag of Italy",
                "className": "emoji1f1ee-1f1f9"
            },
            {
                "icon": "🇯🇲",
                "name": "牙買加旗幟 Flag of Jamaica",
                "className": "emoji1f1ef-1f1f2"
            },
            {
                "icon": "🇯🇵",
                "name": "日本國旗 Flag of Japan",
                "className": "emoji1f1ef-1f1f5"
            },
            {
                "icon": "🎌",
                "name": "交叉的旗子 Crossed flags",
                "className": "emoji1f38c"
            },
            {
                "icon": "🇯🇪",
                "name": "澤西旗幟 Flag of Jersey",
                "className": "emoji1f1ef-1f1ea"
            },
            {
                "icon": "🇯🇴",
                "name": "約旦旗幟 Flag of Jordan",
                "className": "emoji1f1ef-1f1f4"
            },
            {
                "icon": "🇰🇿",
                "name": "哈薩克旗幟 Flag of Kazakhstan",
                "className": "emoji1f1f0-1f1ff"
            },
            {
                "icon": "🇰🇪",
                "name": "肯亞旗幟 Flag of Kenya",
                "className": "emoji1f1f0-1f1ea"
            },
            {
                "icon": "🇰🇮",
                "name": "吉里巴斯旗幟 Flag of Kiribati",
                "className": "emoji1f1f0-1f1ee"
            },
            {
                "icon": "🇽🇰",
                "name": "科索沃旗幟 Flag of Kosovo",
                "className": "emoji1f1fd-1f1f0"
            },
            {
                "icon": "🇰🇼",
                "name": "科威特旗幟 Flag of Kuwait",
                "className": "emoji1f1f0-1f1fc"
            },
            {
                "icon": "🇰🇬",
                "name": "吉爾吉斯旗幟 Flag of Kyrgyzstan",
                "className": "emoji1f1f0-1f1ec"
            },
            {
                "icon": "🇱🇦",
                "name": "寮國旗幟 Flag of Laos",
                "className": "emoji1f1f1-1f1e6"
            },
            {
                "icon": "🇱🇻",
                "name": "拉脫維亞旗幟 Flag of Latvia",
                "className": "emoji1f1f1-1f1fb"
            },
            {
                "icon": "🇱🇧",
                "name": "黎巴嫩旗幟 Flag of Lebanon",
                "className": "emoji1f1f1-1f1e7"
            },
            {
                "icon": "🇱🇸",
                "name": "賴索托旗幟 Flag of Lesotho",
                "className": "emoji1f1f1-1f1f8"
            },
            {
                "icon": "🇱🇷",
                "name": "賴比瑞亞旗幟 Flag of Liberia",
                "className": "emoji1f1f1-1f1f7"
            },
            {
                "icon": "🇱🇾",
                "name": "利比亞旗幟 Flag of Libya",
                "className": "emoji1f1f1-1f1fe"
            },
            {
                "icon": "🇱🇮",
                "name": "列支敦斯登旗幟 Flag of Liechtenstein",
                "className": "emoji1f1f1-1f1ee"
            },
            {
                "icon": "🇱🇹",
                "name": "立陶宛旗幟 Flag of Lithuania",
                "className": "emoji1f1f1-1f1f9"
            },
            {
                "icon": "🇱🇺",
                "name": "盧森堡旗幟 Flag of Luxembourg",
                "className": "emoji1f1f1-1f1fa"
            },
            {
                "icon": "🇲🇴",
                "name": "澳門旗幟 Flag of Macau",
                "className": "emoji1f1f2-1f1f4"
            },
            {
                "icon": "🇲🇰",
                "name": "馬其頓旗幟 Flag of Macedonia",
                "className": "emoji1f1f2-1f1f0"
            },
            {
                "icon": "🇲🇬",
                "name": "馬達加斯加旗幟 Flag of Madagascar",
                "className": "emoji1f1f2-1f1ec"
            },
            {
                "icon": "🇲🇼",
                "name": "馬拉威旗幟 Flag of Malawi",
                "className": "emoji1f1f2-1f1fc"
            },
            {
                "icon": "🇲🇾",
                "name": "馬來西亞旗幟 Flag of Malaysia",
                "className": "emoji1f1f2-1f1fe"
            },
            {
                "icon": "🇲🇻",
                "name": "馬爾地夫旗幟 Flag of Maldives",
                "className": "emoji1f1f2-1f1fb"
            },
            {
                "icon": "🇲🇱",
                "name": "馬利旗幟 Flag of Mali",
                "className": "emoji1f1f2-1f1f1"
            },
            {
                "icon": "🇲🇹",
                "name": "馬爾他旗幟 Flag of Malta",
                "className": "emoji1f1f2-1f1f9"
            },
            {
                "icon": "🇲🇭",
                "name": "馬紹爾群島旗幟 Flag of Marshall Islands",
                "className": "emoji1f1f2-1f1ed"
            },
            {
                "icon": "🇲🇶",
                "name": "馬丁尼克旗幟 Flag of Martinique",
                "className": "emoji1f1f2-1f1f6"
            },
            {
                "icon": "🇲🇷",
                "name": "茅利塔尼亞旗幟 Flag of Mauritania",
                "className": "emoji1f1f2-1f1f7"
            },
            {
                "icon": "🇲🇺",
                "name": "模里西斯旗幟 Flag of Mauritius",
                "className": "emoji1f1f2-1f1fa"
            },
            {
                "icon": "🇾🇹",
                "name": "馬約特旗幟 Flag of Mayotte",
                "className": "emoji1f1fe-1f1f9"
            },
            {
                "icon": "🇲🇽",
                "name": "墨西哥旗幟 Flag of Mexico",
                "className": "emoji1f1f2-1f1fd"
            },
            {
                "icon": "🇫🇲",
                "name": "密克羅尼西亞旗幟 Flag of Micronesia",
                "className": "emoji1f1eb-1f1f2"
            },
            {
                "icon": "🇲🇩",
                "name": "摩爾多瓦旗幟 Flag of Moldova",
                "className": "emoji1f1f2-1f1e9"
            },
            {
                "icon": "🇲🇨",
                "name": "摩納哥旗幟 Flag of Monaco",
                "className": "emoji1f1f2-1f1e8"
            },
            {
                "icon": "🇲🇳",
                "name": "蒙古旗幟 Flag of Mongolia",
                "className": "emoji1f1f2-1f1f3"
            },
            {
                "icon": "🇲🇪",
                "name": "蒙特內哥羅旗幟 Flag of Montenegro",
                "className": "emoji1f1f2-1f1ea"
            },
            {
                "icon": "🇲🇸",
                "name": "蒙哲臘旗幟 Flag of Montserrat",
                "className": "emoji1f1f2-1f1f8"
            },
            {
                "icon": "🇲🇦",
                "name": "摩洛哥旗幟 Flag of Morocco",
                "className": "emoji1f1f2-1f1e6"
            },
            {
                "icon": "🇲🇿",
                "name": "莫三比克旗幟 Flag of Mozambique",
                "className": "emoji1f1f2-1f1ff"
            },
            {
                "icon": "🇲🇲",
                "name": "緬甸旗幟 Flag of Myanmar",
                "className": "emoji1f1f2-1f1f2"
            },
            {
                "icon": "🇳🇦",
                "name": "納米比亞旗幟 Flag of Namibia",
                "className": "emoji1f1f3-1f1e6"
            },
            {
                "icon": "🇳🇷",
                "name": "諾魯旗幟 Flag of Nauru",
                "className": "emoji1f1f3-1f1f7"
            },
            {
                "icon": "🇳🇵",
                "name": "尼泊爾旗幟 Flag of Nepal",
                "className": "emoji1f1f3-1f1f5"
            },
            {
                "icon": "🇳🇱",
                "name": "荷蘭旗幟 Flag of Netherlands",
                "className": "emoji1f1f3-1f1f1"
            },
            {
                "icon": "🇳🇨",
                "name": "新喀里多尼亞旗幟 Flag of New Caledonia",
                "className": "emoji1f1f3-1f1e8"
            },
            {
                "icon": "🇳🇿",
                "name": "紐西蘭旗幟 Flag of New Zealand",
                "className": "emoji1f1f3-1f1ff"
            },
            {
                "icon": "🇳🇮",
                "name": "尼加拉瓜旗幟 Flag of Nicaragua",
                "className": "emoji1f1f3-1f1ee"
            },
            {
                "icon": "🇳🇪",
                "name": "尼日旗幟 Flag of Niger",
                "className": "emoji1f1f3-1f1ea"
            },
            {
                "icon": "🇳🇬",
                "name": "奈及利亞旗幟 Flag of Nigeria",
                "className": "emoji1f1f3-1f1ec"
            },
            {
                "icon": "🇳🇺",
                "name": "紐埃旗幟 Flag of Niue",
                "className": "emoji1f1f3-1f1fa"
            },
            {
                "icon": "🇳🇫",
                "name": "諾福克島旗幟 Flag of Norfolk Island",
                "className": "emoji1f1f3-1f1eb"
            },
            {
                "icon": "🇰🇵",
                "name": "北韓旗幟 Flag of North Korea",
                "className": "emoji1f1f0-1f1f5"
            },
            {
                "icon": "🇲🇵",
                "name": "北馬里亞納群島旗幟 Flag of Northern Mariana Islands",
                "className": "emoji1f1f2-1f1f5"
            },
            {
                "icon": "🇳🇴",
                "name": "挪威旗幟 Flag of Norway",
                "className": "emoji1f1f3-1f1f4"
            },
            {
                "icon": "🇴🇲",
                "name": "阿曼旗幟 Flag of Oman",
                "className": "emoji1f1f4-1f1f2"
            },
            {
                "icon": "🇵🇰",
                "name": "巴基斯坦旗幟 Flag of Pakistan",
                "className": "emoji1f1f5-1f1f0"
            },
            {
                "icon": "🇵🇼",
                "name": "帛琉旗幟 Flag of Palau",
                "className": "emoji1f1f5-1f1fc"
            },
            {
                "icon": "🇵🇸",
                "name": "巴勒斯坦領土旗幟 Flag of Palestinian Territories",
                "className": "emoji1f1f5-1f1f8"
            },
            {
                "icon": "🇵🇦",
                "name": "巴拿馬旗幟 Flag of Panama",
                "className": "emoji1f1f5-1f1e6"
            },
            {
                "icon": "🇵🇬",
                "name": "巴布亞紐幾內亞旗幟 Flag of Papua New Guinea",
                "className": "emoji1f1f5-1f1ec"
            },
            {
                "icon": "🇵🇾",
                "name": "巴拉圭旗幟 Flag of Paraguay",
                "className": "emoji1f1f5-1f1fe"
            },
            {
                "icon": "🇵🇪",
                "name": "秘魯旗幟 Flag of Peru",
                "className": "emoji1f1f5-1f1ea"
            },
            {
                "icon": "🇵🇭",
                "name": "菲律賓旗幟 Flag of Philippines",
                "className": "emoji1f1f5-1f1ed"
            },
            {
                "icon": "🇵🇳",
                "name": "皮特凱恩群島旗幟 Flag of Pitcairn Islands",
                "className": "emoji1f1f5-1f1f3"
            },
            {
                "icon": "🇵🇱",
                "name": "波蘭旗幟 Flag of Poland",
                "className": "emoji1f1f5-1f1f1"
            },
            {
                "icon": "🇵🇹",
                "name": "葡萄牙旗幟 Flag of Portugal",
                "className": "emoji1f1f5-1f1f9"
            },
            {
                "icon": "🇵🇷",
                "name": "波多黎各旗幟 Flag of Puerto Rico",
                "className": "emoji1f1f5-1f1f7"
            },
            {
                "icon": "🇶🇦",
                "name": "卡達旗幟 Flag of Qatar",
                "className": "emoji1f1f6-1f1e6"
            },
            {
                "icon": "🇷🇪",
                "name": "留尼汪旗幟 Flag of Réunion",
                "className": "emoji1f1f7-1f1ea"
            },
            {
                "icon": "🇷🇴",
                "name": "羅馬尼亞旗幟 Flag of Romania",
                "className": "emoji1f1f7-1f1f4"
            },
            {
                "icon": "🇷🇺",
                "name": "俄羅斯旗幟 Flag of Russia",
                "className": "emoji1f1f7-1f1fa"
            },
            {
                "icon": "🇷🇼",
                "name": "盧安達旗幟 Flag of Rwanda",
                "className": "emoji1f1f7-1f1fc"
            },
            {
                "icon": "🇼🇸",
                "name": "薩摩亞旗幟 Flag of Samoa",
                "className": "emoji1f1fc-1f1f8"
            },
            {
                "icon": "🇸🇲",
                "name": "聖馬利諾旗幟 Flag of San Marino",
                "className": "emoji1f1f8-1f1f2"
            },
            {
                "icon": "🇸🇹",
                "name": "聖多美普林西比旗幟 Flag of São Tomé &amp; Príncipe",
                "className": "emoji1f1f8-1f1f9"
            },
            {
                "icon": "🇸🇦",
                "name": "沙烏地阿拉伯旗幟 Flag of Saudi Arabia",
                "className": "emoji1f1f8-1f1e6"
            },
            {
                "icon": "🇸🇳",
                "name": "塞內加爾旗幟 Flag of Senegal",
                "className": "emoji1f1f8-1f1f3"
            },
            {
                "icon": "🇷🇸",
                "name": "塞爾維亞旗幟 Flag of Serbia",
                "className": "emoji1f1f7-1f1f8"
            },
            {
                "icon": "🇸🇨",
                "name": "塞席爾旗幟 Flag of Seychelles",
                "className": "emoji1f1f8-1f1e8"
            },
            {
                "icon": "🇸🇱",
                "name": "獅子山旗幟 Flag of Sierra Leone",
                "className": "emoji1f1f8-1f1f1"
            },
            {
                "icon": "🇸🇬",
                "name": "新加坡旗幟 Flag of Singapore",
                "className": "emoji1f1f8-1f1ec"
            },
            {
                "icon": "🇸🇽",
                "name": "荷屬聖馬丁旗幟 Flag of Sint Maarten",
                "className": "emoji1f1f8-1f1fd"
            },
            {
                "icon": "🇸🇰",
                "name": "斯洛伐克旗幟 Flag of Slovakia",
                "className": "emoji1f1f8-1f1f0"
            },
            {
                "icon": "🇸🇮",
                "name": "斯洛維尼亞旗幟 Flag of Slovenia",
                "className": "emoji1f1f8-1f1ee"
            },
            {
                "icon": "🇬🇸",
                "name": "南喬治亞與南三明治群島旗幟 Flag of South Georgia &amp; South Sandwich Islands",
                "className": "emoji1f1ec-1f1f8"
            },
            {
                "icon": "🇸🇧",
                "name": "索羅門群島旗幟 Flag of Solomon Islands",
                "className": "emoji1f1f8-1f1e7"
            },
            {
                "icon": "🇸🇴",
                "name": "索馬利亞旗幟 Flag of Somalia",
                "className": "emoji1f1f8-1f1f4"
            },
            {
                "icon": "🇿🇦",
                "name": "南非旗幟 Flag of South Africa",
                "className": "emoji1f1ff-1f1e6"
            },
            {
                "icon": "🇰🇷",
                "name": "南韓旗幟 Flag of South Korea",
                "className": "emoji1f1f0-1f1f7"
            },
            {
                "icon": "🇸🇸",
                "name": "南蘇丹旗幟 Flag of South Sudan",
                "className": "emoji1f1f8-1f1f8"
            },
            {
                "icon": "🇪🇸",
                "name": "西班牙旗幟 Flag of Spain",
                "className": "emoji1f1ea-1f1f8"
            },
            {
                "icon": "🇱🇰",
                "name": "斯里蘭卡旗幟 Flag of Sri Lanka",
                "className": "emoji1f1f1-1f1f0"
            },
            {
                "icon": "🇧🇱",
                "name": "聖巴泰勒米旗幟 Flag of St. Barthélemy",
                "className": "emoji1f1e7-1f1f1"
            },
            {
                "icon": "🇸🇭",
                "name": "聖赫勒拿旗幟 Flag of St. Helena",
                "className": "emoji1f1f8-1f1ed"
            },
            {
                "icon": "🇰🇳",
                "name": "聖克里斯多福及尼維斯旗幟 Flag of St. Kitts &amp; Nevis",
                "className": "emoji1f1f0-1f1f3"
            },
            {
                "icon": "🇱🇨",
                "name": "聖露西亞旗幟 Flag of St. Lucia",
                "className": "emoji1f1f1-1f1e8"
            },
            {
                "icon": "🇵🇲",
                "name": "聖皮耶與密克隆群島旗幟 Flag of St. Pierre &amp; Miquelon",
                "className": "emoji1f1f5-1f1f2"
            },
            {
                "icon": "🇻🇨",
                "name": "聖文森及格瑞那丁旗幟 Flag of St. Vincent &amp; Grenadines",
                "className": "emoji1f1fb-1f1e8"
            },
            {
                "icon": "🇸🇩",
                "name": "蘇丹旗幟 Flag of Sudan",
                "className": "emoji1f1f8-1f1e9"
            },
            {
                "icon": "🇸🇷",
                "name": "蘇利南旗幟 Flag of Suriname",
                "className": "emoji1f1f8-1f1f7"
            },
            {
                "icon": "🇸🇿",
                "name": "史瓦濟蘭旗幟 Flag of Swaziland",
                "className": "emoji1f1f8-1f1ff"
            },
            {
                "icon": "🇸🇪",
                "name": "瑞典旗幟 Flag of Sweden",
                "className": "emoji1f1f8-1f1ea"
            },
            {
                "icon": "🇨🇭",
                "name": "瑞士旗幟 Flag of Switzerland",
                "className": "emoji1f1e8-1f1ed"
            },
            {
                "icon": "🇸🇾",
                "name": "敘利亞旗幟 Flag of Syria",
                "className": "emoji1f1f8-1f1fe"
            },
            {
                "icon": "🇹🇼",
                "name": "台灣旗幟 Flag of Taiwan",
                "className": "emoji1f1f9-1f1fc"
            },
            {
                "icon": "🇹🇯",
                "name": "塔吉克旗幟 Flag of Tajikistan",
                "className": "emoji1f1f9-1f1ef"
            },
            {
                "icon": "🇹🇿",
                "name": "坦尚尼亞旗幟 Flag of Tanzania",
                "className": "emoji1f1f9-1f1ff"
            },
            {
                "icon": "🇹🇭",
                "name": "泰國旗幟 Flag of Thailand",
                "className": "emoji1f1f9-1f1ed"
            },
            {
                "icon": "🇹🇱",
                "name": "東帝汶幟 Flag of Timor-Leste",
                "className": "emoji1f1f9-1f1f1"
            },
            {
                "icon": "🇹🇬",
                "name": "多哥旗幟 Flag of Togo",
                "className": "emoji1f1f9-1f1ec"
            },
            {
                "icon": "🇹🇰",
                "name": "托克勞旗幟 Flag of Tokelau",
                "className": "emoji1f1f9-1f1f0"
            },
            {
                "icon": "🇹🇴",
                "name": "東加旗幟 Flag of Tonga",
                "className": "emoji1f1f9-1f1f4"
            },
            {
                "icon": "🇹🇹",
                "name": "千里達及托巴哥旗幟 Flag of Trinidad &amp; Tobago",
                "className": "emoji1f1f9-1f1f9"
            },
            {
                "icon": "🇹🇳",
                "name": "突尼西亞旗幟 Flag of Tunisia",
                "className": "emoji1f1f9-1f1f3"
            },
            {
                "icon": "🇹🇷",
                "name": "土耳其旗幟 Flag of Turkey",
                "className": "emoji1f1f9-1f1f7"
            },
            {
                "icon": "🇹🇲",
                "name": "土庫曼旗幟 Flag of Turkmenistan",
                "className": "emoji1f1f9-1f1f2"
            },
            {
                "icon": "🇹🇨",
                "name": "土克凱可群島旗幟 Flag of Turks &amp; Caicos Islands",
                "className": "emoji1f1f9-1f1e8"
            },
            {
                "icon": "🇹🇻",
                "name": "吐瓦魯旗幟 Flag of Tuvalu",
                "className": "emoji1f1f9-1f1fb"
            },
            {
                "icon": "🇺🇬",
                "name": "烏干達旗幟 Flag of Uganda",
                "className": "emoji1f1fa-1f1ec"
            },
            {
                "icon": "🇺🇦",
                "name": "烏克蘭旗幟 Flag of Ukraine",
                "className": "emoji1f1fa-1f1e6"
            },
            {
                "icon": "🇦🇪",
                "name": "阿拉伯聯合大公國旗幟 Flag of United Arab Emirates",
                "className": "emoji1f1e6-1f1ea"
            },
            {
                "icon": "🇬🇧",
                "name": "英國旗幟 Flag of United Kingdom",
                "className": "emoji1f1ec-1f1e7"
            },
            {
                "icon": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
                "name": "英格蘭旗幟 Flag of England",
                "className": "emoji1f3f4-e0067-e0062-e0065-e006e-e0067-e007f"
            },
            {
                "icon": "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
                "name": "蘇格蘭旗幟 Flag of Scotland",
                "className": "emoji1f3f4-e0067-e0062-e0073-e0063-e0074-e007f"
            },
            {
                "icon": "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
                "name": "威爾斯旗幟 Flag of Wales",
                "className": "emoji1f3f4-e0067-e0062-e0077-e006c-e0073-e007f"
            },
            {
                "icon": "🇺🇸",
                "name": "美國旗幟 Flag of United States",
                "className": "emoji1f1fa-1f1f8"
            },
            {
                "icon": "🇺🇾",
                "name": "烏拉圭旗幟 Flag of Uruguay",
                "className": "emoji1f1fa-1f1fe"
            },
            {
                "icon": "🇻🇮",
                "name": "美屬維京群島旗幟 Flag of U.S. Virgin Islands",
                "className": "emoji1f1fb-1f1ee"
            },
            {
                "icon": "🇺🇿",
                "name": "烏茲別克旗幟 Flag of Uzbekistan",
                "className": "emoji1f1fa-1f1ff"
            },
            {
                "icon": "🇻🇺",
                "name": "萬那杜旗幟 Flag of Vanuatu",
                "className": "emoji1f1fb-1f1fa"
            },
            {
                "icon": "🇻🇦",
                "name": "梵蒂岡旗幟 Flag of Vatican City",
                "className": "emoji1f1fb-1f1e6"
            },
            {
                "icon": "🇻🇪",
                "name": "委內瑞拉旗幟 Flag of Venezuela",
                "className": "emoji1f1fb-1f1ea"
            },
            {
                "icon": "🇻🇳",
                "name": "越南旗幟 Flag of Vietnam",
                "className": "emoji1f1fb-1f1f3"
            },
            {
                "icon": "🇼🇫",
                "name": "瓦利斯和富圖納旗幟 Flag of Wallis &amp; Futuna",
                "className": "emoji1f1fc-1f1eb"
            },
            {
                "icon": "🇪🇭",
                "name": "西撒哈拉旗幟 Flag of Western Sahara",
                "className": "emoji1f1ea-1f1ed"
            },
            {
                "icon": "🇾🇪",
                "name": "葉門旗幟 Flag of Yemen",
                "className": "emoji1f1fe-1f1ea"
            },
            {
                "icon": "🇿🇲",
                "name": "尚比亞旗幟 Flag of Zambia",
                "className": "emoji1f1ff-1f1f2"
            },
            {
                "icon": "🇿🇼",
                "name": "辛巴威旗幟 Flag of Zimbabwe",
                "className": "emoji1f1ff-1f1fc"
            }
        ]
    }
]